import type {Vsop87Element, Vsop87Group} from '@app/types/Vsop87Types';

const VSOP87_L0: Vsop87Element = [
    [5.48129294299],
    [0.09260408252, 0.8910642153, 74.7815985673],
    [0.01504247826, 3.62719262195, 1.4844727083],
    [0.00365981718, 1.89962189068, 73.297125859],
    [0.00272328132, 3.35823710524, 149.5631971346],
    [0.00070328499, 5.39254431993, 63.7358983034],
    [0.00068892609, 6.09292489045, 76.2660712756],
    [0.00061998592, 2.26952040469, 2.9689454166],
    [0.00061950714, 2.85098907565, 11.0457002639],
    [0.00026468869, 3.14152087888, 71.8126531507],
    [0.00025710505, 6.11379842935, 454.9093665273],
    [0.00021078897, 4.36059465144, 148.0787244263],
    [0.00017818665, 1.74436982544, 36.6485629295],
    [0.00014613471, 4.73732047977, 3.9321532631],
    [0.00011162535, 5.82681993692, 224.3447957019],
    [0.00010997934, 0.48865493179, 138.5174968707],
    [0.00009527487, 2.95516893093, 35.1640902212],
    [0.00007545543, 5.23626440666, 109.9456887885],
    [0.0000422017, 3.23328535514, 70.8494453042],
    [0.0000405185, 2.27754158724, 151.0476698429],
    [0.00003354607, 1.06549008887, 4.4534181249],
    [0.00002926671, 4.62903695486, 9.5612275556],
    [0.00003490352, 5.48305567292, 146.594251718],
    [0.00003144093, 4.75199307603, 77.7505439839],
    [0.0000292241, 5.3523674338, 85.8272988312],
    [0.0000227279, 4.36600802756, 70.3281804424],
    [0.00002051209, 1.51773563459, 0.1118745846],
    [0.00002148599, 0.60745800902, 38.1330356378],
    [0.00001991726, 4.92437290826, 277.0349937414],
    [0.00001376208, 2.04281409054, 65.2203710117],
    [0.0000166691, 3.62744580852, 380.12776796],
    [0.00001284183, 3.11346336879, 202.2533951741],
    [0.00001150416, 0.93344454002, 3.1813937377],
    [0.00001533223, 2.58593414266, 52.6901980395],
    [0.00001281641, 0.54269869505, 222.8603229936],
    [0.000013721, 4.19641615561, 111.4301614968],
    [0.00001220998, 0.19901396193, 108.4612160802],
    [0.00000946195, 1.19249463066, 127.4717966068],
    [0.00001150993, 4.17898207045, 33.6796175129],
    [0.00001244342, 0.91612680579, 2.4476805548],
    [0.00001072008, 0.23564502877, 62.2514255951],
    [0.00001090461, 1.77501638912, 12.5301729722],
    [0.00000707875, 5.18285226584, 213.299095438],
    [0.00000653401, 0.96586909116, 78.7137518304],
    [0.00000627562, 0.18210181975, 984.6003316219],
    [0.00000524495, 2.01276706996, 299.1263942692],
    [0.0000055937, 3.35776737704, 0.5212648618],
    [0.00000606827, 5.43209728952, 529.6909650946],
    [0.00000404891, 5.98689011389, 8.0767548473],
    [0.00000467211, 0.41484068933, 145.1097790097],
    [0.00000471288, 1.40664336447, 184.7272873558],
    [0.00000483219, 2.10553990154, 0.9632078465],
    [0.00000395614, 5.87039580949, 351.8165923087],
    [0.00000433532, 5.52142978255, 183.2428146475],
    [0.00000309885, 5.83301304674, 145.6310438715],
    [0.00000378609, 2.34975805006, 56.6223513026],
    [0.00000398996, 0.33810765436, 415.5524906121],
    [0.00000300379, 5.64353974146, 22.0914005278],
    [0.00000249229, 4.74617120584, 225.8292684102],
    [0.00000239334, 2.35045874708, 137.0330241624],
    [0.00000294172, 5.83916826225, 39.6175083461],
    [0.0000021648, 4.77847481363, 340.7708920448],
    [0.00000251792, 1.63696775578, 221.3758502853],
    [0.00000219621, 1.92212987979, 67.6680515665],
    [0.00000201963, 1.29693040865, 0.0481841098],
    [0.00000224097, 0.51574863468, 84.3428261229],
    [0.00000216549, 6.14211862702, 5.9378908332],
    [0.00000222588, 2.84309380331, 0.2606324309],
    [0.00000207828, 5.5802057004, 68.8437077341],
    [0.00000187474, 1.31924326253, 0.1600586944],
    [0.00000158028, 0.73811997211, 54.1746707478],
    [0.00000199146, 0.9563415501, 152.5321425512],
    [0.00000168648, 5.87874000882, 18.1592472647],
    [0.000001703, 3.67717520688, 5.4166259714],
    [0.00000193652, 1.88800122606, 456.3938392356],
    [0.00000192998, 0.91616058506, 453.424893819],
    [0.00000181934, 3.53624029238, 79.2350166922],
    [0.00000173145, 1.53860728054, 160.6088973985],
    [0.00000164588, 1.42379714838, 106.9767433719],
    [0.00000171968, 5.67952685533, 219.891377577],
    [0.00000162792, 3.05029377666, 112.9146342051],
    [0.00000146653, 1.26300172265, 59.8037450403],
    [0.00000139453, 5.385977234, 32.1951448046],
    [0.00000138585, 4.25994786673, 909.8187330546],
    [0.00000143058, 1.29995487555, 35.4247226521],
    [0.0000012384, 1.37359990336, 7.1135470008],
    [0.00000104414, 5.02820888813, 0.7507595254],
    [0.00000103277, 0.68095301267, 14.977853527],
    [0.00000094741, 0.90674090409, 74.6697239827],
    [0.00000082978, 2.92828718445, 265.9892934775],
    [0.00000110163, 2.02685778976, 554.0699874828],
    [0.00000094226, 3.9426632826, 74.8934731519],
    [0.00000079858, 1.0144682918, 6.592282139],
    [0.00000109376, 5.70581833286, 77.962992305],
    [0.00000085876, 1.70649435603, 82.8583534146],
    [0.00000103562, 1.45770270246, 24.3790223882],
    [0.00000074667, 4.63177552576, 69.3649725959],
    [0.00000079919, 3.00974084247, 297.6419215609],
    [0.00000084502, 0.36887189574, 186.2117600641],
    [0.0000008881, 0.52481330563, 181.7583419392],
    [0.00000070303, 1.18986880009, 66.70484372],
    [0.00000069965, 0.87476081875, 305.3461693927],
    [0.00000069927, 3.76102749315, 131.4039498699],
    [0.00000084604, 5.88725183325, 256.5399405065],
    [0.00000074341, 6.24271323846, 447.7958195265],
    [0.0000006231, 0.16901376623, 479.2883889155],
    [0.00000072726, 2.84892775693, 462.0229135281],
    [0.0000006906, 4.43934854374, 39.3568759152],
    [0.00000076568, 4.5872111034, 6.2197751235],
    [0.00000073387, 4.27603448634, 87.3117715395],
    [0.00000055307, 1.49636544147, 71.6002048296],
    [0.00000057291, 1.63015165542, 143.6253063014],
    [0.00000061661, 3.18604743524, 77.2292791221],
    [0.00000057634, 3.67180685401, 51.2057253312],
    [0.00000050289, 1.12279384633, 20.6069278195],
    [0.00000053744, 5.51890986247, 128.9562693151],
    [0.00000057894, 2.66877593418, 381.6122406683],
    [0.00000058112, 1.58629352171, 60.7669528868],
    [0.00000045382, 0.48053933052, 14.0146456805],
    [0.00000037581, 6.06822931932, 211.8146227297],
    [0.0000003864, 3.43597050177, 153.4953503977],
    [0.00000046087, 4.36201639577, 75.7448064138],
    [0.00000040088, 4.57333927519, 46.2097904851],
    [0.00000034229, 2.93967782207, 140.001969579],
    [0.00000038669, 5.58941074168, 99.1606209555],
    [0.00000034827, 1.02792863024, 203.7378678824],
    [0.00000040024, 0.69889667397, 218.4069048687],
    [0.00000032538, 4.21625657443, 200.7689224658],
    [0.00000031865, 5.50961503408, 72.3339180125],
    [0.00000041695, 3.82438031124, 81.0013736908],
    [0.00000034795, 0.39363490236, 1.3725981237],
    [0.00000039775, 6.05600836903, 293.188503436],
    [0.00000027577, 2.18261286374, 125.9873238985],
    [0.00000036279, 1.66586085405, 258.0244132148],
    [0.00000035442, 1.96652806541, 835.0371344873],
    [0.00000035361, 3.7225869003, 692.5874843535],
    [0.00000027323, 2.10164372072, 209.3669421749],
    [0.0000002653, 4.48265986115, 373.9079928365],
    [0.00000034472, 1.07907945481, 191.2076949102],
    [0.00000029915, 3.87358632506, 259.5088859231],
    [0.00000026233, 3.63172504384, 490.3340891794],
    [0.00000025848, 0.54461409359, 41.6444977756],
    [0.00000026989, 6.27711247734, 28.5718080822],
    [0.00000026391, 5.81110061049, 75.3028634291],
    [0.00000034227, 6.05617272657, 275.5505210331],
    [0.00000024279, 3.18776564878, 81.3738807063],
    [0.00000029937, 1.88789751816, 269.9214467406],
    [0.00000026235, 6.20105251336, 134.5853436076],
    [0.00000022754, 0.92919725789, 288.0806940053],
    [0.0000002518, 5.42547381962, 116.4260963429],
    [0.00000022715, 0.53098783687, 1514.2912967165],
    [0.00000026485, 4.77176167929, 284.1485407422],
    [0.00000027008, 4.75281624832, 41.1019810544],
    [0.00000021972, 4.58613057386, 404.5067903482],
    [0.00000022012, 1.84389287183, 617.8058857862],
    [0.00000024694, 4.7087519549, 378.6432952517],
    [0.00000028949, 0.17127584792, 528.2064923863],
    [0.00000020492, 0.10285646641, 195.1398481733],
    [0.00000020696, 5.62143477633, 55.6591434561],
    [0.00000025843, 0.74627159338, 278.5194664497],
    [0.0000002299, 3.58378694661, 1.5963472929],
    [0.00000021843, 0.05733533568, 173.9422195228],
    [0.0000001905, 2.30351091243, 5.1078094307],
    [0.00000020675, 2.64113858585, 105.4922706636],
    [0.00000021856, 5.87352402691, 45.5766510387],
    [0.0000002112, 1.98081790016, 114.3991069134],
    [0.00000019279, 2.84304025179, 159.1244246902],
    [0.00000019061, 0.50598371738, 67.3592350258],
    [0.00000020434, 3.77601951414, 135.5485514541],
    [0.00000017326, 4.47793157645, 120.358249606],
    [0.00000020547, 0.88695598555, 255.0554677982],
    [0.0000001932, 1.48569290504, 0.8937718773],
    [0.00000021331, 2.7447002306, 28.3111756513],
    [0.00000017582, 4.091396367, 296.1574488526],
    [0.00000015918, 3.94525074972, 17.5261078183],
    [0.00000015562, 0.92748407689, 300.6108669775],
    [0.00000016439, 0.30868798605, 30.7106720963],
    [0.00000015237, 4.93048601827, 7.4223635415],
    [0.00000019284, 6.21950083268, 329.8370663655],
    [0.0000001386, 0.56255266406, 144.1465711632],
    [0.00000016206, 2.30292598693, 344.7030453079],
    [0.00000016041, 0.19723295436, 103.0927742186],
    [0.00000014414, 2.57606243208, 230.5645708254],
    [0.00000016789, 4.93540052916, 565.1156877467],
    [0.00000017052, 1.81844925116, 294.6729761443],
    [0.00000016766, 0.2754218633, 73.8183907208],
    [0.00000015428, 1.91577056305, 96.8729990951],
    [0.00000015718, 3.87095025861, 98.8999885246],
    [0.00000011923, 6.17545505441, 44.7253177768],
    [0.00000012407, 6.22419970167, 80.1982245387],
    [0.0000001304, 1.99652993223, 27.0873353739],
    [0.00000013229, 3.43782440072, 227.3137411185],
    [0.00000011669, 4.31526860843, 426.598190876],
    [0.00000014378, 5.78353646474, 1059.3819301892],
    [0.00000015879, 0.98454960055, 6208.2942514241],
    [0.00000011158, 1.7441743069, 220.4126424388],
    [0.00000011989, 5.8438865795, 13.3333221243],
    [0.00000011386, 2.55925734515, 19.1224551112],
    [0.00000013281, 5.39472153462, 391.1734682239],
    [0.00000012295, 4.57340278496, 23.5758732361],
    [0.00000012827, 1.7741026907, 180.2738692309],
    [0.00000011651, 4.29138607818, 142.4496501338],
    [0.00000012248, 2.44241346243, 100.3844612329],
    [0.00000012421, 2.32591770919, 80.7194894005],
    [0.00000009774, 0.39898140151, 7.8643065262],
    [0.00000013172, 2.74099358938, 177.8743727859],
    [0.00000012262, 5.42795591646, 831.1049812242],
    [0.00000010272, 5.90194483926, 74.5209661364],
    [0.00000009317, 3.75869700774, 74.8297826771],
    [0.00000010701, 4.00709797731, 235.3904959658],
    [0.00000009243, 5.38492199672, 20.4468691251],
    [0.00000009461, 2.60126707172, 92.3077063856],
    [0.00000012066, 5.5216310022, 74.2603337055],
    [0.00000010836, 1.88393779293, 241.6102710893],
    [0.00000009317, 1.1648365831, 74.7334144575],
    [0.00000010718, 5.50310449842, 187.6962327724],
    [0.00000012057, 6.0212005039, 154.0166152595],
    [0.00000009124, 1.15458738606, 0.6331394464],
    [0.00000011526, 6.26425302826, 155.7829722581],
    [0.000000122, 5.79400179483, 1364.7280995819],
    [0.00000010979, 5.76614513865, 628.8515860501],
    [0.00000008532, 5.1801645615, 1.6445314027],
    [0.0000000866, 3.78133822411, 74.9416572617],
    [0.00000011227, 1.30788626675, 604.4725636619],
    [0.00000010531, 1.05867421534, 291.7040307277],
    [0.00000008446, 3.52020067595, 756.3233826569],
    [0.00000010291, 5.30493908317, 75.0422309982],
    [0.00000008015, 6.24347048958, 543.0242872189],
    [0.00000007796, 5.23497582886, 58.1068240109],
    [0.0000000931, 1.65210713729, 24.1183899573],
    [0.00000008642, 1.14285691458, 74.6215398729],
    [0.00000007797, 4.00208030502, 31.492569389],
    [0.00000008915, 3.63129389881, 408.4389436113],
    [0.00000007191, 4.24536221306, 110.2063212194],
    [0.00000009764, 0.10205649809, 366.485629295],
    [0.0000000871, 2.2591075948, 451.9404211107],
    [0.0000000943, 2.00492467431, 331.3215390738],
    [0.00000009008, 1.63146330622, 443.8636662634],
    [0.00000007247, 4.35313018726, 88.1149206916],
    [0.00000007659, 0.61918159043, 50.4025761791],
    [0.00000006836, 5.12190844483, 0.8031491521],
    [0.00000009367, 1.42664537007, 414.0680179038],
    [0.00000008136, 0.45279998999, 25.6028626656],
    [0.00000009199, 2.41000352664, 10138.5039476437],
    [0.00000006896, 5.85017813531, 339.2864193365],
    [0.00000006487, 6.03397141885, 1.2238402774],
    [0.00000007186, 4.00480285222, 157.6399519819],
    [0.0000000813, 0.21907525983, 422.6660376129],
    [0.00000008022, 2.09953974305, 92.940845832],
    [0.00000006371, 4.47820781123, 79.889407998],
    [0.00000007957, 5.86499639179, 760.25553592],
    [0.00000008383, 2.33782809093, 417.0369633204],
    [0.00000007931, 3.41952210669, 7.7042478318],
    [0.00000006613, 1.39197711439, 16.6747745564],
    [0.00000007142, 5.57864813931, 4.7353024152],
    [0.00000007441, 0.48121969777, 68.1893164283],
    [0.00000007187, 0.50441238918, 457.8783119439],
    [0.00000006613, 2.84628770892, 142.1408335931],
    [0.00000006399, 3.88681409308, 74.0308390419],
    [0.0000000614, 1.6577690922, 350.3321196004],
    [0.00000007053, 0.13890020306, 306.830642101],
    [0.0000000601, 5.4643400464, 48.7580447764],
    [0.0000000681, 6.15448079403, 67.8804998876],
    [0.00000005982, 2.36098472874, 2.0057375701],
    [0.00000005709, 1.49928444044, 206.1855484372],
    [0.00000006843, 1.08172913275, 465.9550667912],
    [0.00000006408, 5.07331258075, 4.665866446],
    [0.00000007805, 3.98866710061, 3.6233367224],
    [0.00000005527, 5.57881556653, 2.9207613068],
    [0.00000005521, 3.3822598704, 149.45132255],
    [0.00000006107, 1.95504762856, 216.9224321604],
    [0.00000005692, 2.83076925167, 260.9933586314],
    [0.00000006586, 2.71085048651, 329.7251917809],
    [0.00000005826, 3.98800970226, 347.8844390456],
    [0.00000005745, 0.49160564101, 0.3725070155],
    [0.00000005473, 5.69158856279, 1.6969210294],
    [0.00000004982, 2.40870746521, 342.2553647531],
    [0.0000000604, 4.78944090986, 558.0021407459],
    [0.00000005317, 2.78403764459, 13.4933808187],
    [0.0000000509, 5.47747622578, 372.4235201282],
    [0.00000004894, 1.77082918618, 333.657345044],
    [0.00000005389, 2.94076732149, 9.4011688612],
    [0.00000004757, 5.37129102802, 61.2882177486],
    [0.00000005, 3.43988321744, 518.6452648307],
    [0.00000005664, 3.30309284254, 0.6543913058],
    [0.0000000553, 0.45092393824, 162.0933701068],
    [0.00000005746, 3.45964923866, 55.1378785943],
    [0.00000005666, 1.23578675332, 328.3525936572],
    [0.00000005071, 5.42033080481, 977.4867846211],
    [0.00000005719, 0.66718965817, 92.0470739547],
    [0.00000004994, 1.29267872727, 983.1158589136],
    [0.0000000557, 2.36255927193, 6.9010986797],
    [0.00000005189, 2.40682220291, 58.319272332],
    [0.00000005502, 0.13301359232, 149.6750717192],
    [0.00000004706, 1.85473330365, 119.5069163441],
    [0.00000004305, 4.18171934306, 90.8232336773],
    [0.00000005953, 1.73036741041, 152.7445908723],
    [0.00000005607, 5.53187692339, 1087.6931058405],
    [0.00000005591, 5.75072223569, 358.9301393095],
    [0.00000004441, 0.97726075887, 4.192785694],
    [0.00000004608, 3.31800103668, 89.7594520943],
    [0.00000004677, 5.01422713233, 43.1289704839],
    [0.00000004034, 1.08242564328, 75.5323580927],
    [0.00000005626, 1.10270225604, 66.9172920411],
    [0.00000004058, 1.9401213605, 17.2654753874],
    [0.0000000477, 2.24207019076, 986.0848043302],
    [0.00000005207, 1.3660042891, 767.3690829208],
    [0.0000000494, 0.13733547633, 0.8513332619],
    [0.00000004339, 5.33814728291, 152.0108776894],
    [0.00000003917, 3.85320550575, 2.2876218604],
    [0.00000003903, 5.87573410158, 16.4623262353],
    [0.00000004655, 0.93665017107, 267.4737661858],
    [0.00000004638, 5.42566923517, 16.04163511],
    [0.00000005177, 3.40845690805, 1289.9465010146],
    [0.00000003825, 0.5988810573, 210.3301500214],
    [0.00000005048, 2.16732539242, 367.9701020033],
    [0.00000003819, 1.70901925915, 5.6290742925],
    [0.00000005004, 0.26759264038, 403.1341922245],
    [0.00000004202, 5.12029089394, 19.0105805266],
    [0.00000004472, 2.88978371811, 59.2824801785],
    [0.000000047, 4.17709035394, 130.4407420234],
    [0.00000004487, 0.85521839581, 969.6224780949],
    [0.00000003802, 4.59721371468, 25.8634950965],
    [0.00000004024, 4.98868930941, 30.0562807905],
    [0.00000004722, 6.16359211847, 173.6815870919],
    [0.00000004732, 3.76697693308, 373.0142209592],
    [0.00000003542, 0.76768843819, 114.1384744825],
    [0.0000000337, 2.00021522907, 286.596221297],
    [0.00000003626, 3.20240733896, 991.7138786227],
    [0.00000004028, 0.46802022168, 387.2413149608],
    [0.00000003442, 5.2095973335, 894.8408795276],
    [0.00000003273, 5.46374958434, 192.6921676185],
    [0.00000003291, 3.97847646998, 264.5048207692],
    [0.00000003291, 1.62538722379, 681.5417840896],
    [0.00000003198, 3.965808048, 146.3818033969],
    [0.00000004016, 1.4065746484, 383.0967133766],
    [0.00000003844, 3.60271287642, 0.590700831],
    [0.00000003123, 4.50215520755, 1439.5096981492],
    [0.00000003434, 5.18704419009, 97.4155158163],
    [0.00000003123, 4.14198630214, 76.4785195967],
    [0.00000003259, 1.65410614252, 214.7835681463],
    [0.00000003557, 4.15769848885, 68.5618234438],
    [0.00000002934, 2.95575531139, 120.9913890524],
    [0.00000002914, 3.69930995976, 874.3940104025],
    [0.00000003301, 2.14570582133, 253.5709950899],
    [0.00000003362, 4.82277888708, 19.643719973],
    [0.00000003218, 2.56428709831, 60.5545045657],
    [0.00000003059, 3.57539890234, 117.9105690512],
    [0.00000003073, 3.54739757836, 95.3885263868],
    [0.00000002789, 0.65190913388, 42.5382696529],
    [0.00000003235, 5.31608088666, 546.956440482],
    [0.00000003657, 5.89905956226, 16.1535096946],
    [0.00000003549, 2.76314903735, 82.4858463991],
    [0.00000003627, 4.68663059919, 593.426863398],
    [0.00000003306, 1.57486085317, 312.4597163935],
    [0.00000003602, 2.51921910142, 22.8945496799],
    [0.00000003431, 4.95532928836, 49.7212526229],
    [0.00000002675, 2.41314606353, 29.2049475286],
    [0.00000003101, 1.42849885249, 17.6379824029],
    [0.00000003399, 3.02815712113, 88.7962442478],
    [0.00000003379, 2.65894323745, 771.3012361839],
    [0.00000002547, 6.10642153361, 455.8725743738],
    [0.00000002967, 0.31461418738, 150.5264049811],
    [0.00000002681, 1.16839594153, 477.8039162072],
    [0.00000003343, 3.09880618811, 552.5855147745],
    [0.00000002678, 1.42841144096, 1.1119656928],
    [0.0000000254, 1.94053883528, 6.4804075544],
    [0.00000002491, 2.97226347939, 453.9461586808],
    [0.00000002744, 1.93313970916, 73.1852512744],
    [0.00000002935, 4.5939410628, 167.0893049529],
    [0.00000003007, 1.38745560615, 365.0011565867],
    [0.00000003053, 1.91792962252, 561.1835344836],
    [0.00000002496, 5.45540866674, 66.1835788582],
    [0.00000002622, 1.46324659292, 33.1371007917],
    [0.00000003203, 4.01683757076, 555.5544601911],
    [0.00000002317, 1.13727677715, 43.2408450685],
    [0.00000002341, 5.87635018071, 228.276948965],
    [0.00000002841, 3.60234459541, 42.5864537627],
    [0.00000002858, 1.53714262537, 353.301065017],
    [0.00000002484, 3.85791009894, 104.0077979553],
    [0.00000002903, 5.21967656512, 73.4090004436],
    [0.0000000276, 1.21343315367, 32.2433289144],
    [0.00000002269, 3.31411391807, 4.1446015842],
    [0.00000002241, 2.65636547591, 70.1157321213],
    [0.00000002246, 4.08175081363, 123.5396433437],
    [0.00000002583, 2.38305971478, 100.6450936638],
    [0.00000002761, 5.71758409791, 43.2890291783],
    [0.00000002827, 6.16734582851, 101.8689339412],
    [0.00000002838, 0.5488849549, 20.4950532349],
    [0.00000002145, 4.04195315408, 47.061123747],
    [0.0000000281, 1.90169260186, 273.1028404783],
    [0.00000002922, 2.79808700183, 418.2608035978],
    [0.0000000207, 5.5040271829, 47.6942631934],
    [0.00000002071, 2.0197357306, 316.3918696566],
    [0.0000000252, 3.12740527423, 905.8865797915],
    [0.0000000217, 4.4619656005, 2.7083129857],
    [0.00000002399, 3.78849518316, 75.5847477194],
    [0.00000002746, 4.82558024832, 6.8529145699],
    [0.00000002717, 2.33108458294, 404.6186649328],
    [0.00000002416, 4.11932546205, 332.8060117821],
    [0.00000001974, 5.79881978458, 11.1575748485],
    [0.00000001967, 5.43918682709, 199.2844497575],
    [0.00000002282, 2.79530897096, 22.633917249],
    [0.0000000191, 0.27727117649, 69.1525242748],
    [0.00000002471, 3.51033894778, 8.5980197091],
    [0.00000001904, 3.45282024423, 472.1748419147],
    [0.00000002606, 0.43601023323, 439.782755154],
    [0.00000002663, 5.43112910549, 3265.8308281325],
    [0.00000002058, 1.69362390174, 65.8747623175],
    [0.00000002258, 5.32927779367, 908.3342603463],
    [0.00000001873, 5.5539980591, 175.1660598002],
    [0.00000002222, 0.96973865202, 39.0962434843],
    [0.00000002121, 2.00302088316, 106.0135355254],
    [0.0000000201, 1.49945418027, 29.226199388],
    [0.00000002222, 4.36573603431, 468.2426886516],
    [0.00000002055, 0.05798973044, 205.2223405907],
    [0.00000002086, 0.44287700052, 10.2949407385],
    [0.0000000177, 4.3204880583, 0.457574387],
    [0.00000002112, 5.78682409103, 486.4019359163],
    [0.00000001909, 0.82888506421, 254.9435932136],
    [0.00000001973, 6.05826379648, 78.4049352897],
    [0.00000001908, 5.55892482384, 15.4991183888],
    [0.00000001888, 6.20874408008, 198.321241911],
    [0.00000002092, 2.55561831566, 49.5088043018],
    [0.00000001775, 6.17741514589, 258.8757464767],
    [0.00000002146, 1.4050811881, 526.722019678],
    [0.000000018, 0.04238718337, 334.2904844904],
    [0.00000001738, 1.99152421966, 77.0692204277],
    [0.00000001641, 3.36410541913, 118.0224436358],
    [0.00000002084, 5.21275540105, 134.0640787458],
    [0.00000001861, 2.97480744198, 178.7893965226],
    [0.0000000175, 2.01731567093, 142.6620984549],
    [0.000000016, 1.60963172329, 40.1600250673],
    [0.00000001668, 1.53361997245, 0.8300814025],
    [0.00000001769, 4.72689497119, 32.7164096664],
    [0.00000001782, 2.60469159465, 166.828672522],
    [0.00000001765, 5.57583636983, 522.5774180938],
    [0.00000001877, 1.09044005603, 274.0660483248],
    [0.00000001544, 1.9179841914, 303.8616966844],
    [0.00000001532, 3.44973397383, 124.5028511902],
    [0.00000001658, 5.23946791059, 233.9060232575],
    [0.00000001743, 2.32369273283, 290.2195580194],
    [0.00000001528, 0.62020771152, 1033.3583763983],
    [0.00000001522, 6.11272567668, 165.6048322446],
    [0.00000001496, 2.02190170195, 150.0844619964],
    [0.0000000149, 3.30997217921, 820.0592809603],
    [0.00000001398, 3.41567259878, 4.9959348461],
    [0.00000001886, 6.25585539882, 162.8965192589],
    [0.00000001388, 0.62745508416, 448.6895914038],
    [0.00000001918, 0.91483173263, 1819.6374661092],
    [0.00000001682, 2.11545135265, 189.7232222019],
    [0.00000001711, 2.55731536599, 1108.1399749656],
    [0.00000001598, 0.89607036108, 115.8835796217],
    [0.00000001477, 0.22838214106, 370.9390474199],
    [0.00000001727, 1.54005322759, 401.6497195162],
    [0.00000001432, 3.73381952953, 8.9068362498],
    [0.00000001338, 0.19338311739, 81.8951455681],
    [0.00000001618, 6.02595306259, 31.2319369581],
    [0.00000001452, 0.11827434627, 72.7758609972],
    [0.00000001626, 4.26332651029, 369.4545747116],
    [0.00000001284, 3.18389639039, 362.8622925726],
    [0.00000001755, 5.57436830525, 344.9636777388],
    [0.00000001451, 4.4261538175, 189.1807054807],
    [0.00000001294, 2.77775613125, 63.6240237188],
    [0.00000001712, 2.16785817753, 536.8045120954],
    [0.00000001266, 2.78408709208, 55.7710180407],
    [0.000000017, 2.49908604932, 441.2672278623],
    [0.00000001645, 2.41257585783, 10.0824924174],
    [0.00000001666, 5.00664377609, 79.5169009825],
    [0.00000001674, 0.00394784675, 491.5579294568],
    [0.00000001334, 5.62972572008, 129.9194771616],
    [0.00000001328, 0.2560613584, 114.9416236346],
    [0.00000001176, 1.63208422172, 84.1827674285],
    [0.00000001177, 4.10449248614, 103.3534066495],
    [0.00000001384, 5.7300452987, 89.338760969],
    [0.00000001287, 0.99537181009, 14.6690369863],
    [0.00000001171, 5.98078310685, 57.1436161644],
    [0.00000001126, 3.39586759408, 375.3924655448],
    [0.00000001406, 5.18477940039, 113.8778420516],
    [0.00000001397, 1.49751443233, 14.2270940016],
    [0.00000001206, 3.60301196272, 480.7728616238],
    [0.00000001113, 4.80418427391, 9.449352971],
    [0.00000001434, 1.57158177893, 419.7452763061],
    [0.00000001473, 1.03881736383, 1215.1649024473],
    [0.00000001311, 2.99704179684, 458.8415197904],
    [0.00000001453, 6.10676427884, 64.6991061499],
    [0.0000000107, 3.16542344402, 54.3347294422],
    [0.00000001389, 2.78512263875, 26.0235537909],
    [0.00000001203, 0.20627563214, 0.5694489716],
    [0.00000001343, 5.58004577468, 95.2284676924],
    [0.00000001062, 2.40616687148, 154.979823106],
    [0.00000001399, 1.66776602336, 240.3864308119],
    [0.00000001036, 5.53891715915, 403.0223176399],
    [0.00000001269, 2.3768452729, 37.8724032069],
    [0.00000001197, 4.87553746725, 1044.4040766622],
    [0.00000001009, 2.7461946296, 80.4106728598],
    [0.0000000133, 0.99603813295, 483.2205421786],
    [0.00000001348, 0.58829539202, 476.4313180835],
    [0.00000000989, 3.31666847329, 18.9100067901],
    [0.00000001054, 2.85972567059, 616.3214130779],
    [0.00000001276, 4.72938141859, 691.1030116452],
    [0.00000001219, 3.6290968922, 106.2741679563],
    [0.00000001269, 1.53301050628, 280.9671470045],
    [0.00000000968, 2.73688433893, 218.9281697305],
    [0.0000000133, 5.69234088687, 694.0719570618],
    [0.00000001121, 2.8054243979, 148.5999892881],
    [0.0000000098, 6.04026702553, 5.4690155981],
    [0.00000001235, 0.61136787453, 237.6781178262],
    [0.00000001161, 5.3220902482, 369.0820676961],
    [0.00000000944, 1.14261861393, 384.0599212231],
    [0.00000001017, 2.49896409345, 147.1155165798],
    [0.00000001082, 2.46236323548, 326.8681209489],
    [0.00000001037, 5.92126063748, 4.8259251404],
    [0.00000001232, 5.83725190224, 63.847772888],
    [0.00000000914, 0.36627060914, 10.9338256793],
    [0.00000001165, 5.32140830393, 308.3151148093],
    [0.00000000952, 4.78982033367, 93.9040536785],
    [0.00000000993, 3.39918521663, 10.785067833],
    [0.00000001206, 3.6453050053, 699.7010313543],
    [0.00000000893, 2.97140509591, 248.4631856592],
    [0.00000000883, 2.85605198817, 15.1903018481],
    [0.00000000875, 3.4392570928, 3.0808200012],
    [0.00000001103, 4.80576195766, 6133.5126528568],
    [0.00000001178, 6.01576659565, 377.1588225434],
    [0.00000000974, 2.51206761828, 121.8427223143],
    [0.00000000865, 5.68958102479, 141.6988906084],
    [0.00000000974, 3.15729174941, 215.4379594521],
    [0.00000000847, 0.84854843713, 2043.9822618111],
    [0.00000000961, 0.22181374419, 0.9150237367],
    [0.00000001167, 2.37544946421, 33.9402499438],
    [0.00000001013, 3.43778868786, 36.9091953604],
    [0.00000000838, 1.63355479706, 2.3358059702],
    [0.00000001113, 2.5098969497, 405.9912630565],
    [0.00000000987, 1.14030030863, 82.2039621088],
    [0.0000000106, 1.70915765427, 438.2982824457],
    [0.00000000829, 2.97491446672, 62.7726904569],
    [0.00000000991, 4.44869793177, 406.1031376411],
    [0.00000000952, 6.13897716036, 184.9879197867],
    [0.00000001033, 4.19932839584, 141.4864422873],
    [0.00000001029, 5.13205530996, 157.2674449664],
    [0.00000000805, 3.11000318272, 93.7921790939],
    [0.00000000865, 4.44578048207, 295.1942410061],
    [0.00000000921, 4.88190545687, 12.0089081104],
    [0.00000000949, 5.99910796869, 606.7601855223],
    [0.00000000991, 1.68012021428, 40.5807161926],
    [0.00000000854, 0.37823682862, 217.2312487011],
    [0.00000000883, 2.3622438514, 3.7720945687],
    [0.00000001016, 3.90745585959, 194.2885149114],
    [0.00000000807, 5.93051451738, 302.0953396858],
    [0.00000000879, 0.52695940866, 1057.8974574809],
    [0.00000001009, 1.19621149495, 490.0734567485],
    [0.00000000801, 4.96724351781, 661.0949149645],
    [0.00000000843, 0.97496000705, 73.88782669],
    [0.00000001028, 2.65189503651, 477.9157907918],
    [0.00000000846, 3.3634373396, 40.8413486235],
    [0.00000000772, 4.93551925711, 425.1137181677],
    [0.00000000781, 0.59382881638, 97.6761482472],
    [0.0000000077, 4.25621058806, 488.8496164711],
    [0.00000000935, 1.24971148781, 624.919432787],
    [0.00000000984, 4.44298060183, 171.6545976624],
    [0.00000000806, 0.09410536829, 440.6822725257],
    [0.00000000769, 4.09296452529, 140.6563608848],
    [0.00000000802, 0.78515729603, 11.848849416],
    [0.00000001007, 4.06909438635, 76.154196691],
    [0.00000000935, 0.03808890956, 156.1554792736],
    [0.00000000712, 5.35549696452, 610.6923387854],
    [0.00000000911, 4.70177653335, 81.682697247],
    [0.00000000926, 3.09765550633, 833.552661779],
    [0.00000000812, 3.54377377085, 149.4031384402],
    [0.00000000801, 5.48034970408, 21.9795259432],
    [0.000000009, 4.2173934702, 778.4147831847],
    [0.00000000689, 2.56862945159, 109.3125493421],
    [0.00000000685, 3.1996582898, 31.6526280834],
    [0.00000000952, 4.8257997882, 1744.8558675419],
    [0.00000000724, 2.16878848875, 1171.875873269],
    [0.00000000897, 3.94746491183, 75.6753704446],
    [0.00000000739, 5.45802693622, 252.6559713532],
    [0.00000000821, 4.26046087515, 1246.6574718363],
    [0.00000000663, 5.83767831921, 86.6304479833],
    [0.00000000664, 1.72432848951, 216.4804891757],
    [0.00000000721, 3.98089320988, 902.7051860538],
    [0.00000000663, 4.98388191647, 958.576777831],
    [0.0000000075, 2.66119349235, 363.5166838784],
    [0.00000000828, 3.62849315181, 14.8177948326],
    [0.00000000663, 3.23521229496, 207.8824694666],
    [0.00000000681, 3.29667467046, 25.0603459444],
    [0.00000000887, 4.81199147907, 155.5010879678],
    [0.00000000646, 2.65129054432, 685.4739373527],
    [0.00000000808, 5.68764955594, 280.003939158],
    [0.00000000619, 1.32296886424, 193.655375465],
    [0.00000000621, 2.57837200005, 703.6331846174],
    [0.00000000854, 3.63173686962, 411.620337349],
    [0.00000000728, 1.05845783695, 916.9322800554],
    [0.00000000733, 0.75817076935, 44.0921783304],
    [0.00000000629, 1.52747752455, 397.3932433474],
    [0.00000000599, 5.30671888409, 180.1619946463],
    [0.00000000615, 5.68908944293, 25.2727942655],
    [0.00000000709, 0.64922689354, 14.5571624017],
    [0.00000000729, 4.79389069212, 479.4002635001],
    [0.00000000667, 1.98320895029, 37.611770776],
    [0.00000000586, 1.51157853976, 668.2084619653],
    [0.00000000639, 1.69085181319, 262.4778313397],
    [0.00000000616, 4.62035066985, 12.2695405413],
    [0.00000000687, 2.24368916079, 228.7982138268],
    [0.00000000599, 2.08317681783, 149.3025647037],
    [0.00000000597, 3.14660293947, 137.5542890242],
    [0.00000000581, 2.69049614736, 823.9914342234],
    [0.00000000709, 4.38514100216, 184.0941479094],
    [0.00000000671, 3.46925958949, 105.380396079],
    [0.00000000619, 2.91325544152, 236.8749686741],
    [0.00000000558, 2.9617719488, 34.2008823747],
    [0.00000000648, 5.56457931302, 140.9651774255],
    [0.00000000581, 0.55427680962, 331.2096644892],
    [0.00000000585, 0.15548306049, 232.4215505492],
    [0.00000000548, 3.57525860446, 497.4476361802],
    [0.00000000574, 5.60908001848, 118.8737768977],
    [0.00000000702, 1.74156189506, 149.0419322728],
    [0.00000000543, 0.49890445043, 133.1008708993],
    [0.00000000716, 3.04149734724, 131.9252147317],
    [0.00000000544, 6.22369103738, 149.6113812444],
    [0.00000000539, 0.74276113752, 911.3032057629],
    [0.00000000614, 5.83710659138, 181.0557665236],
    [0.00000000601, 0.30768922616, 407.5876103494],
    [0.00000000635, 4.03476459045, 136.0698163159],
    [0.00000000526, 5.42874995984, 450.9772132642],
    [0.00000000547, 3.07676037032, 204.7010757289],
    [0.00000000622, 3.08666523105, 268.4369740323],
    [0.00000000537, 4.25467814241, 217.4436970222],
    [0.00000000566, 4.84686444604, 842.1506814881],
    [0.00000000636, 2.57425168783, 621.7380390493],
    [0.00000000623, 5.84341335807, 52.8020726241],
    [0.00000000544, 3.629830065, 149.5150130248],
    [0.00000000578, 0.34796271917, 139.4807047172],
    [0.00000000537, 5.99181083831, 246.9787129509],
    [0.00000000674, 2.57972741298, 602.9880909536],
    [0.00000000539, 6.1966296161, 696.5196376166],
    [0.00000000516, 2.19916575703, 458.090760265],
    [0.00000000632, 5.2665855364, 67.0773507355],
    [0.00000000581, 0.05320320337, 95.931043108],
    [0.00000000504, 6.24600928623, 149.723255829],
    [0.00000000638, 6.23121553223, 10063.7223490764],
    [0.00000000528, 0.20662780149, 310.1720945331],
    [0.00000000537, 2.96207822442, 73.1370671646],
    [0.00000000508, 5.29969144068, 335.7749571987],
    [0.00000000487, 2.83772541949, 143.9341228421],
    [0.00000000537, 3.36808372143, 252.0865223816],
    [0.00000000632, 5.88494938125, 920.8644333185],
    [0.00000000523, 6.13183488285, 1589.0728952838],
    [0.00000000579, 0.04597861846, 563.6312150384],
    [0.00000000613, 0.34938781762, 343.4792050305],
    [0.00000000495, 2.8921249981, 61.448276443],
    [0.00000000623, 0.71740350315, 513.079881013],
    [0.00000000498, 2.53375871592, 41.7563723602],
    [0.00000000564, 2.01612524784, 449.2802922348],
    [0.0000000048, 0.10535023009, 69.6737891366],
    [0.00000000494, 3.25187012728, 428.0826635843],
    [0.00000000536, 5.81149025999, 282.6640680339],
    [0.00000000468, 0.89483830828, 541.5398145106],
    [0.00000000533, 2.44239677121, 393.4610900843],
    [0.00000000589, 6.24067076234, 29.7956483596],
    [0.00000000465, 0.2500674371, 57.255490749],
    [0.00000000622, 3.89339038121, 416.7763308895],
    [0.00000000519, 2.72375973888, 469.1364605289],
    [0.00000000498, 1.76422801185, 380.3884003909],
    [0.00000000596, 0.83642843095, 98.3574718034],
    [0.00000000459, 0.39052216206, 197.7999770492],
    [0.00000000574, 2.86366933069, 170.7608257851],
    [0.00000000518, 3.38058345605, 535.9107402181],
    [0.00000000564, 1.20395155832, 832.5894539325],
    [0.00000000556, 4.39974034374, 196.6243208816],
    [0.00000000537, 3.9363706494, 460.5384408198],
    [0.00000000482, 2.4156214883, 827.9235874865],
    [0.00000000578, 2.39644032176, 1670.0742689746],
    [0.00000000475, 4.19223519775, 271.4059194489],
    [0.00000000452, 3.9914625148, 135.336103133],
    [0.00000000514, 6.11377193423, 1894.4190646765],
    [0.00000000531, 3.45607724228, 450.4559484024],
    [0.00000000492, 5.87591888758, 170.1701249541],
    [0.00000000588, 2.66953705406, 310.9752436852],
    [0.00000000564, 1.0449111737, 446.3113468182],
    [0.0000000044, 5.85084571537, 224.2329211173],
    [0.00000000441, 2.19799439287, 119.3950417595],
    [0.00000000549, 6.05651523611, 76.3779458602],
    [0.00000000573, 2.2989852675, 122.4758617607],
    [0.00000000473, 4.61187869812, 291.262087743],
    [0.00000000553, 4.90464199013, 463.5073862364],
    [0.00000000599, 1.48666209087, 149.8238295655],
    [0.00000000499, 3.72896978991, 853.196381752],
    [0.0000000044, 5.05024690419, 79.4474650133],
    [0.00000000558, 0.42332722744, 283.6272758804],
    [0.00000000458, 4.49655973916, 754.8389099486],
    [0.00000000449, 1.32861330901, 308.6876218248],
    [0.00000000565, 0.45628024105, 241.8709035202],
    [0.0000000051, 3.70202346104, 452.4616859725],
    [0.00000000404, 0.1233582124, 1097.0942747017],
    [0.00000000409, 4.02092464698, 735.8765135318],
    [0.00000000464, 3.82915608692, 1094.5460204104],
    [0.00000000439, 2.72266354653, 376.1956146969],
    [0.00000000478, 0.23380952322, 1182.9215735329],
    [0.00000000412, 1.21971515436, 419.4846438752],
    [0.00000000546, 0.22296640745, 829.6205085159],
    [0.0000000051, 2.69499052512, 412.5835451955],
    [0.00000000409, 2.51935747849, 409.0720830577],
    [0.00000000451, 0.56137272347, 758.7710632117],
    [0.00000000399, 0.8603731533, 337.8019466282],
    [0.00000000393, 0.402024632, 107.4980082337],
    [0.00000000494, 5.02745190154, 619.2903584945],
    [0.00000000404, 0.08539758465, 18.9623964168],
    [0.00000000504, 4.18251931021, 449.4927405559],
    [0.00000000406, 3.80082989682, 34.5309507748],
    [0.00000000545, 2.80919248176, 514.5643537213],
    [0.0000000039, 1.65941826256, 447.2051186955],
    [0.00000000448, 2.81540452771, 400.1652468079],
    [0.00000000405, 4.86073222353, 1404.0849754971],
    [0.00000000476, 1.61050626902, 54.2865453324],
    [0.00000000406, 1.29798079034, 226.7924762567],
    [0.00000000526, 5.35780726572, 838.218528225],
    [0.00000000403, 2.75405589772, 285.1117485887],
    [0.00000000381, 4.97702366598, 309.2783226558],
    [0.00000000448, 1.37926537411, 745.277682393],
    [0.00000000419, 0.90546724862, 451.7279727896],
    [0.0000000045, 1.92391706975, 474.9468453752],
    [0.00000000474, 5.54351717465, 494.2662424425],
    [0.0000000046, 5.09575399931, 289.5651667136],
    [0.00000000455, 3.1475508733, 168.5737776612],
    [0.00000000372, 4.87645271422, 116.5379709275],
    [0.00000000479, 1.08512503555, 154.2984995498],
    [0.00000000374, 0.16389070181, 1190.7858800591],
    [0.00000000422, 3.51871257208, 706.8145783551],
    [0.00000000354, 4.06405413226, 124.2904028691],
    [0.00000000494, 4.57924296149, 167.7224443993],
    [0.00000000357, 5.78050145791, 1265.5674786264],
    [0.00000000402, 2.6765270326, 464.4705940829],
    [0.0000000037, 2.21677703856, 232.0490435337],
    [0.00000000462, 4.1042430527, 27.7204748203],
    [0.00000000364, 3.0751873248, 442.639825986],
    [0.00000000403, 1.69214233165, 90.2807169561],
    [0.00000000348, 1.16647947937, 357.4456666012],
    [0.00000000443, 1.32306861852, 298.2326223919],
    [0.00000000386, 4.34980428548, 227.5261894396],
    [0.00000000337, 5.92030047826, 445.3481389717],
    [0.00000000356, 2.3882420066, 511.5954083047],
    [0.00000000357, 3.19265737844, 21.1976286505],
    [0.00000000406, 3.72223708907, 3116.2676309979],
    [0.00000000341, 3.05116722794, 15.7810026791],
    [0.00000000379, 4.72472516443, 30.5987975117],
    [0.000000004, 0.71868453904, 836.5216071956],
    [0.0000000037, 0.17259001853, 6531.661656265],
    [0.00000000456, 0.83408547295, 674.8007441043],
    [0.00000000376, 5.91068811321, 1617.3840709351],
    [0.00000000392, 1.90856045571, 25863.55834587229],
    [0.00000000333, 4.77074940789, 76.7873361374],
    [0.00000000332, 0.8569940272, 749.2098356561],
    [0.00000000321, 3.88221470645, 38.6061163898],
    [0.00000000321, 2.59404134515, 1300.9922012785],
    [0.00000000438, 2.60178805278, 224.4566702865],
    [0.00000000371, 3.73501205989, 328.2407190726],
    [0.00000000357, 0.03656571669, 148.8124376092],
    [0.00000000389, 3.06990362181, 1012.9115072732],
    [0.00000000392, 3.14428599675, 125.1841747464],
    [0.00000000326, 2.23565995627, 89.5993933999],
    [0.00000000314, 4.56810921721, 1681.1199692385],
    [0.00000000333, 4.37613329736, 147.9668498417],
    [0.00000000326, 4.15448016748, 21.1494445407],
    [0.00000000371, 4.09066371754, 239.1625905345],
    [0.00000000372, 1.12230345314, 321.7603115182],
    [0.00000000305, 6.12924444546, 19.9737883731],
    [0.00000000407, 3.65906570714, 679.2541622292],
    [0.00000000406, 3.58469900333, 26013.1215430069],
    [0.0000000031, 3.92339533494, 229.0800981171],
    [0.00000000321, 1.35118535306, 172.4577468145],
    [0.00000000332, 3.54513021513, 288.7350853111],
    [0.00000000312, 2.87878773413, 806.725958836],
    [0.00000000372, 1.99953045718, 192.8040422031],
    [0.00000000302, 0.01867543539, 501.3797894433],
    [0.00000000299, 3.9646896095, 20277.0078952874],
    [0.00000000308, 2.66235795286, 248.7238180901],
    [0.00000000298, 3.52867456736, 21.4582610814],
    [0.0000000037, 3.51061046963, 91.4563731237],
    [0.00000000297, 0.79872983355, 742.9900605326],
    [0.00000000414, 4.81163687199, 589.4947101349],
    [0.00000000302, 5.2607933805, 27.5604161259],
    [0.00000000314, 3.14643487607, 361.3778198643],
    [0.00000000356, 4.63707521448, 442.7517005706],
    [0.00000000357, 3.44793069844, 44.6134431922],
    [0.0000000037, 4.25032151516, 304.2342036999],
    [0.00000000366, 5.43115395433, 625.9945152181],
    [0.00000000365, 0.3045449841, 6283.0758499914],
    [0.00000000322, 2.32892248876, 229.4526051326],
    [0.00000000369, 3.28573365074, 104.5290628171],
    [0.00000000327, 2.98588869318, 348.8476468921],
    [0.00000000315, 3.66842071994, 230.9370778409],
    [0.00000000356, 0.90433599977, 29.7474642498],
    [0.00000000384, 0.91820739126, 549.7284439425],
    [0.00000000317, 3.86462587284, 639.897286314],
    [0.00000000333, 4.95319798125, 881.5075574033],
    [0.00000000285, 4.09883967296, 904.1896587621],
    [0.00000000338, 5.65177488491, 195.7729876197],
    [0.00000000365, 0.57418860616, 285.6330134505],
    [0.00000000363, 0.98999016221, 839.7030009333],
    [0.0000000033, 2.26308969695, 49.1787359017],
    [0.00000000335, 2.25619157817, 272.5815756165],
    [0.00000000376, 5.87496858487, 268.9582388941],
    [0.00000000362, 4.94491380965, 572.2292347475],
    [0.0000000032, 5.58342880588, 459.3627846522],
    [0.00000000299, 2.86286938521, 883.7951792637],
    [0.00000000286, 2.49409963193, 156.043604689],
    [0.00000000272, 3.62976505444, 754.0357607965],
    [0.00000000349, 2.34615857088, 6069.7767545534],
    [0.00000000279, 4.04872155075, 180.7951340927],
    [0.00000000328, 1.21350330743, 148.1905990109],
    [0.00000000315, 0.74270298817, 320.2758388099],
    [0.00000000324, 5.54296698387, 1507.1777497157],
    [0.00000000266, 4.36134021576, 1310.3933701397],
    [0.00000000262, 5.84934968714, 450.1740641121],
    [0.0000000028, 5.05848320657, 102.523325247],
    [0.00000000347, 4.7006863962, 282.1428031721],
    [0.00000000342, 5.47365149093, 163.5778428151],
    [0.00000000364, 3.29301824378, 378.9039276826],
    [0.0000000033, 4.63426494882, 341.9947323222],
    [0.00000000259, 2.43682741156, 170.0100662597],
    [0.00000000336, 3.79029047358, 9999.986450773],
    [0.00000000284, 2.52583672467, 266.1011680621],
    [0.00000000281, 3.93593342516, 194.1766403268],
    [0.00000000297, 0.18595848541, 491.8185618877],
    [0.0000000029, 4.49575150721, 151.850818995],
    [0.00000000284, 1.59495665161, 336.8387387817],
    [0.00000000255, 5.85817353877, 229.340730548],
    [0.0000000026, 5.92834225312, 455.0694252217],
    [0.00000000274, 0.53977064975, 380.2396425446],
    [0.00000000259, 3.15728797958, 454.7493078329],
    [0.00000000303, 0.17851964142, 384.5811860849],
    [0.00000000285, 1.29732672572, 25.1297819136],
    [0.00000000273, 4.18776699292, 177.3049238143],
    [0.00000000326, 1.68159391466, 161.7208630913],
    [0.00000000321, 2.36931686576, 2274.5468326365],
    [0.00000000241, 3.57660492473, 150.31395666],
    [0.00000000273, 3.787800994, 380.0158933754],
    [0.00000000265, 3.02540120552, 454.7974919427],
    [0.00000000265, 6.06087280189, 455.0212411119],
    [0.00000000279, 3.82392760479, 31.5407534988],
    [0.00000000273, 2.64820862667, 838.0060799039],
    [0.00000000238, 5.17487170793, 263.0203480609],
    [0.00000000299, 3.94906046599, 531.978586955],
    [0.00000000317, 2.28289083599, 44.070926471],
    [0.0000000025, 1.35950829789, 304.1223291153],
    [0.00000000312, 2.73327875294, 442.3791935551],
    [0.00000000314, 3.86400459047, 734.4557312983],
    [0.00000000251, 0.15148137746, 221.1634019642],
    [0.00000000272, 5.71864670101, 164.5410506616],
    [0.00000000305, 4.96642198943, 1140.38330388],
    [0.00000000282, 5.46073788901, 550.1378342197],
    [0.00000000273, 5.68721459468, 92.4195809702],
    [0.00000000256, 0.8878797087, 418.5214360287],
    [0.00000000229, 5.02021405557, 144.8973306886],
    [0.00000000231, 5.7023675287, 132.8884225782],
    [0.00000000218, 2.0562373618, 303.0585475323],
    [0.000000003, 1.76109447754, 371.5297482509],
    [0.00000000216, 2.97122807313, 176.6505325085],
    [0.00000000224, 3.12798198868, 188.9200730498],
    [0.00000000212, 1.30757526083, 74.1484591209],
    [0.00000000238, 4.65119406609, 385.7568422525],
    [0.00000000216, 0.0708691012, 893.3564068193],
    [0.00000000262, 5.78959872639, 635.9651330509],
    [0.0000000025, 4.47327859711, 551.1010420662],
    [0.00000000222, 1.64692618955, 76.42612997],
    [0.00000000254, 2.61838408005, 525.2375469697],
    [0.00000000284, 4.13290731223, 544.5087599272],
    [0.00000000262, 2.82476092056, 971.1069508032],
    [0.00000000266, 4.1246725861, 375.6743498351],
    [0.00000000212, 3.61675003296, 75.4147380137],
    [0.00000000253, 3.14224867483, 270.1820791715],
    [0.0000000025, 4.32883971376, 346.4481504471],
    [0.00000000273, 1.95676918609, 402.2191684878],
    [0.00000000259, 1.96371242284, 968.1380053866],
    [0.00000000238, 1.29663338057, 421.1815649046],
    [0.00000000243, 5.94961177434, 117.36805233],
    [0.00000000241, 4.70849619029, 406.954470903],
    [0.00000000216, 3.31232425021, 190.665178189],
    [0.00000000201, 1.23733749784, 799.6124118352],
    [0.00000000223, 0.98087204684, 627.3671133418],
    [0.00000000226, 1.66139333004, 1366.2125722902],
    [0.00000000205, 0.3383968395, 143.3434220111],
    [0.0000000024, 0.71559872262, 525.7588118315],
    [0.00000000223, 2.57722930616, 981.6313862053],
    [0.00000000193, 4.48974066435, 172.1971143836],
    [0.00000000221, 2.88670838151, 238.9019581036],
    [0.00000000177, 3.87122035013, 389.6889955156],
    [0.00000000175, 5.85737374379, 170.7126416753],
    [0.00000000233, 0.63169996424, 980.6681783588],
    [0.00000000225, 4.81504648561, 88.274979386],
    [0.0000000021, 2.49819501106, 128.4350044533],
    [0.00000000172, 0.91255921858, 210.8514148832],
    [0.00000000176, 3.85133296117, 605.9570363702],
    [0.00000000211, 1.72999855867, 10213.285546211],
    [0.0000000017, 1.614053401, 1512.8068240082],
    [0.00000000216, 1.54874566441, 1060.8664028975],
    [0.00000000194, 6.07381783144, 520.129737539],
    [0.0000000017, 2.58526747515, 1515.7757694248],
    [0.00000000172, 1.45073604378, 995.6460318858],
    [0.0000000016, 4.20015913513, 433.7117378768],
    [0.00000000219, 1.63985385568, 630.3360587584],
    [0.00000000219, 1.96273394194, 313.6835566709],
    [0.00000000159, 3.62343846627, 73.9784494152],
    [0.00000000206, 0.83764718449, 104.8378793578],
    [0.00000000203, 0.68701289007, 1363.2436268736],
    [0.00000000158, 0.81666479221, 987.5692770385],
    [0.00000000172, 2.97938676702, 327.4375699205],
    [0.00000000147, 2.15517092627, 73.2489417492],
    [0.00000000156, 1.296434692, 216.2680408546],
    [0.00000000153, 3.77492020946, 768.8535556291],
    [0.00000000147, 4.74903152642, 73.3453099688],
    [0.00000000198, 2.80749830888, 225.3080035484],
    [0.00000000179, 0.35410767087, 421.2297490144],
    [0.00000000204, 3.47423038287, 564.8550553158],
    [0.00000000172, 2.8842064282, 233.533516242],
    [0.00000000195, 3.09114364733, 294.3004691288],
    [0.00000000181, 4.75684139861, 71.1582618449],
    [0.0000000016, 3.16134209902, 70.0462961521],
    [0.00000000155, 2.07144269719, 91.2439248026],
    [0.00000000154, 3.37462128317, 138.4056222861],
    [0.00000000192, 6.19629054455, 312.1990839626],
    [0.00000000162, 0.60896273267, 73.0364934281],
    [0.00000000172, 2.01712700688, 973.554631358],
    [0.00000000145, 1.72582731815, 302.3772239761],
    [0.0000000017, 2.97437423989, 3191.0492295652],
    [0.00000000153, 0.11158566352, 138.6293714553],
    [0.00000000164, 5.37129563471, 457.3570470821],
    [0.00000000132, 3.15466226029, 523.4711899711],
    [0.00000000137, 2.88313323946, 765.8846102125],
    [0.00000000128, 1.75773421717, 77.7023598741],
    [0.00000000173, 5.03552846066, 415.2918581812],
    [0.00000000137, 4.77137510538, 73.4571845534],
    [0.00000000163, 0.99316178485, 94.4253185403],
    [0.00000000138, 4.68330115148, 517.1607921224],
    [0.00000000133, 2.95376828791, 75.1541055828],
    [0.00000000134, 1.35779558361, 249.9476583675],
    [0.00000000168, 4.7316454297, 108.7218485111],
    [0.00000000119, 1.48229220689, 237.4174853953],
    [0.00000000134, 1.5227717792, 154.6710065653],
    [0.00000000117, 5.4864227361, 437.6438911399],
    [0.00000000131, 5.76525548944, 75.4359898731],
    [0.00000000127, 2.3830922723, 208.8456773131],
    [0.00000000115, 4.38951350436, 343.2185725996],
    [0.00000000114, 4.48142283161, 224.8660605637],
    [0.00000000117, 5.37802827323, 293.7097682978],
    [0.00000000136, 2.80772094137, 374.4986936675],
];

const VSOP87_L1: Vsop87Element = [
    [75.02543121646],
    [0.00154458244, 5.24201658072, 74.7815985673],
    [0.00024456413, 1.71255705309, 1.4844727083],
    [0.00009257828, 0.42844639064, 11.0457002639],
    [0.00008265977, 1.5022003511, 63.7358983034],
    [0.00007841715, 1.31983607251, 149.5631971346],
    [0.00003899105, 0.46483574024, 3.9321532631],
    [0.00002283777, 4.17367533997, 76.2660712756],
    [0.000019266, 0.53013080152, 2.9689454166],
    [0.00001232727, 1.58634458237, 70.8494453042],
    [0.00000791206, 5.43641224143, 3.1813937377],
    [0.00000766954, 1.99555409575, 73.297125859],
    [0.00000481671, 2.98401996914, 85.8272988312],
    [0.00000449798, 4.13826237508, 138.5174968707],
    [0.000004456, 3.72300400331, 224.3447957019],
    [0.00000426554, 4.73126059388, 71.8126531507],
    [0.00000347735, 2.45372261286, 9.5612275556],
    [0.00000353752, 2.58324496886, 148.0787244263],
    [0.00000317084, 5.57855232072, 52.6901980395],
    [0.0000017992, 5.68367730922, 12.5301729722],
    [0.00000171084, 3.00060075287, 78.7137518304],
    [0.00000205585, 2.36263144251, 2.4476805548],
    [0.00000158029, 2.90931969498, 0.9632078465],
    [0.00000189068, 4.20242881378, 56.6223513026],
    [0.0000015467, 5.59083925605, 4.4534181249],
    [0.00000183762, 0.28371004654, 151.0476698429],
    [0.00000143464, 2.59049246726, 62.2514255951],
    [0.00000151984, 2.9421732689, 77.7505439839],
    [0.00000153515, 4.65186885939, 35.1640902212],
    [0.00000121452, 4.1483920492, 127.4717966068],
    [0.00000115546, 3.73224603791, 65.2203710117],
    [0.00000102022, 4.18754517993, 145.6310438715],
    [0.00000101718, 6.03385875009, 0.1118745846],
    [0.00000088202, 3.99035787994, 18.1592472647],
    [0.00000087549, 6.15520787584, 202.2533951741],
    [0.0000008053, 2.64124743934, 22.0914005278],
    [0.00000072047, 6.04545933578, 70.3281804424],
    [0.0000006857, 4.05071895264, 77.962992305],
    [0.00000059173, 3.70413919082, 67.6680515665],
    [0.00000047267, 3.54312460519, 351.8165923087],
    [0.00000042534, 5.72357370899, 5.4166259714],
    [0.00000044339, 5.90865821911, 7.1135470008],
    [0.00000035605, 3.29197259183, 8.0767548473],
    [0.00000035524, 3.32784616138, 71.6002048296],
    [0.00000036116, 5.89964278801, 33.6796175129],
    [0.00000030608, 5.46414592601, 160.6088973985],
    [0.00000031454, 5.62015632303, 984.6003316219],
    [0.00000038544, 4.91519003848, 222.8603229936],
    [0.00000034996, 5.08034112149, 38.1330356378],
    [0.00000030811, 5.49591403863, 59.8037450403],
    [0.00000028947, 4.51867390414, 84.3428261229],
    [0.00000026627, 5.54127301037, 131.4039498699],
    [0.00000029866, 1.65980844667, 447.7958195265],
    [0.00000029206, 1.14722640419, 462.0229135281],
    [0.00000025753, 4.99362028417, 137.0330241624],
    [0.00000025373, 5.73584678604, 380.12776796],
    [0.00000021672, 2.80556379586, 69.3649725959],
    [0.00000026605, 6.14640604128, 299.1263942692],
    [0.00000022995, 2.24925345862, 111.4301614968],
    [0.00000019246, 3.55645739672, 54.1746707478],
    [0.0000002178, 0.93285892393, 213.299095438],
    [0.00000019338, 1.86249384092, 108.4612160802],
    [0.00000016153, 3.10208165842, 14.977853527],
    [0.00000013126, 1.95385539499, 87.3117715395],
    [0.00000013907, 1.541490458, 340.7708920448],
    [0.00000013549, 4.3845512672, 5.9378908332],
    [0.00000013102, 5.88301410143, 6.2197751235],
    [0.0000001181, 0.32615567587, 35.4247226521],
    [0.0000001098, 1.69230280951, 45.5766510387],
    [0.00000012351, 0.32823896833, 51.2057253312],
    [0.00000010906, 5.9706844479, 265.9892934775],
    [0.00000011446, 3.37831545858, 72.3339180125],
    [0.00000012013, 3.60395709253, 269.9214467406],
    [0.00000011662, 1.74504271366, 79.2350166922],
    [0.00000013777, 2.69028726334, 225.8292684102],
    [0.00000012006, 5.34430562395, 152.5321425512],
    [0.00000009866, 5.50316093605, 153.4953503977],
    [0.00000010436, 4.16875643286, 24.3790223882],
    [0.00000010632, 3.06875158069, 284.1485407422],
    [0.00000009613, 0.49590148788, 209.3669421749],
    [0.00000009283, 3.54479191952, 41.6444977756],
    [0.00000009536, 5.60054956443, 82.8583534146],
    [0.0000000974, 1.01087744586, 68.8437077341],
    [0.00000009187, 4.49472579228, 20.6069278195],
    [0.00000010159, 3.51765739489, 529.6909650946],
    [0.00000008612, 3.88869873588, 60.7669528868],
    [0.0000001003, 4.6479020458, 77.2292791221],
    [0.00000008689, 1.96813580258, 195.1398481733],
    [0.0000000837, 4.40914764204, 134.5853436076],
    [0.00000009273, 3.932912279, 39.6175083461],
    [0.00000007784, 5.35626068469, 75.7448064138],
    [0.00000007724, 5.77176047568, 73.8183907208],
    [0.00000007683, 4.44252070929, 14.0146456805],
    [0.00000008355, 2.4442591043, 146.594251718],
    [0.00000007954, 5.73093878181, 184.7272873558],
    [0.00000007465, 2.18972405572, 145.1097790097],
    [0.0000000643, 0.84582374839, 32.1951448046],
    [0.00000006257, 2.17085130003, 74.8934731519],
    [0.00000007911, 0.17275924476, 120.358249606],
    [0.00000007036, 4.12047266896, 191.2076949102],
    [0.0000000686, 2.13462553365, 116.4260963429],
    [0.00000005191, 3.11155355454, 106.9767433719],
    [0.00000004798, 2.25093144226, 46.2097904851],
    [0.00000004566, 3.45427648666, 0.7507595254],
    [0.00000004401, 3.94058045671, 6.592282139],
    [0.00000004214, 5.17805765625, 144.1465711632],
    [0.00000004409, 0.24427052932, 92.940845832],
    [0.00000004866, 1.15344187054, 112.9146342051],
    [0.00000004744, 5.18229292013, 81.0013736908],
    [0.00000004332, 2.52429167546, 99.1606209555],
    [0.00000003876, 2.78430217652, 565.1156877467],
    [0.00000003801, 0.75133837939, 58.1068240109],
    [0.00000004146, 5.84943984597, 221.3758502853],
    [0.00000003885, 4.95626104286, 125.9873238985],
    [0.00000003815, 3.2300440193, 479.2883889155],
    [0.00000003679, 5.28098232097, 66.9172920411],
    [0.00000003479, 2.95514470947, 74.6697239827],
    [0.00000003514, 4.90090391308, 28.3111756513],
    [0.00000004515, 4.15474629145, 344.7030453079],
    [0.00000004036, 2.28903172191, 109.9456887885],
    [0.00000004266, 2.68534591099, 7.8643065262],
    [0.00000003428, 0.02846652682, 140.001969579],
    [0.00000003644, 5.3200209381, 408.4389436113],
    [0.00000003252, 1.44975192429, 128.9562693151],
    [0.00000004143, 1.89070487241, 277.0349937414],
    [0.00000003177, 0.04197149544, 220.4126424388],
    [0.00000003901, 6.25926496244, 0.8937718773],
    [0.00000003787, 0.02516903921, 152.7445908723],
    [0.000000032, 0.52009458683, 2.2876218604],
    [0.00000002995, 1.94615440691, 80.1982245387],
    [0.00000004029, 5.24603808726, 96.8729990951],
    [0.00000003302, 4.8103355106, 422.6660376129],
    [0.00000003189, 6.261566034, 456.3938392356],
    [0.00000002804, 1.35626949052, 404.5067903482],
    [0.0000000297, 0.54327361056, 159.1244246902],
    [0.00000003465, 5.88337990735, 16.6747745564],
    [0.00000003518, 4.9964940413, 36.6485629295],
    [0.00000003081, 2.82772472086, 453.424893819],
    [0.0000000332, 1.56223495893, 23.5758732361],
    [0.00000002573, 6.19617997586, 135.5485514541],
    [0.00000002547, 5.19937103778, 173.9422195228],
    [0.00000002534, 1.85452635674, 490.3340891794],
    [0.00000003106, 6.07067928601, 142.4496501338],
    [0.00000003302, 1.02846689671, 297.6419215609],
    [0.00000002429, 1.33640100979, 211.8146227297],
    [0.00000002792, 3.89897022917, 358.9301393095],
    [0.00000002947, 5.31528985588, 55.1378785943],
    [0.00000002449, 3.44007536754, 206.1855484372],
    [0.00000002407, 4.38551271701, 60.5545045657],
    [0.00000002425, 2.22643225523, 66.70484372],
    [0.00000002295, 2.31690029267, 31.492569389],
    [0.00000002225, 0.41365126245, 81.3738807063],
    [0.00000002196, 0.76281798713, 17.5261078183],
    [0.00000002301, 3.60815987923, 288.0806940053],
    [0.00000002557, 0.73679737974, 200.7689224658],
    [0.00000002158, 2.61924330277, 13.3333221243],
    [0.00000002048, 6.27204714771, 98.8999885246],
    [0.00000002054, 3.61072687338, 333.657345044],
    [0.0000000219, 2.496967297, 76.4785195967],
    [0.00000002092, 1.66496421654, 235.3904959658],
    [0.00000002206, 2.35938756479, 347.8844390456],
    [0.00000002469, 4.70656858928, 186.2117600641],
    [0.00000002226, 5.9732773815, 1514.2912967165],
    [0.00000001851, 2.19455296942, 203.7378678824],
    [0.00000001865, 4.9820720428, 5.1078094307],
    [0.00000002171, 5.49034081907, 373.0142209592],
    [0.00000001999, 5.80509154216, 146.3818033969],
    [0.00000001903, 4.32950489567, 49.5088043018],
    [0.00000001732, 3.94794012202, 24.1183899573],
    [0.00000001747, 2.46883637489, 55.6591434561],
    [0.00000001833, 3.3511004846, 143.6253063014],
    [0.00000001686, 1.28621563322, 103.0927742186],
    [0.0000000172, 2.35857527806, 1.6445314027],
    [0.00000001641, 2.99507314472, 391.1734682239],
    [0.0000000161, 0.97420709262, 977.4867846211],
    [0.00000001696, 4.98332661473, 387.2413149608],
    [0.00000001527, 3.15107379811, 7.4223635415],
    [0.0000000157, 1.61119571428, 991.7138786227],
    [0.00000001497, 2.89637638984, 19.643719973],
    [0.00000001507, 3.32822127349, 909.8187330546],
    [0.00000001375, 5.75263837916, 19.1224551112],
    [0.00000001407, 2.20244941425, 67.3592350258],
    [0.00000001364, 4.40006421418, 27.0873353739],
    [0.00000001357, 4.33780029649, 70.1157321213],
    [0.00000001311, 4.62202930578, 81.8951455681],
    [0.00000001307, 2.79964247834, 25.6028626656],
    [0.00000001312, 3.7362325266, 628.8515860501],
    [0.00000001286, 3.96557527092, 61.2882177486],
    [0.00000001723, 4.56068809303, 305.3461693927],
    [0.00000001313, 4.90611014973, 617.8058857862],
    [0.00000001508, 6.25017976193, 604.4725636619],
    [0.00000001235, 5.93779486368, 415.5524906121],
    [0.00000001278, 3.21119872139, 92.0470739547],
    [0.00000001357, 0.72647086107, 546.956440482],
    [0.00000001552, 5.05296247763, 10.2949407385],
    [0.0000000123, 1.52077038294, 157.6399519819],
    [0.0000000121, 2.63049415027, 426.598190876],
    [0.00000001206, 4.83219370572, 100.3844612329],
    [0.00000001234, 4.46203104116, 162.0933701068],
    [0.00000001174, 5.3235619109, 17.2654753874],
    [0.00000001431, 6.18138614295, 14.2270940016],
    [0.00000001244, 0.16929250603, 29.2049475286],
    [0.0000000118, 4.09719023908, 443.8636662634],
    [0.0000000118, 3.31438239649, 44.7253177768],
    [0.00000001259, 1.88793196065, 0.6543913058],
    [0.00000001263, 3.49967730885, 230.5645708254],
    [0.00000001168, 2.04071854201, 30.7106720963],
    [0.00000001523, 2.28101186489, 373.9079928365],
    [0.00000001429, 2.05075136274, 181.7583419392],
    [0.00000001065, 2.95960854361, 241.6102710893],
    [0.00000001253, 0.23639539817, 561.1835344836],
    [0.00000001255, 1.2581992576, 155.7829722581],
    [0.00000001044, 2.89293032709, 543.0242872189],
    [0.00000001062, 3.26314901318, 28.5718080822],
    [0.00000001124, 1.06535506684, 88.1149206916],
    [0.00000001186, 5.73445278027, 329.7251917809],
    [0.0000000119, 2.82438170535, 41.1019810544],
    [0.00000001067, 0.2710180619, 58.319272332],
    [0.00000001017, 4.30527610005, 67.8804998876],
    [0.00000000959, 5.20504598622, 42.5382696529],
    [0.00000000984, 4.90934403664, 465.9550667912],
    [0.00000000944, 0.66925769374, 88.7962442478],
    [0.00000001017, 4.37095088461, 13.4933808187],
    [0.00000001222, 5.13450955699, 300.6108669775],
    [0.00000000989, 0.539379093, 80.7194894005],
    [0.0000000089, 3.09802121989, 110.2063212194],
    [0.00000001095, 1.7063757674, 43.1289704839],
    [0.00000000992, 4.17968869928, 154.0166152595],
    [0.0000000095, 0.09841899432, 273.1028404783],
    [0.0000000087, 4.77500238443, 33.1371007917],
    [0.00000000867, 4.22078052532, 20.4468691251],
    [0.0000000083, 5.23785245773, 472.1748419147],
    [0.00000000884, 4.34377463442, 105.4922706636],
    [0.00000000812, 3.53258780148, 39.3568759152],
    [0.00000001055, 1.52219418153, 227.3137411185],
    [0.00000000963, 1.87806076896, 259.5088859231],
    [0.00000000859, 0.57844232244, 152.0108776894],
    [0.00000000861, 4.69213709412, 1059.3819301892],
    [0.00000001084, 2.79612346618, 48.7580447764],
    [0.00000000994, 2.87052008214, 454.9093665273],
    [0.00000000831, 1.62068330602, 554.0699874828],
    [0.00000000891, 2.8502603686, 32.2433289144],
    [0.00000000876, 0.83921717739, 4.7353024152],
    [0.00000000707, 6.16918394997, 3.6233367224],
    [0.00000000787, 1.95585343912, 16.4623262353],
    [0.00000000702, 5.4955704624, 558.0021407459],
    [0.00000000817, 0.38724470336, 378.6432952517],
    [0.00000000804, 2.25693582099, 16.04163511],
    [0.00000000866, 1.80814575866, 258.8757464767],
    [0.00000000651, 3.72120167607, 286.596221297],
    [0.00000000672, 1.00052727778, 522.5774180938],
    [0.00000000631, 4.14839739363, 141.6988906084],
    [0.00000000748, 4.19441869839, 486.4019359163],
    [0.00000000668, 0.77754011576, 120.9913890524],
    [0.00000000619, 4.31040053492, 455.8725743738],
    [0.00000000619, 4.77556598202, 453.9461586808],
    [0.00000000647, 5.74952736928, 119.5069163441],
    [0.00000000609, 0.24149609998, 117.9105690512],
    [0.0000000063, 1.79018649942, 440.6822725257],
    [0.00000000601, 1.41196883461, 218.9281697305],
    [0.00000000719, 4.27398947015, 50.4025761791],
    [0.00000000594, 3.92150462249, 25.2727942655],
    [0.0000000071, 0.45768559438, 536.8045120954],
    [0.00000000706, 6.15599144951, 258.0244132148],
    [0.00000000617, 2.80636989892, 68.5618234438],
    [0.00000000587, 5.47247350993, 767.3690829208],
    [0.0000000069, 3.48978614301, 835.0371344873],
    [0.00000000537, 4.06668446648, 450.9772132642],
    [0.00000000511, 0.60155300709, 264.5048207692],
    [0.00000000694, 1.18127476921, 129.9194771616],
    [0.00000000584, 1.94104733057, 106.2741679563],
    [0.00000000522, 5.9518061751, 518.6452648307],
    [0.00000000507, 4.39658523394, 121.8427223143],
    [0.00000000627, 2.24582628581, 218.4069048687],
    [0.00000000485, 0.02058107411, 106.0135355254],
    [0.00000000592, 2.06072766194, 296.1574488526],
    [0.00000000587, 0.1855747086, 458.090760265],
    [0.00000000483, 1.50333774574, 150.5264049811],
    [0.00000000474, 4.99848521665, 458.8415197904],
    [0.00000000566, 1.9443518903, 699.7010313543],
    [0.00000000472, 1.865197202, 180.1619946463],
    [0.00000000472, 0.07145793467, 216.4804891757],
    [0.00000000571, 6.01195273302, 47.061123747],
    [0.0000000046, 3.76890954025, 342.2553647531],
    [0.00000000489, 2.96084966272, 385.7568422525],
    [0.00000000458, 1.99730631732, 275.5505210331],
    [0.0000000046, 5.75982407113, 89.7594520943],
    [0.00000000549, 1.43219978325, 171.6545976624],
    [0.00000000544, 0.04821904056, 114.3991069134],
    [0.0000000045, 1.94933296558, 148.5999892881],
    [0.00000000444, 2.94093732205, 692.5874843535],
    [0.00000000442, 2.15938034999, 173.6815870919],
    [0.00000000543, 2.61197342701, 451.7279727896],
    [0.00000000465, 0.31777753866, 756.3233826569],
    [0.00000000441, 2.82271922049, 32.7164096664],
    [0.00000000538, 2.39420182072, 339.2864193365],
    [0.00000000569, 0.84686482736, 260.9933586314],
    [0.00000000572, 5.40379754526, 278.5194664497],
    [0.00000000422, 4.61520857062, 40.1600250673],
    [0.00000000451, 4.5091120102, 142.1408335931],
    [0.00000000501, 0.18290112601, 331.3215390738],
    [0.00000000468, 0.97688759019, 760.25553592],
    [0.00000000443, 4.58896013561, 149.6750717192],
    [0.00000000428, 1.02564850231, 469.1364605289],
    [0.000000005, 4.34235307579, 166.828672522],
    [0.00000000412, 5.69502940499, 92.3077063856],
    [0.00000000404, 5.18855270166, 22.633917249],
    [0.00000000396, 3.98515136901, 31.2319369581],
    [0.00000000421, 5.47567810199, 104.0077979553],
    [0.00000000425, 3.50702044406, 180.2738692309],
    [0.00000000415, 1.5229107152, 497.4476361802],
    [0.0000000043, 2.39159932023, 39.0962434843],
    [0.00000000401, 0.55271143649, 95.3885263868],
    [0.00000000384, 2.48712922138, 210.3301500214],
    [0.00000000422, 1.02056886848, 468.2426886516],
    [0.00000000465, 5.72323435231, 183.2428146475],
    [0.00000000383, 2.63486938783, 685.4739373527],
    [0.00000000367, 5.39331524988, 874.3940104025],
    [0.00000000461, 3.5796125479, 187.6962327724],
    [0.00000000409, 4.21780704807, 181.0557665236],
    [0.0000000044, 0.36380766054, 367.9701020033],
    [0.00000000392, 5.44355925956, 26.0235537909],
    [0.00000000431, 3.83885208954, 254.9435932136],
    [0.00000000366, 2.92275490656, 291.262087743],
    [0.00000000416, 2.54190330826, 255.0554677982],
    [0.00000000348, 0.35176743482, 46.470422916],
    [0.00000000413, 2.41518097006, 483.2205421786],
    [0.00000000386, 4.76483292968, 268.4369740323],
    [0.00000000344, 0.20350283971, 184.0941479094],
    [0.0000000035, 1.24205287122, 97.4155158163],
    [0.00000000361, 5.683933914, 353.301065017],
    [0.00000000359, 2.62171903648, 162.8965192589],
    [0.00000000381, 3.38777292581, 114.9416236346],
    [0.00000000352, 2.76374792259, 295.1942410061],
    [0.0000000034, 1.3466636056, 34.2008823747],
    [0.00000000433, 1.90504858871, 123.5396433437],
    [0.00000000389, 2.41268196916, 381.6122406683],
    [0.00000000383, 3.20416581825, 79.4474650133],
    [0.00000000369, 2.1518588972, 555.5544601911],
    [0.0000000037, 2.19402183275, 562.6680071919],
    [0.00000000327, 3.40081544565, 309.2783226558],
    [0.00000000378, 5.75737470182, 916.9322800554],
    [0.00000000318, 4.53066393124, 350.3321196004],
    [0.00000000376, 1.74845257914, 545.4719677737],
    [0.00000000346, 4.15815107375, 282.6640680339],
    [0.00000000319, 4.38123849114, 154.979823106],
    [0.0000000032, 0.81846631878, 610.6923387854],
    [0.00000000327, 5.07873875355, 189.7232222019],
    [0.00000000306, 1.71903179875, 394.3548619616],
    [0.00000000329, 1.82999432252, 706.8145783551],
    [0.00000000335, 4.78622577105, 109.3125493421],
    [0.0000000031, 5.08120849869, 376.1956146969],
    [0.00000000327, 1.87637598331, 207.8824694666],
    [0.00000000323, 1.888454518, 192.6921676185],
    [0.00000000284, 2.88222063053, 384.0599212231],
    [0.00000000283, 4.63187254084, 332.1728723357],
    [0.00000000294, 2.84554743359, 267.4737661858],
    [0.00000000285, 0.97965330777, 113.8778420516],
    [0.00000000319, 5.09582764612, 285.6330134505],
    [0.0000000028, 0.67871105907, 312.4597163935],
    [0.000000003, 5.93285242876, 124.2904028691],
    [0.0000000032, 4.86151247369, 448.6895914038],
    [0.0000000031, 3.75000484412, 253.5709950899],
    [0.00000000311, 5.5968659072, 271.4059194489],
    [0.00000000316, 1.89686876211, 228.276948965],
    [0.00000000269, 0.14585942744, 142.6620984549],
    [0.0000000027, 2.12904548682, 778.4147831847],
    [0.00000000267, 0.96560769114, 90.8232336773],
    [0.00000000308, 1.38454900684, 375.3924655448],
    [0.00000000298, 3.99595366039, 451.9404211107],
    [0.00000000278, 3.38339026214, 346.3999663373],
    [0.00000000287, 1.01918432834, 905.8865797915],
    [0.00000000263, 0.16921968622, 124.5028511902],
    [0.00000000283, 5.95865378023, 362.8622925726],
    [0.00000000266, 3.07331582044, 193.655375465],
    [0.00000000264, 5.47114459575, 133.1008708993],
    [0.00000000288, 2.78232740152, 1812.5239191084],
    [0.00000000361, 4.30140629884, 198.321241911],
    [0.00000000257, 1.60206491208, 369.0820676961],
    [0.00000000274, 2.88347680082, 233.9060232575],
    [0.00000000267, 4.90554019072, 681.5417840896],
    [0.00000000305, 1.55983861329, 49.7212526229],
    [0.00000000253, 0.50457429429, 316.3918696566],
    [0.00000000258, 5.81453094409, 630.3360587584],
    [0.0000000028, 1.15452517706, 986.0848043302],
    [0.00000000265, 4.93584097286, 831.1049812242],
    [0.00000000246, 1.2518623362, 134.0640787458],
    [0.00000000298, 5.75927878031, 902.7051860538],
    [0.0000000024, 2.84888261768, 44.0921783304],
    [0.00000000261, 2.20643594285, 73.0846775379],
    [0.00000000321, 3.4686482782, 372.4235201282],
    [0.00000000234, 6.06783988023, 147.1155165798],
    [0.00000000262, 2.69623862046, 167.7224443993],
    [0.00000000267, 4.05985113852, 75.3028634291],
    [0.0000000024, 0.48471871511, 172.1971143836],
    [0.00000000261, 4.64354183979, 535.3200393871],
    [0.00000000244, 5.85987959874, 507.5995645668],
    [0.00000000237, 4.79666486485, 377.1588225434],
    [0.00000000224, 1.94589447357, 593.426863398],
    [0.00000000226, 3.71637531808, 449.2802922348],
    [0.00000000233, 5.98739382153, 219.891377577],
    [0.0000000024, 2.71609791875, 227.5261894396],
    [0.00000000221, 2.23218400256, 460.5384408198],
    [0.00000000226, 2.74516124394, 446.3113468182],
    [0.00000000221, 3.2033980767, 463.5073862364],
    [0.00000000203, 5.04975483055, 457.8783119439],
    [0.00000000191, 4.24841510229, 4.665866446],
    [0.00000000169, 0.59358171769, 983.1158589136],
    [0.00000000179, 4.12060524413, 310.1720945331],
    [0.00000000187, 6.22165475247, 294.6729761443],
    [0.00000000162, 1.30776665222, 248.7238180901],
    [0.00000000219, 4.17413407057, 303.8616966844],
    [0.00000000193, 1.64715944768, 91.4563731237],
    [0.0000000017, 2.18067759964, 66.1835788582],
    [0.00000000156, 4.92094728667, 68.1893164283],
    [0.00000000145, 5.51404722738, 280.9671470045],
    [0.00000000144, 5.81835834612, 75.5323580927],
    [0.00000000153, 0.48549989656, 144.8973306886],
    [0.00000000168, 5.81402201452, 149.45132255],
    [0.0000000015, 4.66632209585, 306.830642101],
    [0.00000000131, 1.01359934164, 175.1660598002],
    [0.00000000174, 3.03279013213, 298.2326223919],
    [0.00000000163, 1.97665571311, 221.1634019642],
    [0.00000000144, 2.5905808501, 217.2312487011],
    [0.00000000167, 2.7460416758, 69.1525242748],
    [0.00000000129, 2.87574897902, 156.1554792736],
];

const VSOP87_L2: Vsop87Element = [
    [0.00053033277],
    [0.00002357636, 2.26014661705, 74.7815985673],
    [0.00000769129, 4.52561041823, 11.0457002639],
    [0.00000551533, 3.25814281023, 63.7358983034],
    [0.00000541532, 2.27573907424, 3.9321532631],
    [0.00000529473, 4.92348433826, 1.4844727083],
    [0.00000257521, 3.69059216858, 3.1813937377],
    [0.00000238835, 5.85806638405, 149.5631971346],
    [0.00000181904, 6.21763603405, 70.8494453042],
    [0.00000049401, 6.03101301723, 56.6223513026],
    [0.00000053504, 1.44225240953, 76.2660712756],
    [0.00000038222, 1.78467827781, 52.6901980395],
    [0.00000044753, 3.90904910523, 2.4476805548],
    [0.0000004453, 0.81152639478, 85.8272988312],
    [0.00000037403, 4.46228598032, 2.9689454166],
    [0.00000033029, 0.86388149962, 9.5612275556],
    [0.00000024292, 2.10702559049, 18.1592472647],
    [0.00000029423, 5.09818697708, 73.297125859],
    [0.00000022135, 4.81730808582, 78.7137518304],
    [0.00000022491, 5.99320728691, 138.5174968707],
    [0.00000017226, 2.53537183199, 145.6310438715],
    [0.00000021392, 2.39880709309, 77.962992305],
    [0.00000020578, 2.16918786539, 224.3447957019],
    [0.00000016777, 3.46631344086, 12.5301729722],
    [0.00000012012, 0.01941361902, 22.0914005278],
    [0.00000010466, 4.45556032593, 62.2514255951],
    [0.0000001101, 0.0849627437, 127.4717966068],
    [0.00000008668, 4.25550086984, 7.1135470008],
    [0.00000010476, 5.16453084068, 71.6002048296],
    [0.0000000716, 1.24903906391, 5.4166259714],
    [0.00000008387, 5.50115930045, 67.6680515665],
    [0.00000006087, 5.44611674384, 65.2203710117],
    [0.00000006013, 4.51836836347, 151.0476698429],
    [0.00000005718, 1.8293391534, 202.2533951741],
    [0.00000006109, 3.36320161279, 447.7958195265],
    [0.00000006003, 5.72500086735, 462.0229135281],
    [0.00000005111, 3.52374555791, 59.8037450403],
    [0.00000005155, 1.05810305746, 131.4039498699],
    [0.00000005969, 5.61147374852, 148.0787244263],
    [0.00000005065, 3.36477113418, 4.4534181249],
    [0.00000004845, 1.20298837109, 71.8126531507],
    [0.00000003979, 0.67629577193, 77.7505439839],
    [0.00000003673, 1.76315074166, 351.8165923087],
    [0.00000003149, 3.83590892865, 45.5766510387],
    [0.00000003036, 3.32062892682, 160.6088973985],
    [0.00000003033, 6.14532331482, 77.2292791221],
    [0.00000003596, 4.57256025582, 454.9093665273],
    [0.00000002664, 5.36121614612, 269.9214467406],
    [0.00000002498, 1.04819496324, 69.3649725959],
    [0.00000002307, 2.69282373897, 84.3428261229],
    [0.00000002249, 5.07693376112, 14.977853527],
    [0.00000002228, 1.38937510191, 284.1485407422],
    [0.00000002064, 4.34647674542, 984.6003316219],
    [0.00000002105, 2.32047802326, 120.358249606],
    [0.00000001864, 5.70354779393, 54.1746707478],
    [0.00000002005, 3.87177765185, 195.1398481733],
    [0.00000001622, 5.07964536529, 209.3669421749],
    [0.00000001597, 0.48807990368, 137.0330241624],
    [0.00000001583, 2.90536212187, 51.2057253312],
    [0.00000001725, 6.25703202673, 41.6444977756],
    [0.00000002073, 1.24032244487, 35.1640902212],
    [0.00000001543, 2.15414338268, 70.3281804424],
    [0.00000001671, 6.28283232471, 277.0349937414],
    [0.00000001494, 6.04572758571, 87.3117715395],
    [0.00000001418, 1.15843502159, 213.299095438],
    [0.00000001239, 4.63223076077, 92.940845832],
    [0.00000001238, 2.65969680342, 134.5853436076],
    [0.00000001273, 5.87964059822, 60.5545045657],
    [0.0000000116, 1.03320781667, 153.4953503977],
    [0.0000000143, 4.68022239016, 299.1263942692],
    [0.00000001117, 2.62506108047, 72.3339180125],
    [0.00000001142, 4.64615099782, 152.7445908723],
    [0.00000000974, 2.85233132493, 222.8603229936],
    [0.00000001046, 4.81299135934, 116.4260963429],
    [0.00000000872, 3.49659835508, 340.7708920448],
    [0.00000000952, 2.1083748084, 20.6069278195],
    [0.00000000964, 2.46471453524, 380.12776796],
    [0.00000000843, 6.12869288891, 49.5088043018],
    [0.00000000821, 0.27134156683, 191.2076949102],
    [0.00000000813, 4.08930465981, 14.2270940016],
    [0.00000000796, 6.170668463, 344.7030453079],
    [0.00000000924, 2.11096444289, 14.0146456805],
    [0.00000000791, 2.38927423348, 58.1068240109],
    [0.00000000781, 0.7422311595, 408.4389436113],
    [0.00000000759, 3.77564054479, 80.1982245387],
    [0.00000000884, 1.99930014838, 265.9892934775],
    [0.00000000722, 3.10001033669, 422.6660376129],
    [0.0000000075, 2.33167721991, 358.9301393095],
    [0.00000000687, 2.0286634204, 33.6796175129],
    [0.00000000603, 1.10391172652, 55.1378785943],
    [0.00000000655, 3.85415269764, 16.6747745564],
    [0.00000000606, 0.15052747979, 28.3111756513],
    [0.00000000639, 5.16714934188, 23.5758732361],
    [0.00000000658, 0.75636229109, 76.4785195967],
    [0.0000000059, 1.73778850095, 8.0767548473],
    [0.00000000565, 4.92645232089, 35.4247226521],
    [0.00000000656, 2.34273264083, 38.1330356378],
    [0.00000000542, 5.97968975563, 146.594251718],
    [0.00000000518, 3.19086220901, 152.5321425512],
    [0.00000000536, 4.52808465499, 220.4126424388],
    [0.00000000489, 4.80633294199, 159.1244246902],
    [0.00000000491, 0.85765309118, 565.1156877467],
    [0.00000000483, 3.52583593251, 144.1465711632],
    [0.00000000521, 5.21561656321, 206.1855484372],
    [0.00000000477, 4.25420753202, 365.9006739584],
    [0.00000000466, 5.13219663072, 297.6419215609],
    [0.00000000557, 0.98387565952, 225.8292684102],
    [0.00000000531, 4.2253465745, 29.2049475286],
    [0.000000005, 3.49663062387, 128.9562693151],
    [0.00000000445, 2.60797570173, 96.8729990951],
    [0.00000000466, 6.05585106742, 70.1157321213],
    [0.00000000425, 1.04692398351, 19.643719973],
    [0.00000000491, 2.2612339868, 152.0108776894],
    [0.00000000455, 5.45520675, 333.657345044],
    [0.00000000458, 0.91654899383, 373.0142209592],
    [0.0000000052, 5.72828536642, 111.4301614968],
    [0.00000000432, 1.04604024916, 125.9873238985],
    [0.00000000387, 2.82547341355, 200.7689224658],
    [0.00000000383, 1.91679738697, 5.6290742925],
    [0.00000000504, 1.95816731769, 415.5524906121],
    [0.0000000037, 3.21958844151, 387.2413149608],
    [0.00000000379, 2.75940848661, 81.8951455681],
    [0.00000000345, 2.98021540638, 429.7795846137],
    [0.00000000368, 6.20331898497, 456.3938392356],
    [0.00000000335, 5.29062985955, 13.3333221243],
    [0.0000000032, 0.74685222907, 347.8844390456],
    [0.00000000307, 1.65925943351, 99.1606209555],
    [0.00000000284, 2.0943747648, 129.9194771616],
    [0.00000000275, 0.62680026669, 31.492569389],
    [0.00000000339, 1.65968150805, 142.4496501338],
    [0.0000000027, 2.7937834555, 977.4867846211],
    [0.00000000284, 2.42261530322, 546.956440482],
    [0.00000000271, 0.59225635449, 1894.4190646765],
    [0.00000000263, 3.49309481771, 440.6822725257],
    [0.00000000295, 0.43376026627, 373.9079928365],
    [0.00000000271, 4.82853730065, 561.1835344836],
    [0.00000000248, 5.72379940676, 79.2350166922],
    [0.00000000252, 5.76728095309, 235.3904959658],
    [0.00000000261, 0.09830739366, 991.7138786227],
    [0.00000000238, 1.14634663242, 288.0806940053],
    [0.0000000022, 5.12386263728, 479.2883889155],
    [0.00000000263, 1.52366362053, 146.3818033969],
    [0.0000000023, 0.35983101967, 109.9456887885],
    [0.00000000214, 2.9438876558, 184.7272873558],
    [0.00000000198, 5.72107161521, 453.424893819],
    [0.00000000185, 4.7160017678, 108.4612160802],
    [0.00000000139, 2.99832472431, 211.8146227297],
    [0.00000000167, 1.1964352228, 39.6175083461],
    [0.0000000018, 0.80198096578, 183.2428146475],
    [0.00000000131, 2.73236351123, 522.5774180938],
    [0.00000000142, 5.03489222377, 536.8045120954],
];

const VSOP87_L3: Vsop87Element = [
    [0.00000120936, 0.02418789918, 74.7815985673],
    [0.00000068064, 4.12084267733, 3.9321532631],
    [0.00000052828, 2.3896406126, 11.0457002639],
    [0.00000043754, 2.95965039734, 1.4844727083],
    [0.000000453, 2.0442379841, 3.1813937377],
    [0.00000045806],
    [0.00000024969, 4.88741307918, 63.7358983034],
    [0.00000021061, 4.54511486862, 70.8494453042],
    [0.00000019897, 2.31320314136, 149.5631971346],
    [0.00000008901, 1.57548871761, 56.6223513026],
    [0.00000004271, 0.22777319552, 18.1592472647],
    [0.00000003613, 5.39244611308, 76.2660712756],
    [0.00000003488, 4.97622811775, 85.8272988312],
    [0.00000003479, 4.12969359977, 52.6901980395],
    [0.00000003572, 0.95052448578, 77.962992305],
    [0.00000002328, 0.85770961794, 145.6310438715],
    [0.00000002696, 0.37287796344, 78.7137518304],
    [0.00000001946, 2.67997393431, 7.1135470008],
    [0.00000002156, 5.65647821519, 9.5612275556],
    [0.00000001363, 4.86983744746, 224.3447957019],
    [0.00000001333, 1.25032115614, 12.5301729722],
    [0.00000001613, 0.48764377311, 71.6002048296],
    [0.00000001475, 5.19957293069, 73.297125859],
    [0.00000001225, 3.93406822032, 22.0914005278],
    [0.00000000911, 2.18921999026, 127.4717966068],
    [0.00000000811, 3.98323855938, 462.0229135281],
    [0.00000000808, 5.06374463008, 447.7958195265],
    [0.00000000718, 0.34600103024, 5.6290742925],
    [0.00000000722, 1.05856935832, 138.5174968707],
    [0.00000000687, 2.93752748595, 131.4039498699],
    [0.00000000463, 1.58927254512, 151.0476698429],
    [0.00000000414, 4.3290428762, 120.358249606],
    [0.00000000372, 0.73596518002, 269.9214467406],
    [0.00000000345, 3.05968942771, 561.1835344836],
    [0.00000000338, 5.94221536204, 284.1485407422],
    [0.00000000343, 4.01891371998, 546.956440482],
    [0.00000000382, 5.93515231196, 45.5766510387],
    [0.00000000276, 3.44212110991, 202.2533951741],
    [0.000000003, 1.13119175675, 160.6088973985],
    [0.00000000268, 3.24615387968, 536.8045120954],
    [0.00000000358, 1.10916640253, 333.657345044],
    [0.00000000236, 4.65292396535, 387.2413149608],
    [0.00000000204, 5.81663798296, 373.0142209592],
    [0.00000000145, 2.75632381347, 92.940845832],
    [0.00000000149, 0.13764106563, 71.8126531507],
    [0.00000000156, 2.90936922804, 153.4953503977],
];

const VSOP87_L4: Vsop87Element = [
    [0.00000113855, Math.PI],
    [0.00000005599, 4.57882424417, 74.7815985673],
    [0.00000003203, 0.34623003207, 11.0457002639],
    [0.00000001217, 3.42199121826, 56.6223513026],
    [0.00000000634, 4.65759668097, 18.1592472647],
    [0.00000000171, 3.80393539303, 149.5631971346],
    [0.00000000133, 4.35519131657, 63.7358983034],
];

const VSOP87_L5: Vsop87Element = [[0.00000000873, Math.PI]];

const VSOP87_B0: Vsop87Element = [
    [0.01346277639, 2.61877810545, 74.7815985673],
    [0.00062341405, 5.08111175856, 149.5631971346],
    [0.00061601203, Math.PI],
    [0.00009963744, 1.61603876357, 76.2660712756],
    [0.00009926151, 0.57630387917, 73.297125859],
    [0.00003259455, 1.2611938596, 224.3447957019],
    [0.00002972318, 2.24367035538, 1.4844727083],
    [0.00002010257, 6.05550401088, 148.0787244263],
    [0.00001522172, 0.27960386377, 63.7358983034],
    [0.00000924055, 4.03822927853, 151.0476698429],
    [0.00000760624, 6.14000431923, 71.8126531507],
    [0.00000420265, 5.21279984788, 11.0457002639],
    [0.00000430668, 3.55445034854, 213.299095438],
    [0.00000436843, 3.38082524317, 529.6909650946],
    [0.00000522309, 3.3208519477, 138.5174968707],
    [0.00000434625, 0.34065281858, 77.7505439839],
    [0.0000046263, 0.74256727574, 85.8272988312],
    [0.00000232649, 2.25716421383, 222.8603229936],
    [0.00000215838, 1.5912170494, 38.1330356378],
    [0.00000244698, 0.78795150326, 2.9689454166],
    [0.00000179935, 3.72487952673, 299.1263942692],
    [0.00000174895, 1.23550262213, 146.594251718],
    [0.00000173667, 1.93654269131, 380.12776796],
    [0.00000160368, 5.33635436463, 111.4301614968],
    [0.00000144064, 5.96239326415, 35.1640902212],
    [0.00000102049, 2.61876256513, 78.7137518304],
    [0.00000116363, 5.73877190007, 70.8494453042],
    [0.00000106441, 0.94103112994, 70.3281804424],
    [0.00000086163, 0.70262506622, 39.6175083461],
    [0.00000072617, 0.20564696113, 225.8292684102],
    [0.00000071172, 0.83343269975, 109.9456887885],
    [0.00000057502, 2.67039425415, 108.4612160802],
    [0.00000054255, 3.35166579613, 184.7272873558],
    [0.0000004447, 2.74408231138, 152.5321425512],
    [0.00000038591, 5.17394663303, 202.2533951741],
    [0.00000039157, 2.17108251341, 351.8165923087],
    [0.00000041346, 3.22134319551, 160.6088973985],
    [0.0000003514, 4.00111634363, 112.9146342051],
    [0.00000033073, 3.61378095742, 221.3758502853],
    [0.00000031315, 2.71969470781, 145.1097790097],
    [0.00000037336, 4.02053241202, 52.6901980395],
    [0.00000032028, 1.29160071142, 145.6310438715],
    [0.00000027574, 3.7006426696, 36.6485629295],
    [0.00000024277, 2.84989187496, 127.4717966068],
    [0.00000024635, 1.11645461259, 3.9321532631],
    [0.00000024315, 5.48987913644, 79.2350166922],
    [0.00000021418, 0.63722900407, 277.0349937414],
    [0.00000019826, 2.5933418223, 84.3428261229],
    [0.00000022373, 5.73687615457, 4.4534181249],
    [0.00000019137, 1.30214105578, 62.2514255951],
    [0.00000019789, 4.72260849557, 297.6419215609],
    [0.00000020299, 1.06070151806, 454.9093665273],
    [0.00000019768, 5.77906142568, 305.3461693927],
    [0.00000021348, 1.01350946382, 33.6796175129],
    [0.00000015142, 2.91786832554, 426.598190876],
    [0.00000016, 1.95535748902, 186.2117600641],
    [0.00000013819, 2.67163927171, 74.6697239827],
    [0.00000011463, 5.73391138419, 41.1019810544],
    [0.00000010741, 3.73401569675, 1059.3819301892],
    [0.0000001145, 3.98177764866, 106.9767433719],
    [0.0000001036, 4.75567608732, 183.2428146475],
    [0.00000010232, 6.18772866993, 373.9079928365],
    [0.00000013803, 5.70712120608, 74.8934731519],
    [0.00000010553, 3.78602881738, 490.3340891794],
    [0.00000011838, 5.96756415681, 87.3117715395],
    [0.0000001003, 1.74828757238, 22.0914005278],
    [0.00000010107, 0.92911975959, 65.2203710117],
    [0.00000009127, 5.11093790809, 153.4953503977],
    [0.00000012093, 2.53736362742, 9.5612275556],
    [0.00000008646, 4.18351923569, 12.5301729722],
    [0.00000009978, 5.83600622359, 604.4725636619],
    [0.00000011352, 2.12645777694, 68.8437077341],
    [0.00000008472, 3.36885457285, 72.3339180125],
    [0.00000007797, 5.11771906359, 77.962992305],
    [0.00000008302, 5.19247905162, 77.2292791221],
    [0.00000007696, 3.25189037096, 71.6002048296],
    [0.00000007513, 2.982659701, 114.3991069134],
    [0.00000006947, 3.31871016057, 56.6223513026],
    [0.0000000649, 0.88434578474, 288.0806940053],
    [0.00000006394, 3.51142812432, 220.4126424388],
    [0.00000006211, 0.58222518453, 340.7708920448],
    [0.00000006772, 4.09374798222, 137.0330241624],
    [0.00000005595, 5.68643434536, 259.5088859231],
    [0.00000005309, 2.65421183211, 300.6108669775],
    [0.0000000495, 4.99672086239, 219.891377577],
    [0.00000006419, 0.44895727879, 140.001969579],
    [0.00000004975, 4.06722486039, 143.6253063014],
    [0.00000005692, 3.7656346318, 67.6680515665],
    [0.00000004853, 2.03383592524, 415.5524906121],
    [0.00000003796, 1.26231186682, 75.3028634291],
    [0.00000003807, 2.24787582155, 909.8187330546],
    [0.00000003812, 3.10475682509, 181.7583419392],
    [0.00000003764, 5.2005209056, 227.3137411185],
    [0.00000003445, 5.91769433069, 296.1574488526],
    [0.00000003517, 5.44397685665, 628.8515860501],
    [0.00000003943, 4.95136058926, 265.9892934775],
    [0.00000003472, 0.3473799838, 131.4039498699],
    [0.0000000339, 0.53497504164, 206.1855484372],
    [0.00000003038, 4.68314286209, 159.1244246902],
    [0.0000000319, 5.68929316349, 235.3904959658],
    [0.00000003303, 2.09359507373, 73.8183907208],
    [0.00000003069, 4.49065085092, 66.70484372],
    [0.00000003285, 0.00780313833, 75.7448064138],
    [0.00000002917, 4.21615078632, 258.0244132148],
    [0.00000003747, 0.82999983666, 74.2603337055],
    [0.00000002814, 3.96708337625, 82.8583534146],
    [0.00000002474, 3.81319259323, 7.1135470008],
    [0.00000002394, 2.21483198491, 54.1746707478],
    [0.00000002555, 2.97023907145, 378.6432952517],
    [0.00000002631, 1.55153254691, 154.0166152595],
    [0.00000002633, 2.28385552693, 32.1951448046],
    [0.00000002643, 3.9683272968, 381.6122406683],
    [0.00000002206, 3.06995275892, 59.8037450403],
    [0.00000002635, 0.53987945692, 211.8146227297],
    [0.00000002071, 1.97429082033, 18.1592472647],
    [0.00000002485, 3.5543384699, 96.8729990951],
    [0.00000002061, 4.50102695788, 5.9378908332],
    [0.00000001916, 1.60538526374, 80.1982245387],
    [0.0000000248, 0.63321072542, 187.6962327724],
    [0.00000002039, 2.97351088965, 191.2076949102],
    [0.00000001833, 1.95824865568, 81.8951455681],
    [0.00000001719, 2.22526635038, 479.2883889155],
    [0.00000001745, 3.22821992592, 218.4069048687],
    [0.00000001857, 1.66304484985, 984.6003316219],
    [0.00000001766, 5.24239122261, 105.4922706636],
    [0.00000001524, 6.05374020264, 99.1606209555],
    [0.00000001519, 0.94716867229, 372.4235201282],
    [0.00000001614, 3.39986066169, 230.5645708254],
    [0.00000001711, 3.44237080993, 522.5774180938],
    [0.00000001504, 1.34653259405, 74.5209661364],
    [0.00000001577, 4.3802093672, 80.7194894005],
    [0.0000000136, 5.4869124027, 74.8297826771],
    [0.00000001364, 4.56045715617, 42.5864537627],
    [0.00000001398, 0.33827838973, 142.4496501338],
    [0.00000001709, 3.63188407264, 554.0699874828],
    [0.0000000136, 2.89305157919, 74.7334144575],
    [0.0000000126, 5.50922979275, 74.9416572617],
    [0.00000001374, 4.398979932, 260.9933586314],
    [0.00000001366, 2.15288773765, 162.0933701068],
    [0.00000001244, 4.97789913094, 149.45132255],
    [0.00000001269, 0.84167691738, 767.3690829208],
    [0.00000001278, 4.53585702916, 294.6729761443],
    [0.00000001342, 5.11117141196, 51.2057253312],
    [0.0000000118, 0.79882196802, 116.4260963429],
    [0.00000001495, 0.74986873597, 75.0422309982],
    [0.00000001207, 3.67288675913, 20.6069278195],
    [0.00000001181, 4.39598416757, 180.2738692309],
    [0.00000001248, 3.13312504066, 67.3592350258],
    [0.00000001263, 2.87116663203, 74.6215398729],
    [0.0000000138, 3.76141611602, 92.940845832],
    [0.00000001113, 3.87133607367, 39.3568759152],
    [0.00000001018, 6.20393099094, 835.0371344873],
    [0.00000000962, 3.30343472839, 255.0554677982],
    [0.00000001238, 1.73023505315, 149.6750717192],
    [0.0000000097, 1.71236273285, 115.8835796217],
    [0.00000001001, 5.49914631698, 256.5399405065],
    [0.00000000921, 3.07729879788, 8.0767548473],
    [0.00000000914, 0.00764291274, 536.8045120954],
    [0.00000000911, 6.23753038018, 200.7689224658],
    [0.00000000956, 5.76811833839, 128.9562693151],
    [0.00000000999, 0.33400530567, 404.5067903482],
    [0.00000000952, 3.00456073496, 14.977853527],
    [0.00000000765, 3.4545453366, 214.7835681463],
    [0.000000008, 3.2091293209, 28.3111756513],
    [0.00000000799, 4.11425365829, 125.9873238985],
    [0.00000001021, 1.79905869707, 3.1813937377],
    [0.00000000706, 5.80210566917, 157.6399519819],
    [0.00000000715, 5.56313177065, 146.3818033969],
    [0.00000000689, 1.84748347121, 41.6444977756],
    [0.00000000682, 5.16479782395, 74.0308390419],
    [0.00000000673, 2.65544175682, 75.5323580927],
    [0.00000000723, 4.75905991606, 331.3215390738],
    [0.0000000073, 2.25510749124, 453.424893819],
    [0.00000000691, 3.58561635364, 362.8622925726],
    [0.00000000641, 5.77408891198, 110.2063212194],
    [0.00000000671, 5.96862039131, 135.5485514541],
    [0.00000000631, 1.97807297205, 639.897286314],
    [0.00000000774, 0.42035450706, 565.1156877467],
    [0.00000000705, 2.94649553712, 60.7669528868],
    [0.00000000663, 5.32574112049, 142.1408335931],
    [0.00000000612, 2.01741578932, 195.1398481733],
    [0.00000000749, 5.56828487823, 2.4476805548],
    [0.00000000798, 0.90969731665, 152.0108776894],
    [0.00000000747, 5.07639466593, 89.7594520943],
    [0.0000000065, 4.56215718085, 216.9224321604],
    [0.00000000651, 2.80626026285, 50.4025761791],
    [0.00000000593, 1.89556258897, 203.7378678824],
    [0.0000000055, 2.90625551534, 68.1893164283],
    [0.00000000548, 3.75628845322, 617.8058857862],
    [0.00000000554, 2.78135114877, 14.0146456805],
    [0.0000000053, 3.51385025328, 291.7040307277],
    [0.00000000506, 4.94619342366, 81.3738807063],
    [0.00000000649, 5.74895589744, 141.4864422873],
    [0.00000000593, 5.40734033998, 692.5874843535],
    [0.00000000544, 2.9991051278, 152.7445908723],
    [0.00000000485, 2.36317665443, 448.6895914038],
    [0.00000000481, 5.81647231299, 134.5853436076],
    [0.00000000517, 4.97759795528, 387.2413149608],
    [0.00000000573, 2.46311368783, 81.0013736908],
    [0.0000000047, 1.30184316812, 228.276948965],
    [0.00000000475, 0.53480492526, 303.8616966844],
    [0.00000000485, 6.21247575899, 5.4166259714],
    [0.00000000468, 0.55881267334, 23.5758732361],
    [0.00000000585, 4.67924542643, 88.7962442478],
    [0.00000000512, 5.86200059955, 293.188503436],
    [0.00000000445, 2.50076311432, 905.8865797915],
    [0.00000000501, 4.79997295899, 306.830642101],
    [0.00000000418, 5.21379084769, 35.4247226521],
    [0.00000000408, 5.69107313998, 284.1485407422],
    [0.00000000474, 3.03149617428, 286.596221297],
    [0.00000000432, 4.20907682097, 278.5194664497],
    [0.00000000506, 2.05348204197, 373.0142209592],
    [0.0000000041, 5.30637634877, 95.3885263868],
    [0.00000000478, 2.41106642594, 358.9301393095],
    [0.00000000536, 1.8261477226, 114.1384744825],
    [0.00000000383, 5.54541241459, 419.4846438752],
    [0.00000000413, 0.03813081773, 103.0927742186],
    [0.00000000368, 4.08526832792, 1589.0728952838],
    [0.00000000369, 1.82533858431, 334.2904844904],
    [0.00000000491, 5.58913582973, 68.5618234438],
    [0.00000000387, 0.5661931048, 602.9880909536],
    [0.00000000427, 5.08349119654, 367.9701020033],
    [0.00000000475, 0.17507881032, 120.358249606],
    [0.00000000342, 5.27187859255, 28.5718080822],
    [0.00000000407, 2.00853504718, 679.2541622292],
    [0.00000000381, 4.61366060949, 329.7251917809],
    [0.00000000388, 0.88856038803, 483.2205421786],
    [0.00000000376, 1.28856348513, 155.7829722581],
    [0.00000000326, 6.09140263554, 456.3938392356],
    [0.00000000318, 0.09996195379, 69.3649725959],
    [0.00000000292, 5.11578046796, 375.3924655448],
    [0.00000000299, 6.04121646505, 332.8060117821],
    [0.00000000328, 3.47252263966, 73.4090004436],
    [0.00000000283, 1.81773059325, 647.0108333148],
    [0.00000000308, 3.50154864071, 30.7106720963],
    [0.00000000283, 1.88910019831, 24.3790223882],
    [0.00000000278, 3.85507901929, 760.25553592],
    [0.00000000273, 4.22941219477, 391.1734682239],
    [0.00000000293, 5.44464406156, 477.9157907918],
    [0.00000000289, 3.85492516765, 209.3669421749],
    [0.00000000309, 1.97045147502, 543.0242872189],
    [0.00000000324, 5.57191515554, 501.3797894433],
    [0.00000000248, 2.17741598681, 611.5861106627],
    [0.00000000245, 1.04008534095, 1332.4847706675],
    [0.00000000248, 6.19516038159, 1134.1635287565],
    [0.00000000242, 1.37720813333, 121.2520214833],
    [0.00000000233, 0.50933224249, 462.0229135281],
    [0.00000000319, 4.2421988104, 328.3525936572],
    [0.00000000244, 6.0064485364, 295.1942410061],
    [0.00000000228, 0.72608678727, 233.9060232575],
    [0.00000000223, 5.35785607671, 983.1158589136],
    [0.00000000304, 5.68101077712, 189.1807054807],
    [0.00000000223, 2.04168197187, 370.9390474199],
    [0.00000000245, 4.69742022955, 316.3918696566],
    [0.00000000217, 4.33845164683, 269.9214467406],
    [0.00000000267, 0.15744446718, 10213.285546211],
    [0.0000000021, 5.84975171904, 147.1155165798],
    [0.00000000224, 3.04829549918, 1439.5096981492],
    [0.00000000226, 0.72248476212, 45.5766510387],
    [0.00000000202, 1.37341689387, 302.0953396858],
    [0.00000000207, 6.13936312021, 344.7030453079],
    [0.00000000228, 2.33602531859, 150.5264049811],
    [0.00000000203, 2.38070591912, 275.5505210331],
    [0.00000000194, 5.11344829813, 1215.1649024473],
    [0.00000000259, 2.78974616768, 144.1465711632],
    [0.00000000199, 3.21010368905, 7.4223635415],
    [0.00000000246, 6.15106498377, 6.2197751235],
    [0.0000000018, 4.7037703687, 518.6452648307],
    [0.00000000186, 3.85070006482, 46.2097904851],
    [0.00000000175, 3.72163733058, 150.0844619964],
    [0.00000000165, 1.87245210311, 310.1720945331],
    [0.00000000166, 3.24028819042, 173.9422195228],
    [0.00000000181, 0.39521867351, 0.9632078465],
    [0.00000000144, 1.78180338482, 531.1754378029],
    [0.00000000137, 6.20635855175, 369.4545747116],
    [0.00000000136, 4.00164375048, 526.722019678],
    [0.00000000141, 4.02238453909, 350.3321196004],
    [0.00000000125, 5.28865037145, 329.8370663655],
    [0.00000000134, 3.97421067761, 228.7982138268],
    [0.00000000132, 4.52023845365, 148.5999892881],
    [0.00000000125, 4.24724390191, 248.7238180901],
    [0.0000000012, 4.08565783859, 154.979823106],
    [0.00000000133, 3.16576403244, 262.4778313397],
];

const VSOP87_B1: Vsop87Element = [
    [0.00206366162, 4.12394311407, 74.7815985673],
    [0.0000856323, 0.33819986165, 149.5631971346],
    [0.00001725703, 2.12193159895, 73.297125859],
    [0.0000136886, 3.06861722047, 76.2660712756],
    [0.00001374449],
    [0.00000399847, 2.84767037795, 224.3447957019],
    [0.00000450639, 3.77656180977, 1.4844727083],
    [0.00000307214, 1.25456766737, 148.0787244263],
    [0.00000154336, 3.78575467747, 63.7358983034],
    [0.00000110888, 5.32888676461, 138.5174968707],
    [0.00000112432, 5.57299891505, 151.0476698429],
    [0.00000083493, 3.59152795558, 71.8126531507],
    [0.00000055573, 3.40135416354, 85.8272988312],
    [0.00000041377, 4.45476669141, 78.7137518304],
    [0.0000005369, 1.70455769943, 77.7505439839],
    [0.00000041912, 1.21476607434, 11.0457002639],
    [0.00000031959, 3.77446207748, 222.8603229936],
    [0.00000030297, 2.56371683644, 2.9689454166],
    [0.00000026977, 5.33695500294, 213.299095438],
    [0.00000026222, 0.41620628369, 380.12776796],
    [0.00000020094, 5.9308563351, 529.6909650946],
    [0.00000022992, 2.48887389394, 146.594251718],
    [0.0000001959, 5.37213500014, 299.1263942692],
    [0.00000020408, 3.70179681605, 70.8494453042],
    [0.00000019102, 1.09213276596, 111.4301614968],
    [0.00000019411, 3.83015453768, 38.1330356378],
    [0.00000010847, 2.66326308043, 3.9321532631],
    [0.00000010249, 2.3127880772, 109.9456887885],
    [0.00000009405, 2.76950513184, 39.6175083461],
    [0.0000000766, 1.8110846285, 225.8292684102],
    [0.00000008082, 4.69064168719, 184.7272873558],
    [0.00000006584, 5.50417589189, 35.1640902212],
    [0.0000000741, 1.17879753422, 65.2203710117],
    [0.00000006451, 4.98294064391, 71.6002048296],
    [0.00000006089, 1.31830108565, 52.6901980395],
    [0.00000004768, 5.90574941745, 145.6310438715],
    [0.0000000484, 4.86390682412, 221.3758502853],
    [0.00000004192, 3.29643787103, 77.962992305],
    [0.00000004711, 4.24289069791, 152.5321425512],
    [0.00000004894, 6.01164167429, 160.6088973985],
    [0.00000003738, 4.75287390209, 70.3281804424],
    [0.00000003481, 0.64108927026, 153.4953503977],
    [0.00000003758, 3.94715595219, 351.8165923087],
    [0.00000003114, 0.10537144899, 112.9146342051],
    [0.00000002788, 4.24118032837, 74.6697239827],
    [0.00000002505, 0.04576283378, 297.6419215609],
    [0.00000002563, 4.15665405963, 305.3461693927],
    [0.00000002544, 5.25903565788, 56.6223513026],
    [0.00000002247, 4.24726481845, 36.6485629295],
    [0.00000002541, 0.40106060407, 77.2292791221],
    [0.00000002212, 2.88960413468, 277.0349937414],
    [0.00000002299, 3.57748029365, 186.2117600641],
    [0.00000002661, 0.53230319176, 79.2350166922],
    [0.00000002157, 2.10150995852, 127.4717966068],
    [0.00000002265, 1.41055702214, 4.4534181249],
    [0.00000002103, 4.27438518414, 22.0914005278],
    [0.00000001861, 3.75619999278, 145.1097790097],
    [0.00000001759, 2.10240976488, 131.4039498699],
    [0.00000001661, 4.84483054269, 62.2514255951],
    [0.00000001496, 1.72084298116, 220.4126424388],
    [0.00000001659, 5.86539712478, 454.9093665273],
    [0.00000001428, 0.31508367934, 137.0330241624],
    [0.00000001522, 1.00801468633, 75.7448064138],
    [0.00000001459, 6.17427145114, 426.598190876],
    [0.00000001463, 5.14953143442, 84.3428261229],
    [0.00000001453, 2.22988903923, 206.1855484372],
    [0.00000001358, 5.85111427068, 183.2428146475],
    [0.00000001405, 2.43582184515, 87.3117715395],
    [0.00000001495, 5.55621838458, 67.6680515665],
    [0.00000001317, 1.91178535183, 140.001969579],
    [0.00000001068, 1.51430678116, 373.9079928365],
    [0.00000001439, 0.99170994448, 74.8934731519],
    [0.00000001065, 4.15616015505, 288.0806940053],
    [0.00000001096, 1.63909426062, 41.1019810544],
    [0.00000001189, 0.90595784409, 33.6796175129],
    [0.00000000961, 5.48175535705, 490.3340891794],
    [0.00000000851, 0.95029849401, 909.8187330546],
    [0.0000000082, 0.78610123063, 259.5088859231],
    [0.00000000881, 4.31294603221, 9.5612275556],
    [0.00000000708, 0.00007309836, 81.8951455681],
    [0.00000000709, 3.18853632737, 80.1982245387],
    [0.00000000786, 5.18884635415, 114.3991069134],
    [0.00000000822, 0.01949759759, 18.1592472647],
    [0.00000000656, 6.16899483115, 96.8729990951],
    [0.00000000879, 1.82006610038, 73.8183907208],
    [0.00000000872, 0.30134022304, 12.5301729722],
    [0.0000000086, 0.21225398802, 3.1813937377],
    [0.00000000637, 2.64378420008, 75.3028634291],
    [0.00000000727, 0.02846968582, 66.70484372],
    [0.000000006, 4.42462853209, 415.5524906121],
    [0.0000000059, 4.17885957237, 300.6108669775],
    [0.0000000061, 6.07202921132, 219.891377577],
    [0.00000000611, 0.97629869063, 296.1574488526],
    [0.00000000635, 2.21125075603, 74.2603337055],
    [0.00000000529, 2.35940463062, 7.1135470008],
    [0.00000000622, 2.2180194485, 211.8146227297],
    [0.00000000519, 2.01872911223, 142.4496501338],
    [0.00000000489, 1.83419944488, 92.940845832],
    [0.00000000445, 2.51784247184, 604.4725636619],
    [0.00000000413, 5.36482818305, 82.8583534146],
    [0.00000000445, 0.33164113115, 227.3137411185],
    [0.00000000456, 2.44190834824, 381.6122406683],
    [0.00000000378, 1.91873737843, 202.2533951741],
    [0.00000000509, 5.83556856314, 191.2076949102],
    [0.00000000455, 5.15414537021, 522.5774180938],
    [0.00000000419, 2.80644155875, 72.3339180125],
    [0.00000000333, 0.3201483795, 2.4476805548],
    [0.0000000036, 1.47248643716, 378.6432952517],
    [0.00000000306, 0.15517399606, 159.1244246902],
    [0.00000000301, 4.46417652272, 536.8045120954],
    [0.00000000353, 0.48749845867, 128.9562693151],
    [0.00000000351, 6.24769322491, 5.9378908332],
    [0.00000000298, 1.71815652029, 235.3904959658],
    [0.00000000315, 2.44922921309, 187.6962327724],
    [0.00000000318, 0.7017635951, 181.7583419392],
    [0.00000000314, 4.68400251693, 14.977853527],
    [0.00000000282, 3.70093718573, 108.4612160802],
    [0.00000000272, 3.91340553608, 617.8058857862],
    [0.00000000273, 3.29483889428, 387.2413149608],
    [0.00000000323, 4.90410549341, 258.0244132148],
    [0.00000000288, 4.42249612833, 195.1398481733],
    [0.0000000025, 1.23231297183, 703.6331846174],
    [0.00000000338, 2.8464576889, 154.0166152595],
    [0.00000000297, 1.16538119842, 146.3818033969],
    [0.00000000248, 4.90614051989, 41.6444977756],
    [0.00000000275, 5.35665949805, 80.7194894005],
    [0.00000000257, 1.82441994046, 230.5645708254],
    [0.00000000234, 0.27679874465, 33.1371007917],
    [0.0000000028, 1.73679618032, 265.9892934775],
    [0.00000000229, 0.49529839431, 74.8297826771],
    [0.00000000229, 4.18462288684, 74.7334144575],
    [0.00000000253, 2.63817804331, 74.5209661364],
    [0.00000000252, 2.04143912495, 75.0422309982],
    [0.00000000213, 4.16218259902, 74.6215398729],
    [0.00000000212, 0.51761494342, 74.9416572617],
    [0.00000000201, 4.54140547837, 20.6069278195],
    [0.00000000194, 4.17282454759, 116.4260963429],
    [0.00000000213, 2.29528235429, 32.1951448046],
    [0.00000000174, 3.15418942153, 228.276948965],
    [0.00000000194, 0.06960211137, 42.5864537627],
    [0.00000000173, 5.59700344643, 68.8437077341],
    [0.00000000159, 4.91721631097, 143.6253063014],
    [0.0000000015, 0.92771324396, 404.5067903482],
    [0.00000000136, 2.51083022906, 372.4235201282],
    [0.00000000134, 3.22507836958, 479.2883889155],
    [0.00000000124, 0.42063711585, 149.45132255],
    [0.00000000122, 1.20639876458, 5.4166259714],
    [0.00000000119, 0.45375065997, 74.0308390419],
    [0.00000000146, 5.0820733036, 294.6729761443],
    [0.00000000118, 4.2264078889, 75.5323580927],
    [0.00000000118, 1.50613822829, 344.7030453079],
    [0.00000000121, 2.13544759505, 209.3669421749],
    [0.00000000121, 6.0823907637, 260.9933586314],
    [0.00000000154, 4.18369977366, 39.3568759152],
];

const VSOP87_B2: Vsop87Element = [
    [0.00009211656, 5.80044305785, 74.7815985673],
    [0.00000556926],
    [0.00000286265, 2.17729776353, 149.5631971346],
    [0.00000094969, 3.84237569809, 73.297125859],
    [0.00000045419, 4.87822046064, 76.2660712756],
    [0.00000020107, 5.46264485369, 1.4844727083],
    [0.00000014793, 0.87983715652, 138.5174968707],
    [0.00000013963, 5.07234043994, 63.7358983034],
    [0.00000014261, 2.84517742687, 148.0787244263],
    [0.00000010122, 5.00290894862, 224.3447957019],
    [0.00000008299, 6.26655615197, 78.7137518304],
    [0.00000004729, 5.16274174929, 71.8126531507],
    [0.00000003816, 6.28224514574, 85.8272988312],
    [0.00000003488, 3.53472172445, 11.0457002639],
    [0.00000002555, 1.44444215715, 151.0476698429],
    [0.00000002353, 4.23069776466, 3.9321532631],
    [0.00000002585, 0.41383633246, 71.6002048296],
    [0.00000001394, 4.13126838571, 146.594251718],
    [0.00000001183, 3.68471361409, 77.7505439839],
    [0.00000001103, 5.54212014132, 222.8603229936],
    [0.00000001205, 5.05109252937, 380.12776796],
    [0.00000001146, 1.95280464754, 529.6909650946],
    [0.00000000977, 1.52652616357, 77.962992305],
    [0.00000001025, 4.33698643491, 2.9689454166],
    [0.00000000858, 2.78728745263, 111.4301614968],
    [0.00000000868, 5.55175791193, 38.1330356378],
    [0.00000000633, 0.41074353315, 213.299095438],
    [0.00000000596, 5.39265533517, 127.4717966068],
    [0.00000000586, 4.00404667232, 109.9456887885],
    [0.00000000543, 2.40369406419, 153.4953503977],
    [0.00000000486, 2.05237757516, 299.1263942692],
    [0.00000000557, 3.13408880388, 65.2203710117],
    [0.00000000457, 3.96543219832, 454.9093665273],
    [0.00000000481, 2.81511187371, 160.6088973985],
    [0.00000000421, 2.16819778071, 56.6223513026],
    [0.00000000326, 4.5292001243, 39.6175083461],
    [0.00000000308, 6.26508780547, 70.3281804424],
    [0.00000000338, 5.14594268587, 3.1813937377],
    [0.00000000288, 0.47061435406, 22.0914005278],
    [0.00000000336, 4.23512034174, 35.1640902212],
    [0.00000000316, 3.93430525759, 52.6901980395],
    [0.00000000306, 1.10359318443, 70.8494453042],
    [0.0000000025, 3.58780257084, 202.2533951741],
    [0.00000000239, 4.7767930608, 87.3117715395],
    [0.00000000227, 2.74138067839, 12.5301729722],
    [0.00000000263, 1.59203582407, 84.3428261229],
    [0.00000000215, 3.88195737361, 131.4039498699],
    [0.00000000216, 5.80700510713, 74.6697239827],
    [0.00000000264, 1.82574036051, 77.2292791221],
    [0.00000000222, 0.0411188355, 184.7272873558],
    [0.00000000197, 1.56602555362, 9.5612275556],
    [0.00000000193, 2.2641693816, 75.7448064138],
    [0.00000000179, 2.69065316892, 145.6310438715],
    [0.0000000017, 2.75844544119, 73.8183907208],
    [0.00000000155, 3.5539324911, 18.1592472647],
    [0.00000000174, 4.76111441901, 277.0349937414],
    [0.0000000014, 0.2871476287, 221.3758502853],
    [0.00000000134, 1.29065526326, 206.1855484372],
    [0.00000000127, 6.17908901556, 62.2514255951],
    [0.00000000116, 6.26646620658, 220.4126424388],
];

const VSOP87_B3: Vsop87Element = [
    [0.00000267832, 1.25097888291, 74.7815985673],
    [0.00000011048, Math.PI],
    [0.00000006154, 4.00663614486, 149.5631971346],
    [0.00000003361, 5.77804694935, 73.297125859],
    [0.00000001602, 1.05657834344, 63.7358983034],
    [0.00000001265, 1.66795295537, 78.7137518304],
    [0.00000001183, 2.58856450374, 138.5174968707],
    [0.00000001087, 0.28687213135, 76.2660712756],
    [0.0000000064, 1.87238784591, 71.6002048296],
    [0.0000000059, 0.80206040001, 1.4844727083],
    [0.00000000467, 4.42872012006, 148.0787244263],
    [0.00000000272, 4.00684090176, 85.8272988312],
    [0.00000000203, 0.60406901282, 71.8126531507],
    [0.0000000018, 5.55657564049, 3.9321532631],
    [0.00000000168, 4.67745630044, 70.8494453042],
    [0.0000000017, 2.93672195979, 11.0457002639],
];

const VSOP87_B4: Vsop87Element = [
    [0.00000005719, 2.85499529315, 74.7815985673],
    [0.000000003, Math.PI],
];

const VSOP87_B5: Vsop87Element = [[Math.LN2]];

const VSOP87_R0: Vsop87Element = [
    [19.21264847881],
    [0.88784984055, 5.60377526994, 74.7815985673],
    [0.03440835545, 0.32836098991, 73.297125859],
    [0.02055653495, 1.78295170028, 149.5631971346],
    [0.00649321851, 4.52247298119, 76.2660712756],
    [0.00602248144, 3.86003820462, 63.7358983034],
    [0.00496404171, 1.40139934716, 454.9093665273],
    [0.00338525522, 1.58002682946, 138.5174968707],
    [0.00243508222, 1.57086595074, 71.8126531507],
    [0.00190521915, 1.99809364502, 1.4844727083],
    [0.00161858251, 2.79137863469, 148.0787244263],
    [0.00143705902, 1.38368574483, 11.0457002639],
    [0.00093192359, 0.17437193645, 36.6485629295],
    [0.00071424265, 4.24509327405, 224.3447957019],
    [0.00089805842, 3.66105366329, 109.9456887885],
    [0.00039009624, 1.66971128869, 70.8494453042],
    [0.00046677322, 1.39976563936, 35.1640902212],
    [0.00039025681, 3.36234710692, 277.0349937414],
    [0.0003675516, 3.88648934736, 146.594251718],
    [0.00030348875, 0.70100446346, 151.0476698429],
    [0.00029156264, 3.18056174556, 77.7505439839],
    [0.00020471584, 1.555889615, 202.2533951741],
    [0.0002562036, 5.25656292802, 380.12776796],
    [0.00025785805, 3.78537741503, 85.8272988312],
    [0.00022637152, 0.72519137745, 529.6909650946],
    [0.00020473163, 2.79639811626, 70.3281804424],
    [0.00017900561, 0.55455488605, 2.9689454166],
    [0.00012328151, 5.96039150918, 127.4717966068],
    [0.00014701566, 4.90434406648, 108.4612160802],
    [0.00011494701, 0.43774027872, 65.2203710117],
    [0.00015502809, 5.35405037603, 38.1330356378],
    [0.00010792699, 1.42104858472, 213.299095438],
    [0.00011696085, 3.29825599114, 3.9321532631],
    [0.00011959355, 1.75044072173, 984.6003316219],
    [0.00012896507, 2.62154018241, 111.4301614968],
    [0.00011852996, 0.99342814582, 52.6901980395],
    [0.00009111446, 4.99638600045, 62.2514255951],
    [0.0000842055, 5.25350716616, 222.8603229936],
    [0.00007449125, 0.79491905956, 351.8165923087],
    [0.00008402147, 5.03877516489, 415.5524906121],
    [0.0000604637, 5.67960948357, 78.7137518304],
    [0.00005524133, 3.11499484161, 9.5612275556],
    [0.00007329454, 3.9727752784, 183.2428146475],
    [0.00005444878, 5.10575635361, 145.1097790097],
    [0.00005238103, 2.62960141797, 33.6796175129],
    [0.00004079167, 3.22064788674, 340.7708920448],
    [0.00003801606, 6.10985558505, 184.7272873558],
    [0.00003919476, 4.25015288873, 39.6175083461],
    [0.00002940492, 2.14637460319, 137.0330241624],
    [0.00003781219, 3.45840272873, 456.3938392356],
    [0.00002942239, 0.42393808854, 299.1263942692],
    [0.00003686787, 2.48718116535, 453.424893819],
    [0.00003101743, 4.14031063896, 219.891377577],
    [0.00002962641, 0.82977991995, 56.6223513026],
    [0.00002937799, 3.6765745093, 140.001969579],
    [0.00002865128, 0.30996903761, 12.5301729722],
    [0.00002538032, 4.85457831993, 131.4039498699],
    [0.0000196251, 5.24342224065, 84.3428261229],
    [0.0000236355, 0.44253328372, 554.0699874828],
    [0.00001979394, 6.12836181686, 106.9767433719],
    [0.00002182572, 2.94040431638, 305.3461693927],
    [0.00001962974, 0.0411473912, 221.3758502853],
    [0.0000182956, 4.01105771632, 68.8437077341],
    [0.0000164292, 0.35564102554, 67.6680515665],
    [0.0000158485, 3.16267171762, 225.8292684102],
    [0.00001848655, 2.91111759376, 909.8187330546],
    [0.0000163243, 4.23061792837, 22.0914005278],
    [0.0000140139, 1.39084023521, 265.9892934775],
    [0.00001403717, 5.63563637532, 4.4534181249],
    [0.00001655866, 1.96431297431, 79.2350166922],
    [0.00001248978, 5.44027380866, 54.1746707478],
    [0.00001563447, 1.47917835549, 112.9146342051],
    [0.00001248054, 4.88984353601, 479.2883889155],
    [0.00001197439, 2.52185744943, 145.6310438715],
    [0.00001506952, 5.24186185583, 181.7583419392],
    [0.00001481746, 5.66203046912, 152.5321425512],
    [0.00001438838, 1.53046287618, 447.7958195265],
    [0.00001408514, 4.41921749601, 462.0229135281],
    [0.00001477112, 4.32214690647, 256.5399405065],
    [0.00001228314, 5.9770333104, 59.8037450403],
    [0.00001249958, 6.24484546141, 160.6088973985],
    [0.00000906468, 5.62025869483, 74.6697239827],
    [0.00001090681, 4.15393813845, 77.962992305],
    [0.00000844931, 0.12943398585, 82.8583534146],
    [0.00000900363, 2.37315925843, 74.8934731519],
    [0.00001071957, 1.74286714339, 528.2064923863],
    [0.00000689708, 3.08097059985, 69.3649725959],
    [0.00000593798, 4.50074517056, 8.0767548473],
    [0.00000718559, 4.00047509264, 128.9562693151],
    [0.00000699574, 0.03987168068, 143.6253063014],
    [0.00000575656, 5.89552672641, 66.70484372],
    [0.00000759004, 2.13700057433, 692.5874843535],
    [0.00000710449, 5.41605755095, 218.4069048687],
    [0.00000548672, 5.6281149697, 3.1813937377],
    [0.00000651632, 4.42340061551, 18.1592472647],
    [0.00000539825, 6.20788667166, 71.6002048296],
    [0.00000544539, 5.69375108253, 203.7378678824],
    [0.00000710276, 4.21967260022, 381.6122406683],
    [0.00000593819, 3.83805798523, 32.1951448046],
    [0.00000710134, 4.48972171999, 293.188503436],
    [0.00000705482, 0.45521177725, 835.0371344873],
    [0.00000588, 5.08252923316, 186.2117600641],
    [0.00000598231, 0.35815291076, 269.9214467406],
    [0.00000641914, 2.71127457036, 87.3117715395],
    [0.00000495621, 2.65094755989, 200.7689224658],
    [0.00000630252, 4.46146214548, 275.5505210331],
    [0.00000575195, 5.57862480486, 2.4476805548],
    [0.0000056987, 1.6393093274, 77.2292791221],
    [0.00000556672, 1.07231961344, 1059.3819301892],
    [0.00000449439, 0.27981733949, 617.8058857862],
    [0.00000463608, 1.43448297993, 297.6419215609],
    [0.00000436547, 0.52802035072, 209.3669421749],
    [0.00000463938, 2.35443114417, 211.8146227297],
    [0.00000435943, 2.10077211065, 1514.2912967165],
    [0.00000515534, 3.23274579379, 284.1485407422],
    [0.00000454879, 4.08364210459, 99.1606209555],
    [0.0000047743, 2.89397217998, 39.3568759152],
    [0.00000542331, 5.39481705077, 278.5194664497],
    [0.00000410087, 3.04968860441, 404.5067903482],
    [0.00000367848, 0.71159607058, 125.9873238985],
    [0.00000503096, 5.83931251717, 191.2076949102],
    [0.00000487532, 0.06402454583, 60.7669528868],
    [0.00000455043, 2.59321186669, 490.3340891794],
    [0.00000436291, 2.08183813746, 51.2057253312],
    [0.00000435803, 2.79445203085, 75.7448064138],
    [0.00000323546, 4.82899980859, 195.1398481733],
    [0.00000359363, 0.00868012078, 35.4247226521],
    [0.00000429314, 3.08031550488, 41.1019810544],
    [0.00000320021, 5.48625497747, 14.977853527],
    [0.00000414331, 0.09012800478, 258.0244132148],
    [0.00000379715, 0.05832815311, 378.6432952517],
    [0.00000420062, 2.25393983318, 81.0013736908],
    [0.00000357721, 4.71414305625, 173.9422195228],
    [0.00000358922, 0.35213227553, 426.598190876],
    [0.0000040541, 6.12263257999, 24.3790223882],
    [0.00000365158, 5.59483211224, 255.0554677982],
    [0.00000308102, 3.92355394354, 116.4260963429],
    [0.0000032566, 4.71996698332, 134.5853436076],
    [0.00000292781, 3.9952119483, 72.3339180125],
    [0.00000386543, 0.68619006966, 230.5645708254],
    [0.00000305686, 3.76108783519, 344.7030453079],
    [0.00000286972, 1.8499033531, 153.4953503977],
    [0.0000035364, 4.65717995107, 329.8370663655],
    [0.00000302051, 0.13190003806, 565.1156877467],
    [0.00000241128, 1.60454142389, 81.3738807063],
    [0.00000249829, 4.24205256241, 75.3028634291],
    [0.00000245063, 5.94905404273, 20.6069278195],
    [0.00000248277, 1.06282887181, 105.4922706636],
    [0.00000305353, 2.55534744586, 6208.2942514241],
    [0.00000296328, 4.21100245276, 1364.7280995819],
    [0.00000219938, 2.96119055727, 120.358249606],
    [0.00000233564, 2.97074409938, 46.2097904851],
    [0.00000262422, 3.83652250971, 831.1049812242],
    [0.00000233546, 4.4811700614, 628.8515860501],
    [0.00000187432, 3.03529190348, 135.5485514541],
    [0.00000216776, 3.42907414802, 241.6102710893],
    [0.0000025576, 1.1670789346, 177.8743727859],
    [0.00000220458, 0.1963349229, 180.2738692309],
    [0.00000224519, 0.40677777819, 114.3991069134],
    [0.00000205398, 2.30380942634, 259.5088859231],
    [0.00000211106, 4.93079982424, 103.0927742186],
    [0.00000175758, 5.50822822216, 7.1135470008],
    [0.00000188512, 2.23588941288, 5.4166259714],
    [0.00000171718, 5.21730232334, 41.6444977756],
    [0.00000176136, 1.95958319897, 756.3233826569],
    [0.00000170447, 4.94978757413, 206.1855484372],
    [0.00000169454, 4.04319823722, 55.6591434561],
    [0.00000219015, 0.24790282027, 294.6729761443],
    [0.00000187768, 2.04538775456, 408.4389436113],
    [0.00000182258, 0.70728384467, 391.1734682239],
    [0.00000192095, 5.76718231319, 291.7040307277],
    [0.00000153684, 4.70659406659, 543.0242872189],
    [0.00000170043, 4.50995820508, 288.0806940053],
    [0.00000164097, 5.22527540372, 67.3592350258],
    [0.00000194341, 6.1169036471, 414.0680179038],
    [0.00000168027, 5.25810639105, 518.6452648307],
    [0.00000156641, 0.66304836778, 220.4126424388],
    [0.0000018233, 0.78383856974, 417.0369633204],
    [0.00000167462, 4.92241597775, 422.6660376129],
    [0.0000017077, 2.30927162659, 98.8999885246],
    [0.00000161678, 3.27259601116, 443.8636662634],
    [0.00000132763, 2.88875442023, 373.9079928365],
    [0.0000016114, 3.82341391177, 451.9404211107],
    [0.00000179292, 4.82405681293, 366.485629295],
    [0.00000178153, 3.98026039043, 10138.5039476437],
    [0.00000141929, 1.26972581554, 159.1244246902],
    [0.0000015375, 4.27847681414, 45.5766510387],
    [0.00000161513, 4.99545008738, 73.8183907208],
    [0.00000146315, 2.65664902119, 465.9550667912],
    [0.00000124875, 4.30470898895, 339.2864193365],
    [0.0000015462, 4.3204622812, 760.25553592],
    [0.00000142894, 2.07773752143, 457.8783119439],
    [0.00000152408, 4.64742446768, 155.7829722581],
    [0.00000116389, 4.43513730944, 5.9378908332],
    [0.00000113444, 4.65351596266, 80.1982245387],
    [0.00000107611, 3.77290419929, 142.4496501338],
    [0.0000013374, 5.30894739047, 14.0146456805],
    [0.00000116104, 2.5118272567, 296.1574488526],
    [0.00000129106, 0.36277717661, 96.8729990951],
    [0.00000122766, 2.38341351026, 141.4864422873],
    [0.00000101368, 1.05739625315, 92.3077063856],
    [0.00000114669, 6.24863527978, 767.3690829208],
    [0.00000113283, 0.83051319425, 100.3844612329],
    [0.00000107199, 2.39365512354, 347.8844390456],
    [0.00000095443, 0.80094579583, 342.2553647531],
    [0.00000110789, 0.38651051525, 216.9224321604],
    [0.00000126978, 0.4235935825, 331.3215390738],
    [0.00000112635, 0.08107814739, 558.0021407459],
    [0.00000103166, 0.69792283389, 358.9301393095],
    [0.00000111474, 0.75023459027, 80.7194894005],
    [0.00000090902, 5.16530481614, 144.1465711632],
    [0.00000090677, 0.22036476597, 333.657345044],
    [0.00000098568, 4.33164222339, 74.5209661364],
    [0.00000089306, 2.18851161761, 74.8297826771],
    [0.00000117216, 3.94965784596, 74.2603337055],
    [0.00000089088, 5.87783179087, 74.7334144575],
    [0.00000097316, 0.6942969502, 977.4867846211],
    [0.00000116587, 1.83677031994, 1289.9465010146],
    [0.00000085449, 5.80255966149, 6.592282139],
    [0.00000086823, 5.61973473261, 300.6108669775],
    [0.00000105226, 5.94513614941, 328.3525936572],
    [0.00000112117, 1.21168089807, 329.7251917809],
    [0.00000082982, 2.20797412496, 74.9416572617],
    [0.00000094345, 4.53937998713, 28.5718080822],
    [0.00000106847, 1.82071328579, 306.830642101],
    [0.00000103572, 2.99368274596, 6.2197751235],
    [0.00000106357, 0.8158387475, 1087.6931058405],
    [0.00000077728, 2.73390123734, 110.2063212194],
    [0.00000098405, 3.73478182667, 75.0422309982],
    [0.00000086231, 2.83316881064, 983.1158589136],
    [0.00000089023, 4.7375445896, 604.4725636619],
    [0.00000083013, 1.88273535999, 387.2413149608],
    [0.00000090227, 3.80367274711, 986.0848043302],
    [0.00000084598, 1.25774132938, 142.1408335931],
    [0.0000007469, 1.35097482767, 350.3321196004],
    [0.0000009577, 5.54845504768, 969.6224780949],
    [0.00000090277, 0.36773710508, 0.9632078465],
    [0.00000082748, 5.85590525764, 74.6215398729],
    [0.00000075828, 2.78019216029, 88.1149206916],
    [0.0000008385, 1.84386358668, 227.3137411185],
    [0.00000070705, 4.65567024014, 44.7253177768],
    [0.00000071322, 3.64963906751, 894.8408795276],
    [0.00000094141, 4.98819201726, 403.1341922245],
    [0.00000088966, 4.43895583278, 154.0166152595],
    [0.00000079436, 5.66662613679, 267.4737661858],
    [0.00000075615, 5.40971072536, 50.4025761791],
    [0.00000068583, 4.76679841388, 991.7138786227],
    [0.00000065256, 0.69286370395, 152.7445908723],
    [0.00000063031, 2.89946567712, 79.889407998],
    [0.00000063878, 0.09820555288, 681.5417840896],
    [0.00000080101, 2.97520561915, 526.722019678],
    [0.00000069693, 3.95281159807, 187.6962327724],
    [0.00000059492, 3.59642351692, 58.1068240109],
    [0.00000059273, 0.50930692071, 28.3111756513],
    [0.0000006859, 2.4188031153, 235.3904959658],
    [0.00000066007, 5.04558399435, 30.7106720963],
    [0.00000070223, 3.73647415486, 546.956440482],
    [0.00000066836, 0.85506033017, 522.5774180938],
    [0.00000063027, 0.29269109052, 119.5069163441],
    [0.00000062023, 2.31557510311, 74.0308390419],
    [0.00000071379, 3.16967571102, 23.5758732361],
    [0.00000074827, 5.36812537961, 373.0142209592],
    [0.00000064204, 2.3681714946, 157.6399519819],
    [0.00000070712, 0.55830476304, 92.940845832],
    [0.00000055762, 5.27011035858, 874.3940104025],
    [0.00000075638, 4.66344127677, 101.8689339412],
    [0.00000073727, 6.20581665991, 312.4597163935],
    [0.0000007294, 0.58406607757, 367.9701020033],
    [0.0000005323, 2.24728742995, 17.5261078183],
    [0.00000063139, 4.59563922296, 67.8804998876],
    [0.0000006055, 0.57591315857, 253.5709950899],
    [0.00000052946, 2.45947017614, 264.5048207692],
    [0.00000070236, 1.51860943454, 552.5855147745],
    [0.00000068624, 2.44507780453, 555.5544601911],
    [0.00000062796, 0.33786296181, 561.1835344836],
    [0.00000049009, 1.09233728279, 19.1224551112],
    [0.00000064636, 5.274699709, 68.1893164283],
    [0.00000062957, 5.35891188483, 92.0470739547],
    [0.00000047664, 3.90924952181, 192.6921676185],
    [0.00000065279, 4.23629510074, 771.3012361839],
    [0.0000006519, 3.73942854797, 536.8045120954],
    [0.00000059452, 6.10554259948, 365.0011565867],
    [0.00000052153, 1.71734604937, 905.8865797915],
    [0.00000046035, 3.87093684776, 210.3301500214],
    [0.00000046429, 5.97423131576, 477.8039162072],
    [0.00000062115, 2.67544358037, 130.4407420234],
    [0.00000046038, 3.89378239085, 48.7580447764],
    [0.00000042663, 3.81519760715, 61.2882177486],
    [0.00000053909, 2.86457147106, 353.301065017],
    [0.00000046936, 1.00011046774, 166.828672522],
    [0.00000042217, 2.61748790314, 90.8232336773],
    [0.00000043324, 4.15777895713, 173.6815870919],
    [0.00000041296, 1.79930408254, 149.45132255],
    [0.0000004496, 1.76623306927, 0.5212648618],
    [0.00000051904, 2.97773319756, 383.0967133766],
    [0.00000042931, 1.57416456203, 120.9913890524],
    [0.00000049611, 4.0342792047, 303.8616966844],
    [0.00000045263, 3.58382163089, 97.4155158163],
    [0.00000038695, 2.39404211169, 31.492569389],
    [0.00000038072, 5.7947367035, 75.5323580927],
    [0.00000050126, 4.76412907201, 911.3032057629],
    [0.00000050884, 5.15513957132, 439.782755154],
    [0.00000043148, 0.84999004804, 58.319272332],
    [0.00000042732, 5.17318058934, 162.0933701068],
    [0.00000050298, 5.81603435915, 66.9172920411],
    [0.00000035639, 1.87447823723, 472.1748419147],
    [0.00000049963, 1.8894349079, 42.5864537627],
    [0.00000039974, 1.74262050679, 89.7594520943],
    [0.00000045252, 1.92511912328, 55.1378785943],
    [0.00000044896, 1.4835590189, 450.9772132642],
    [0.00000034297, 5.20257496546, 316.3918696566],
    [0.00000046355, 0.33942039181, 273.1028404783],
    [0.00000037152, 2.03757941865, 117.9105690512],
    [0.00000046106, 5.62315633955, 1819.6374661092],
    [0.00000039368, 4.19402806344, 486.4019359163],
    [0.00000041039, 4.82994471947, 149.6750717192],
    [0.00000044959, 0.72694662195, 3265.8308281325],
    [0.00000043617, 0.75332422672, 404.6186649328],
    [0.00000031823, 3.84768075667, 20.4468691251],
    [0.00000044196, 4.36769721266, 418.2608035978],
    [0.000000379, 3.02928044053, 167.0893049529],
    [0.00000043684, 1.57328182739, 491.5579294568],
    [0.00000034004, 1.26257052908, 260.9933586314],
    [0.00000031276, 4.16123711648, 13.3333221243],
    [0.00000039984, 2.8662612562, 468.2426886516],
    [0.0000003649, 2.58804294589, 68.5618234438],
    [0.00000032364, 3.11577354875, 103.3534066495],
    [0.00000033857, 0.15592410716, 24.1183899573],
    [0.00000035933, 1.36784550071, 59.2824801785],
    [0.00000033633, 0.755011774, 290.2195580194],
    [0.00000029751, 5.33178627038, 1033.3583763983],
    [0.00000032036, 4.67549858, 205.2223405907],
    [0.00000030991, 4.62823866461, 258.8757464767],
    [0.00000035268, 1.00718464327, 1108.1399749656],
    [0.00000033366, 3.40738625377, 43.1289704839],
    [0.00000032638, 5.25485850258, 114.1384744825],
    [0.00000029825, 5.64157476876, 254.9435932136],
    [0.00000031613, 3.7823139311, 152.0108776894],
    [0.0000003098, 2.26660677937, 104.0077979553],
    [0.00000034591, 5.17326577255, 25.6028626656],
    [0.00000028398, 1.76872790446, 820.0592809603],
    [0.00000027991, 3.92486885309, 199.2844497575],
    [0.00000028986, 2.58171811759, 76.4785195967],
    [0.00000033772, 5.79359878723, 274.0660483248],
    [0.00000029401, 5.93638676504, 280.9671470045],
    [0.00000031094, 1.39352495971, 178.7893965226],
    [0.00000030118, 0.44367887423, 27.0873353739],
    [0.0000003382, 6.26168443513, 401.6497195162],
    [0.00000027513, 2.15194454461, 480.7728616238],
    [0.0000002688, 2.5130027278, 123.5396433437],
    [0.00000026139, 0.21985367371, 286.596221297],
    [0.00000026455, 3.88229792258, 372.4235201282],
    [0.00000033974, 1.44637843871, 88.7962442478],
    [0.00000030107, 0.82723915882, 100.6450936638],
    [0.00000027715, 4.64827434185, 198.321241911],
    [0.00000033687, 1.14348201049, 82.4858463991],
    [0.00000026493, 1.97889544238, 95.3885263868],
    [0.00000024355, 2.3783917615, 146.3818033969],
    [0.0000002659, 0.39881920389, 106.0135355254],
    [0.00000027006, 2.10206230691, 1057.8974574809],
    [0.00000023976, 6.21233637686, 16.6747745564],
    [0.0000003097, 5.34005431547, 476.4313180835],
    [0.00000024073, 3.42953641968, 1044.4040766622],
    [0.00000027023, 0.71284764471, 248.7238180901],
    [0.00000029098, 3.99184722502, 908.3342603463],
    [0.00000022862, 2.26978781393, 175.1660598002],
    [0.00000024026, 0.36584131268, 73.1852512744],
    [0.00000028024, 3.46485782266, 1439.5096981492],
    [0.00000022034, 0.051638073, 33.1371007917],
    [0.00000022185, 5.32252126255, 483.2205421786],
    [0.00000021027, 0.37224660652, 214.7835681463],
    [0.00000020548, 1.80004483299, 118.0224436358],
    [0.00000027835, 4.1241255353, 694.0719570618],
    [0.000000255, 5.49632191634, 115.8835796217],
    [0.00000021377, 3.89179204956, 66.1835788582],
    [0.00000027201, 5.761487979, 1215.1649024473],
    [0.00000024984, 0.65339418015, 132.8884225782],
    [0.00000023976, 4.56161326826, 458.8415197904],
    [0.00000021116, 1.1361070625, 60.5545045657],
    [0.00000026263, 2.77532723118, 490.0734567485],
    [0.00000026369, 3.371200393, 49.7212526229],
    [0.0000002287, 4.5313563762, 78.4049352897],
    [0.00000026872, 3.26037129303, 691.1030116452],
    [0.00000025004, 3.65018677651, 73.4090004436],
    [0.00000020874, 3.92589972978, 134.0640787458],
    [0.00000020915, 5.53955400138, 129.9194771616],
    [0.00000023067, 2.56806856688, 332.8060117821],
    [0.0000002263, 5.02721554401, 150.5264049811],
    [0.00000019123, 1.92386327535, 124.5028511902],
    [0.00000020678, 0.98302410602, 29.2049475286],
    [0.00000018755, 1.07911898422, 70.1157321213],
    [0.00000019458, 1.33847349577, 616.3214130779],
    [0.00000023071, 3.93152899657, 43.2890291783],
    [0.00000023313, 0.61185525008, 189.7232222019],
    [0.0000001966, 1.40884902649, 1589.0728952838],
    [0.0000002499, 0.91842956919, 441.2672278623],
    [0.00000023555, 0.02127675886, 593.426863398],
    [0.00000018288, 4.55111843462, 165.6048322446],
    [0.0000002098, 0.88504201898, 326.8681209489],
    [0.0000002494, 4.63470443286, 162.8965192589],
    [0.00000018941, 5.10763304564, 81.8951455681],
    [0.00000018911, 1.23351635328, 13.4933808187],
    [0.00000017358, 4.05768226252, 403.0223176399],
    [0.00000017362, 5.2860722764, 7.8643065262],
    [0.00000022513, 3.15059891398, 419.7452763061],
    [0.00000021237, 2.14856256664, 75.5847477194],
    [0.00000017845, 2.54349200329, 47.061123747],
    [0.00000016995, 2.48647736969, 2043.9822618111],
    [0.00000023676, 5.80355919955, 232.0490435337],
    [0.00000022639, 2.07623129509, 699.7010313543],
    [0.00000019261, 1.56494156016, 425.1137181677],
    [0.00000021067, 5.30844438236, 237.6781178262],
    [0.00000022733, 0.2830312644, 0.1118745846],
    [0.00000016372, 3.45984005656, 0.7507595254],
    [0.00000021213, 0.95828006612, 405.9912630565],
    [0.00000018033, 1.60723214246, 215.4379594521],
    [0.00000016267, 4.8900201636, 69.1525242748],
    [0.00000021738, 3.24738839789, 1744.8558675419],
    [0.00000016149, 0.35803995032, 77.0692204277],
    [0.0000002171, 0.88800040769, 344.9636777388],
    [0.00000017204, 6.04366142241, 32.2433289144],
    [0.00000017883, 4.01076173641, 280.003939158],
    [0.00000015918, 2.96623390816, 25.8634950965],
    [0.00000014769, 3.73887340623, 610.6923387854],
    [0.00000015033, 4.24825484707, 228.276948965],
    [0.00000015586, 5.0798708274, 114.9416236346],
    [0.00000015392, 0.22971106129, 17.2654753874],
    [0.00000015354, 0.25482391126, 661.0949149645],
    [0.00000014617, 1.13349626273, 823.9914342234],
    [0.00000016232, 3.4349974381, 147.1155165798],
    [0.00000014654, 1.68288566884, 207.8824694666],
    [0.00000017682, 5.94376629143, 624.919432787],
    [0.00000018837, 1.3833540807, 377.1588225434],
    [0.00000015425, 1.66489033237, 440.6822725257],
    [0.00000014764, 4.41710614445, 16.4623262353],
    [0.00000014402, 0.41359448817, 142.6620984549],
    [0.00000016992, 0.16042368544, 438.2982824457],
    [0.00000013268, 3.04634728126, 668.2084619653],
    [0.0000001646, 0.92068542861, 369.0820676961],
    [0.00000017239, 4.51659246818, 606.7601855223],
    [0.00000013238, 0.13650358961, 216.4804891757],
    [0.00000015832, 4.94315562971, 124.2904028691],
    [0.00000014374, 2.93700606008, 419.4846438752],
    [0.00000012927, 1.65950183061, 54.3347294422],
    [0.00000014224, 4.42286781619, 47.6942631934],
    [0.00000012753, 0.03020931725, 217.2312487011],
    [0.00000014792, 1.08447500622, 49.5088043018],
    [0.00000014031, 3.68785757687, 16.04163511],
    [0.00000013709, 4.78890618802, 72.7758609972],
    [0.00000013073, 1.54064778942, 218.9281697305],
    [0.00000017474, 5.05621281434, 564.8550553158],
    [0.00000012686, 3.4464088888, 958.576777831],
    [0.00000013035, 0.56445754615, 1171.875873269],
    [0.00000012458, 3.29187197133, 902.7051860538],
    [0.00000011893, 1.41294011193, 55.7710180407],
    [0.00000015018, 3.43209569509, 19.0105805266],
    [0.0000001647, 2.04067754807, 411.620337349],
    [0.00000015619, 1.53464600544, 833.552661779],
    [0.00000015678, 5.92839374034, 778.4147831847],
    [0.00000012039, 5.17748353434, 135.336103133],
    [0.00000015523, 3.54656631824, 113.8778420516],
    [0.00000014364, 4.19825110964, 89.338760969],
    [0.00000015424, 2.12697366269, 106.2741679563],
    [0.00000011957, 1.43314130608, 455.8725743738],
    [0.00000015938, 5.49575810978, 513.079881013],
    [0.00000013532, 4.11463529983, 95.2284676924],
    [0.00000015105, 1.86350524526, 7.7042478318],
    [0.00000015832, 3.42498484109, 79.5169009825],
    [0.00000011492, 4.6518745562, 149.6113812444],
    [0.00000011406, 1.31085455047, 63.6240237188],
    [0.00000014469, 3.35284802718, 19.643719973],
    [0.00000011953, 0.20979051344, 65.8747623175],
    [0.00000012039, 0.0142323841, 397.3932433474],
    [0.00000014157, 1.87440535404, 6283.0758499914],
    [0.00000011357, 0.19079103112, 5.6290742925],
    [0.00000014109, 0.09348109701, 6133.5126528568],
    [0.00000015322, 3.54468546172, 252.6559713532],
    [0.00000011681, 0.85100356112, 5.1078094307],
    [0.00000014134, 5.66340426198, 639.897286314],
    [0.00000011052, 0.47607339302, 150.0844619964],
    [0.00000011507, 5.19480309409, 1182.9215735329],
    [0.00000011492, 2.05801478181, 149.5150130248],
    [0.00000011571, 4.7821072497, 334.2904844904],
    [0.00000010671, 4.67373109923, 149.723255829],
    [0.00000011651, 3.13272450186, 93.9040536785],
    [0.00000014316, 0.08421279341, 240.3864308119],
    [0.00000010855, 4.52379396618, 453.9461586808],
    [0.000000119, 1.41784572428, 26.0235537909],
    [0.00000010851, 4.40625021974, 57.1436161644],
    [0.00000013385, 0.76174742916, 37.8724032069],
    [0.00000010664, 5.81644528276, 193.655375465],
    [0.000000107, 5.3459550607, 331.2096644892],
    [0.00000010465, 3.82648204886, 180.1619946463],
    [0.0000001335, 0.86920479636, 22.8945496799],
    [0.00000010324, 2.99969783109, 525.7588118315],
    [0.00000014293, 1.06904465002, 477.9157907918],
    [0.00000012341, 4.62813430535, 1894.4190646765],
    [0.00000012539, 3.70404881494, 67.0773507355],
    [0.00000011771, 1.07971321862, 363.5166838784],
    [0.00000011466, 0.9352838604, 121.8427223143],
    [0.00000012839, 0.31988787839, 474.9468453752],
    [0.00000010194, 6.23976471898, 84.1827674285],
    [0.000000123, 2.85238700423, 184.0941479094],
    [0.00000013861, 3.4836768877, 157.2674449664],
    [0.00000011395, 4.2553344068, 181.0557665236],
    [0.00000010146, 6.01371693363, 43.2408450685],
    [0.00000009889, 0.01753733887, 40.1600250673],
    [0.00000010798, 2.4636424394, 140.6563608848],
    [0.00000009893, 2.72219544398, 384.0599212231],
    [0.00000011012, 3.77284307154, 494.2662424425],
    [0.00000010226, 1.49169427598, 80.4106728598],
    [0.00000011981, 2.69741212203, 369.4545747116],
    [0.00000010658, 1.7870288097, 252.0865223816],
    [0.00000012506, 4.66852994807, 64.6991061499],
    [0.0000001164, 5.70405852396, 39.0962434843],
    [0.00000012305, 1.73322306013, 229.0800981171],
    [0.00000009954, 3.72074935511, 233.9060232575],
    [0.00000011004, 3.58723041577, 449.2802922348],
    [0.00000010581, 2.79550711884, 1246.6574718363],
    [0.00000010411, 2.8672714553, 189.1807054807],
    [0.00000009259, 5.1983482312, 749.2098356561],
    [0.00000012468, 0.76477162698, 122.4758617607],
    [0.00000010099, 6.06894682979, 156.1554792736],
    [0.00000012671, 6.19797171716, 149.8238295655],
    [0.00000009053, 0.99447742265, 109.3125493421],
    [0.00000009595, 1.00827882958, 393.4610900843],
    [0.00000010455, 1.23531019351, 148.5999892881],
    [0.00000010645, 5.50399216121, 460.5384408198],
    [0.00000012433, 5.298436616, 20.4950532349],
    [0.00000009002, 5.5121689284, 133.1008708993],
    [0.00000009882, 5.68987366321, 42.5382696529],
    [0.0000001211, 3.14577799081, 30.0562807905],
    [0.0000001038, 3.54528360301, 619.2903584945],
    [0.00000010139, 1.90528799801, 25.0603459444],
    [0.00000011206, 5.8782323899, 832.5894539325],
    [0.00000009283, 3.00514787072, 754.8389099486],
    [0.00000010994, 0.05721003392, 54.2865453324],
    [0.00000008981, 5.82462023723, 248.4631856592],
    [0.00000008634, 5.49123270314, 448.6895914038],
    [0.0000000939, 1.32674472283, 9.4011688612],
    [0.00000009621, 5.6909029939, 73.88782669],
    [0.00000010843, 1.4281264822, 268.4369740323],
    [0.00000010874, 2.6136174199, 446.3113468182],
    [0.00000009681, 4.27051176079, 282.6640680339],
    [0.0000001077, 0.19304986906, 463.5073862364],
    [0.00000008223, 3.30114329151, 172.1971143836],
    [0.00000010216, 5.04428111805, 241.8709035202],
    [0.0000000889, 2.53320903906, 271.4059194489],
    [0.00000010621, 4.39013117792, 63.847772888],
    [0.00000009085, 0.99085954236, 6.9010986797],
    [0.00000010414, 4.96367476854, 97.6761482472],
    [0.00000008382, 5.03764591595, 370.9390474199],
    [0.00000008791, 3.05426995163, 291.262087743],
    [0.00000008629, 0.1467493805, 262.4778313397],
    [0.00000009673, 4.2559733057, 602.9880909536],
    [0.00000007939, 5.71230451368, 541.5398145106],
    [0.00000007981, 2.35900017752, 196.6243208816],
    [0.00000007941, 0.88239951788, 154.979823106],
    [0.00000008212, 0.00845991197, 76.42612997],
    [0.00000010135, 1.90258069764, 91.4563731237],
    [0.00000008948, 4.31891786278, 469.1364605289],
    [0.00000009906, 0.61122653279, 308.3151148093],
    [0.00000008257, 4.61012292958, 69.6737891366],
    [0.00000010291, 3.58217488981, 842.1506814881],
    [0.00000010672, 2.28920805112, 194.2885149114],
    [0.00000009024, 0.70282370018, 685.4739373527],
    [0.00000007552, 4.86800510978, 1097.0942747017],
    [0.00000009496, 1.0666235072, 93.7921790939],
    [0.00000008413, 3.15290837718, 32.7164096664],
    [0.00000008914, 5.03579282562, 450.4559484024],
    [0.00000008008, 4.33420849497, 302.0953396858],
    [0.00000010397, 4.90564475822, 829.6205085159],
    [0.00000007401, 5.67595616187, 337.8019466282],
    [0.00000007419, 3.0467243912, 7.4223635415],
    [0.00000007936, 4.37116642726, 464.4705940829],
    [0.00000009731, 5.703933034, 98.3574718034],
    [0.00000009287, 4.16913084905, 15.4991183888],
    [0.00000010072, 1.18963356664, 621.7380390493],
    [0.00000009867, 1.34469368253, 142.9709149956],
    [0.00000008913, 1.33679256423, 0.2606324309],
    [0.00000008734, 2.03651443558, 149.4031384402],
    [0.00000007745, 0.14834225031, 1404.0849754971],
    [0.00000009037, 3.53203542312, 636.6677084665],
    [0.00000007707, 1.87083579542, 31.6526280834],
    [0.00000008566, 2.4828035791, 497.4476361802],
    [0.00000010074, 2.59066128203, 711.4493070338],
    [0.00000008726, 5.88905195509, 82.2039621088],
    [0.00000009218, 1.10861658464, 412.5835451955],
    [0.00000009483, 6.02304095716, 916.9322800554],
    [0.00000007012, 6.27635752748, 376.1956146969],
    [0.00000009867, 1.9314020472, 62.7726904569],
    [0.00000007121, 1.54192963162, 679.2541622292],
    [0.0000000844, 5.06400284478, 1.3725981237],
    [0.00000008915, 2.39052372377, 76.154196691],
    [0.00000009637, 3.78128664809, 838.218528225],
    [0.00000007059, 5.91499106809, 74.1484591209],
    [0.0000000957, 1.97721363991, 703.6331846174],
    [0.00000007516, 4.87738017916, 310.1720945331],
    [0.00000007059, 1.94098053303, 75.4147380137],
    [0.00000008552, 6.14581140636, 17.6379824029],
    [0.00000006859, 5.11679089849, 107.4980082337],
    [0.00000007148, 1.73466140387, 1190.7858800591],
    [0.00000009112, 0.8836866329, 362.8622925726],
    [0.000000093, 1.44257902224, 763.4369296577],
    [0.00000009073, 4.31998777457, 16.1535096946],
    [0.00000009126, 3.74417347717, 4.665866446],
    [0.00000007869, 4.65596954763, 232.4215505492],
    [0.00000009168, 3.25096522859, 155.5010879678],
    [0.00000007624, 0.88232424215, 459.3627846522],
    [0.000000082, 1.51866334747, 10063.7223490764],
    [0.00000008579, 2.377262345, 75.6753704446],
    [0.00000007595, 2.63499505823, 657.1627617014],
    [0.00000008131, 6.15861249482, 745.277682393],
    [0.00000006398, 0.61376490225, 73.2489417492],
    [0.0000000771, 4.02552779925, 4.7353024152],
    [0.0000000638, 3.20688120531, 73.3453099688],
    [0.00000007505, 0.67397826037, 228.7982138268],
    [0.00000007129, 1.33525552417, 236.8749686741],
    [0.00000007444, 3.05581518163, 171.6545976624],
    [0.00000006361, 6.05108999867, 95.9792272178],
    [0.00000007086, 4.88497877319, 6531.661656265],
    [0.00000006527, 4.0138014903, 118.8737768977],
    [0.00000007984, 1.70695215254, 104.5290628171],
    [0.00000006239, 1.08160874504, 143.9341228421],
    [0.000000072, 1.19830150903, 1617.3840709351],
    [0.0000000639, 4.83649966441, 1072.7152523135],
    [0.00000007857, 3.06062400692, 341.9947323222],
    [0.00000006158, 0.04340975323, 627.3671133418],
    [0.00000008664, 5.60425824325, 2810.9214616052],
    [0.00000006147, 4.16482048084, 1300.9922012785],
    [0.00000008148, 3.1170064191, 10213.285546211],
    [0.00000008603, 3.80404544682, 25558.2121764796],
    [0.00000007586, 2.86885781812, 406.1031376411],
    [0.00000007925, 3.11650504, 81.682697247],
    [0.00000007063, 5.35078594952, 73.0364934281],
    [0.00000006265, 3.27996815317, 116.5379709275],
    [0.00000007345, 0.45699353973, 192.8040422031],
    [0.00000006878, 1.29690429239, 22.633917249],
    [0.00000006102, 2.06174377751, 73.9784494152],
    [0.00000007867, 1.45455437627, 131.9252147317],
    [0.00000006837, 0.07237438837, 90.2807169561],
    [0.0000000774, 2.87078307084, 79.4474650133],
    [0.00000006744, 0.01897075429, 572.2292347475],
    [0.00000006034, 0.96635268225, 476.3194434989],
    [0.00000008276, 2.40596529645, 674.8007441043],
    [0.00000006002, 3.24986200464, 76.7873361374],
    [0.00000006863, 1.24850658686, 400.1652468079],
    [0.00000006375, 1.37050567525, 75.1541055828],
    [0.00000007445, 5.47946546419, 50.66320861],
    [0.00000005889, 5.83364715391, 164.1203595363],
    [0.0000000719, 3.21396813566, 71.1582618449],
    [0.00000006305, 1.65443603478, 70.0462961521],
    [0.00000006628, 1.990437442, 1.5963472929],
    [0.00000006081, 1.2659989053, 61.448276443],
    [0.00000007795, 0.70956881527, 44.070926471],
    [0.00000007784, 5.47416712189, 416.7763308895],
    [0.00000005727, 2.39389303582, 20277.0078952874],
    [0.00000006363, 1.96472326808, 288.7350853111],
    [0.00000005724, 4.3053278397, 86.6304479833],
    [0.00000007348, 5.28008775997, 285.6330134505],
    [0.00000005693, 1.13590287643, 445.3481389717],
    [0.00000005799, 2.43420435064, 180.7951340927],
    [0.00000006927, 4.19297070447, 525.2375469697],
    [0.00000006143, 2.23902465258, 1310.3933701397],
    [0.0000000668, 5.36285833774, 452.4616859725],
    [0.00000005709, 3.65303501856, 442.3791935551],
    [0.00000006238, 4.60538870228, 137.5542890242],
    [0.00000005932, 3.22993254909, 73.4571845534],
    [0.00000007734, 5.72805659987, 154.2984995498],
    [0.00000005782, 2.17577477697, 2.2876218604],
    [0.00000006016, 3.4658554659, 346.3999663373],
    [0.00000007517, 5.63641104589, 549.7284439425],
    [0.00000006685, 4.84971092735, 148.8124376092],
    [0.00000005797, 0.51568102762, 149.3025647037],
    [0.00000007739, 3.23104533276, 589.4947101349],
    [0.0000000759, 2.49504939023, 321.7603115182],
    [0.00000006706, 5.23367324742, 769.8167634756],
    [0.0000000721, 2.56243122515, 375.6743498351],
    [0.00000005491, 1.84139760824, 375.3924655448],
    [0.00000006592, 3.39703193659, 389.6889955156],
    [0.00000006414, 3.56513278405, 488.8496164711],
    [0.00000006376, 0.24081237769, 881.5075574033],
    [0.00000005785, 3.49508162978, 102.523325247],
    [0.00000006079, 0.84517404881, 89.5993933999],
    [0.00000005799, 2.19388408812, 8.9068362498],
    [0.00000005305, 1.977856112, 150.31395666],
    [0.00000005422, 1.21990761182, 332.1728723357],
    [0.00000007235, 2.78896876234, 748.0978699633],
    [0.0000000636, 0.36304095923, 74.4090915518],
    [0.00000005285, 4.41108441808, 12.0089081104],
    [0.00000006602, 3.01699401726, 442.7517005706],
    [0.00000006509, 0.49819168917, 1147.4968508808],
    [0.00000005585, 6.04761249158, 172.4577468145],
    [0.00000006673, 0.77536194908, 6069.7767545534],
    [0.00000007125, 0.34356180793, 511.5954083047],
    [0.00000005288, 4.27462942653, 11.1575748485],
    [0.00000006767, 2.00969662613, 105.380396079],
    [0.00000005611, 2.40776057824, 1286.0143477515],
    [0.00000006456, 4.48699081452, 31.2319369581],
    [0.00000005898, 5.26174074234, 757.8078553652],
    [0.00000005153, 2.41386832919, 742.9900605326],
    [0.00000005087, 6.03592089039, 980.6681783588],
    [0.00000006198, 0.83056505252, 1507.1777497157],
    [0.00000005425, 1.93107713343, 40.8413486235],
    [0.00000006091, 5.18564204379, 487.1045113319],
    [0.00000005715, 1.96802719384, 394.3548619616],
    [0.00000005509, 1.3127509208, 883.7951792637],
    [0.0000000532, 4.22718652038, 65.3804297061],
    [0.00000005357, 1.80483136985, 139.4807047172],
    [0.00000005204, 3.39869589191, 1400.152822234],
    [0.00000006537, 2.31923989568, 328.2407190726],
    [0.00000005041, 2.9467334644, 361.3778198643],
    [0.00000004969, 6.27367198215, 0.1600586944],
    [0.00000005334, 2.78985718428, 217.4436970222],
    [0.00000005654, 0.51056760715, 285.1117485887],
    [0.00000006432, 2.21948959433, 9999.986450773],
    [0.00000005768, 5.10735836078, 216.2680408546],
    [0.00000004977, 2.62435916254, 194.1766403268],
    [0.00000006932, 1.71722863424, 378.9039276826],
    [0.00000005187, 3.04429850681, 1083.7609525774],
    [0.00000005791, 3.9406147625, 550.1378342197],
    [0.00000005816, 2.24843661305, 230.9370778409],
    [0.00000005319, 0.0699882535, 336.8387387817],
    [0.00000005427, 0.30577275388, 40.5807161926],
    [0.00000006469, 3.02579309025, 298.2326223919],
    [0.00000004974, 1.21594265105, 455.0694252217],
    [0.0000000496, 4.7280621023, 454.7493078329],
    [0.00000005619, 2.27500303004, 227.5261894396],
    [0.00000006328, 0.97544932086, 249.9476583675],
    [0.00000005319, 4.59867974067, 454.7974919427],
    [0.00000004791, 4.40360629153, 853.196381752],
    [0.00000006519, 3.03043401282, 167.7224443993],
    [0.0000000545, 6.00971547441, 25.1297819136],
    [0.00000005094, 3.96693309189, 1066.49547719],
    [0.00000005779, 0.65954416303, 272.5815756165],
    [0.00000006491, 4.6852965154, 312.1990839626],
    [0.00000005234, 4.34712255335, 233.533516242],
    [0.00000005396, 5.62885554221, 418.5214360287],
    [0.00000005048, 2.46802064424, 987.5692770385],
    [0.00000006152, 0.79853332272, 2274.5468326365],
    [0.00000006506, 1.7291557512, 125.1841747464],
    [0.00000004993, 3.75975860404, 57.255490749],
    [0.00000006295, 0.84778953014, 10.0824924174],
    [0.00000006251, 4.78782138567, 270.1820791715],
    [0.00000005785, 4.31237764709, 374.4986936675],
    [0.00000005406, 5.49902863401, 632.7837393132],
    [0.00000006224, 0.12733845417, 149.0419322728],
    [0.00000004921, 1.43037646364, 73.1370671646],
    [0.00000005076, 1.34845106372, 455.0212411119],
    [0.0000000573, 3.30386575867, 88.274979386],
    [0.00000004618, 0.64720625124, 119.3950417595],
    [0.00000006213, 2.58827934841, 544.5087599272],
    [0.00000004825, 6.08615765986, 304.1223291153],
    [0.00000004825, 6.00483903794, 226.7924762567],
    [0.00000005528, 5.69752791882, 548.4409131903],
    [0.00000005108, 2.74489127167, 423.6292454594],
    [0.00000005426, 2.44835106987, 531.978586955],
    [0.00000004573, 1.61098293427, 357.4456666012],
    [0.00000004487, 6.09067660554, 204.7010757289],
    [0.00000005866, 6.20513223441, 772.7857088922],
    [0.00000005334, 2.49860553733, 1131.1945833399],
    [0.00000005656, 4.75744184558, 491.8185618877],
    [0.00000004441, 0.23590452375, 35.685355083],
    [0.0000000437, 3.8113649083, 1329.3033769298],
    [0.00000004406, 3.42865095493, 144.8973306886],
    [0.00000005251, 4.72114047741, 535.3200393871],
    [0.00000005174, 1.37807596858, 520.129737539],
    [0.00000004331, 2.64717426456, 1517.2602421331],
    [0.00000004802, 2.6056946352, 177.3049238143],
    [0.00000004368, 3.36272561974, 1503.2455964526],
    [0.00000004335, 2.73379207096, 289.5651667136],
    [0.00000005198, 0.97116582962, 128.4350044533],
    [0.00000004437, 0.56678131875, 253.4591205053],
    [0.00000005386, 5.84886051674, 268.6976064632],
    [0.00000005376, 1.30096148962, 436.8138097374],
    [0.00000005797, 4.33049740199, 208.8456773131],
    [0.00000004353, 1.66111524192, 1261.6353253633],
    [0.00000004812, 4.95769337401, 545.4719677737],
    [0.00000005897, 2.0420120518, 8.5980197091],
    [0.00000005032, 2.8055075977, 360.4146120178],
    [0.00000004921, 2.55658380096, 260.360219185],
    [0.00000004413, 3.23825819993, 973.554631358],
    [0.00000004506, 0.17509624151, 380.3884003909],
    [0.00000004947, 5.50324549675, 365.9006739584],
    [0.00000004174, 2.99974290843, 136.0698163159],
    [0.00000004553, 2.77416673233, 147.9668498417],
    [0.00000005344, 1.81213470593, 521.0929453855],
    [0.00000005155, 0.78324341489, 1670.0742689746],
    [0.00000005133, 1.37435234967, 271.61836777],
    [0.00000005708, 2.52872222038, 501.3797894433],
    [0.00000004933, 1.36454104948, 238.9019581036],
    [0.00000004973, 1.92960964594, 535.9107402181],
    [0.00000004935, 5.04375067678, 697.8071683688],
    [0.00000004129, 1.50064332826, 71.8608372605],
    [0.00000005207, 4.0187736734, 92.4195809702],
    [0.00000004587, 4.78553156868, 95.931043108],
    [0.0000000505, 5.41251268131, 758.7710632117],
    [0.00000005012, 4.50266403888, 635.9651330509],
    [0.00000004248, 0.65406962267, 920.8644333185],
    [0.0000000515, 1.13490701556, 310.9752436852],
    [0.00000004146, 5.54040372231, 1048.3362299253],
    [0.00000004256, 4.20942901957, 25.2727942655],
    [0.00000004569, 5.19758291396, 10.2949407385],
    [0.00000004259, 5.53202386861, 184.9879197867],
    [0.00000004315, 2.80569687202, 213.9534867438],
    [0.00000004604, 2.51643176466, 962.5089310941],
    [0.00000005105, 1.26007002216, 971.1069508032],
    [0.000000045, 6.15796742231, 1052.2683831884],
    [0.00000004095, 0.63467124507, 1321.4390704036],
    [0.00000003968, 0.07377679014, 77.7023598741],
    [0.00000004617, 2.77367751889, 406.954470903],
    [0.00000004899, 4.65767840428, 305.6068018236],
    [0.000000039, 1.66467970991, 945.2434557067],
    [0.00000004133, 3.76396043787, 263.0203480609],
    [0.00000003899, 4.28677450975, 224.2329211173],
    [0.0000000503, 6.24112139981, 1162.4747044078],
    [0.00000005024, 0.39738855487, 968.1380053866],
    [0.00000004894, 2.50422546622, 355.7487455718],
    [0.00000004283, 3.15267059582, 846.0828347512],
    [0.00000003941, 0.04342429962, 1235.6117715724],
    [0.00000004077, 5.6885446997, 695.5564297701],
    [0.00000003842, 0.37429373422, 774.4826299216],
    [0.00000004674, 0.08112657673, 1366.2125722902],
    [0.00000004671, 4.38923533828, 117.36805233],
    [0.00000005313, 4.38472090135, 689.6185389369],
    [0.00000003787, 1.41443617212, 48.9181034708],
    [0.00000004236, 1.60316940746, 367.5975949878],
    [0.00000004569, 2.88138923862, 551.1010420662],
    [0.00000004636, 5.93442268083, 148.1905990109],
    [0.00000005128, 0.17600225009, 433.7117378768],
    [0.00000004264, 2.08657038625, 325.3836482406],
    [0.00000003885, 5.85359840623, 450.7165808333],
    [0.00000004753, 2.58442943928, 358.4088744477],
    [0.00000004226, 6.24596640453, 448.9714756941],
    [0.00000003776, 1.78756451192, 71.7007785661],
    [0.00000004912, 4.45665056284, 51.8870488874],
    [0.00000003854, 2.72138633161, 151.850818995],
    [0.00000004561, 0.07201979569, 2349.3284312038],
    [0.00000004291, 5.39929339966, 523.7530742614],
    [0.00000004143, 0.1715886627, 735.8765135318],
    [0.00000003806, 1.44358694049, 138.6293714553],
    [0.00000003654, 2.41520715554, 348.8476468921],
    [0.00000003728, 1.69745141654, 984.7122062065],
    [0.00000004176, 4.01139155515, 195.7729876197],
    [0.00000004986, 1.0356290592, 224.4566702865],
    [0.00000004031, 0.92145122185, 76.0054388447],
    [0.00000004098, 3.51214223942, 72.4939767069],
    [0.00000003812, 4.41246815759, 1511.3223512999],
    [0.00000004098, 2.39702785276, 239.1625905345],
    [0.00000004894, 5.26621064696, 601.5036182453],
    [0.00000004459, 5.76440378473, 836.5216071956],
    [0.00000004373, 4.08948598951, 75.4359898731],
    [0.00000004363, 6.01127167247, 421.1815649046],
    [0.00000004414, 0.358306616, 168.3131452303],
    [0.000000037, 2.04103813925, 63.2146334416],
    [0.00000004648, 2.07482117651, 1106.6555022573],
    [0.00000004304, 3.03122452327, 1109.6244476739],
    [0.00000003618, 4.84400847177, 893.3564068193],
    [0.00000004023, 0.59685650686, 91.2439248026],
    [0.00000004937, 5.49417275871, 976.7360250957],
    [0.00000004373, 3.76648561161, 74.1272072615],
    [0.0000000431, 3.72983787822, 673.316271396],
    [0.0000000468, 3.8963125415, 163.5778428151],
    [0.00000004172, 0.75349427039, 1500.0642027149],
    [0.00000004492, 1.87283145714, 141.1776257466],
    [0.00000004174, 5.82910805335, 346.4481504471],
    [0.00000003775, 0.83052387256, 827.9235874865],
    [0.00000003481, 2.70828672792, 818.574808252],
    [0.00000004853, 0.95917381603, 58.1705144857],
    [0.00000004021, 3.11274455034, 377.4194549743],
    [0.00000004409, 0.16607520728, 630.3360587584],
    [0.00000003597, 1.02560564654, 515.463871093],
    [0.00000003444, 1.38488805947, 117.3198682202],
    [0.00000004021, 5.68447974866, 3.4902102784],
    [0.00000004244, 3.75845344717, 733.428832977],
    [0.00000003933, 4.55157642432, 240.125798381],
    [0.00000004421, 1.51263319894, 1610.2705239343],
    [0.0000000339, 4.00215380112, 74.9940468884],
    [0.00000004556, 3.41531360529, 1140.38330388],
    [0.00000004171, 0.76417016678, 623.4349600787],
    [0.00000003441, 2.56450835637, 14.8177948326],
    [0.00000003587, 4.10186965494, 343.2185725996],
    [0.00000003997, 5.74857613262, 6212.2264046872],
    [0.00000004215, 0.84469743228, 176.6505325085],
    [0.00000004098, 1.41920746453, 559.6990617753],
    [0.00000004553, 1.09016692751, 561.8861098992],
    [0.00000003493, 0.11837510368, 1031.87390369],
    [0.00000003596, 5.33968666729, 394.9455627926],
    [0.00000003501, 5.53309359866, 594.9113361063],
    [0.00000003564, 1.57868308864, 354.9979860464],
    [0.00000004279, 2.35436288262, 562.6680071919],
    [0.00000003398, 1.6208634854, 941.3113024436],
    [0.00000003803, 1.78948693511, 251.1714986449],
    [0.00000003299, 5.13631478768, 477.0007670551],
    [0.00000003422, 3.55674695079, 256.4280659219],
    [0.00000003802, 4.09287840097, 268.9582388941],
    [0.00000003818, 4.64162443046, 71.9245277353],
    [0.00000004623, 2.72836206211, 6244.9428143536],
    [0.00000003466, 1.91387688001, 58.7399634573],
    [0.00000003435, 2.96178782926, 995.6460318858],
    [0.00000003626, 5.35614681493, 57.5161231799],
    [0.00000004512, 1.18350543284, 170.7608257851],
    [0.00000004378, 0.273460377, 469.7271613599],
    [0.00000003323, 4.51516827363, 454.8611824175],
    [0.0000000332, 1.42938752044, 454.9575506371],
    [0.00000004578, 4.7498051473, 731.9443602687],
    [0.00000003249, 0.67719975914, 74.0478853844],
    [0.00000004145, 5.58064267022, 57.7980074702],
    [0.00000003512, 6.09122971288, 70.5888128733],
    [0.00000003814, 2.49565462974, 6204.362098161],
    [0.00000003828, 4.39751907192, 586.3133163972],
    [0.00000003639, 4.85097208169, 138.4056222861],
    [0.00000003518, 0.52105043625, 262.8078997398],
    [0.00000003671, 1.99667387765, 511.5317178299],
    [0.00000003215, 0.64628330219, 887.7273325268],
    [0.00000003718, 3.27473813045, 454.6487340964],
    [0.00000003638, 2.63250736806, 455.1699989582],
    [0.00000003772, 0.88810300052, 10142.4361009068],
    [0.0000000319, 4.87960158471, 455.6601260527],
    [0.00000003669, 4.11456655271, 409.9234163196],
    [0.00000003166, 1.24948126394, 82.6459050935],
    [0.0000000353, 4.02075420346, 388.2045228073],
    [0.00000003163, 1.65294183878, 765.8846102125],
    [0.00000003568, 5.95965909592, 460.8472573605],
    [0.0000000345, 0.08821515281, 49.1787359017],
    [0.0000000327, 1.81146731641, 34.2008823747],
    [0.00000003188, 1.74587038709, 18.9100067901],
    [0.00000003305, 5.77382040863, 10.5244354021],
    [0.00000003345, 4.15802505352, 1515.7757694248],
    [0.0000000316, 1.06549289762, 454.1586070019],
    [0.00000003525, 2.56091667232, 78114.14622758799],
    [0.00000004124, 1.06751791085, 388.4651552382],
    [0.00000004016, 2.48751669586, 531.1754378029],
    [0.00000003147, 5.05814757549, 1521.4048437173],
    [0.0000000418, 1.16833674781, 514.5643537213],
    [0.00000003212, 3.18682610058, 1512.8068240082],
    [0.00000003486, 0.22630227172, 36.5366883449],
    [0.00000004211, 3.21876950029, 761.7400086283],
    [0.00000003485, 3.26177495276, 36.7604375141],
    [0.00000003506, 6.26633354904, 545.2750258176],
    [0.00000003733, 2.55776517455, 279.4826742962],
    [0.00000004227, 1.41381723926, 41.7563723602],
    [0.00000003187, 1.62296832026, 138.4693127609],
    [0.00000003934, 2.86731965547, 832.0681890707],
    [0.00000003684, 3.941740603, 179.3106613844],
    [0.00000003115, 5.67364420834, 73.5577582899],
    [0.00000003663, 1.80556740809, 31.5407534988],
    [0.00000003171, 4.85529878165, 138.5656809805],
    [0.00000003777, 5.94890597104, 873.1701701251],
    [0.00000004357, 4.15105623366, 10175.1525105732],
    [0.00000003951, 1.60185888278, 576.1613880106],
    [0.00000003525, 4.8031643597, 429.7795846137],
    [0.0000000333, 5.62171319933, 1116.0042814918],
    [0.00000003943, 4.6264154302, 898.7730327907],
    [0.00000003382, 1.45717307307, 5983.9494557222],
    [0.00000003215, 3.73878297941, 335.7749571987],
    [0.00000003423, 5.07987216951, 143.3434220111],
    [0.00000004161, 5.39091883238, 1363.2436268736],
    [0.00000003457, 3.94796907904, 444.8268741099],
    [0.00000003593, 3.91831549069, 10134.5717943806],
    [0.00000003666, 4.2262033899, 36.1754821775],
    [0.0000000358, 3.43130119859, 912.7876784712],
    [0.000000037, 0.67445695843, 73.9302653054],
    [0.00000003679, 1.10949079061, 686.958410061],
    [0.00000003547, 5.63096398237, 440.8947208468],
    [0.00000003622, 1.10742531477, 2250.1678102483],
    [0.00000003562, 3.80604468765, 1525.3369969804],
    [0.0000000333, 1.76480149289, 78.9743842613],
    [0.00000003738, 1.7675491018, 384.5811860849],
    [0.00000003986, 1.0684287447, 743.7932096847],
    [0.00000003032, 5.77852412826, 612.1768114937],
    [0.00000003008, 0.64086342534, 210.8514148832],
    [0.00000003334, 4.81681647959, 597.3590166611],
    [0.00000003141, 3.11768616608, 6607.9277275406],
    [0.00000003022, 2.08709314702, 34.5309507748],
    [0.00000003226, 3.19780030434, 377.6800874052],
    [0.00000004065, 3.53637930424, 402.2191684878],
    [0.00000004138, 0.28927701421, 517.1607921224],
    [0.00000003697, 0.89932694516, 75.6329318292],
    [0.00000003918, 5.73859894835, 94.4253185403],
    [0.00000003374, 0.4097440558, 677.7696895209],
    [0.00000003194, 4.56998602897, 1385.174968707],
    [0.0000000318, 1.03370427552, 885.4397106664],
    [0.00000003235, 5.09681747179, 464.9918589447],
    [0.00000003798, 5.76464888795, 586.377006872],
    [0.00000003173, 5.68964342749, 4.192785694],
    [0.00000003181, 2.87968862974, 9914.1591519418],
    [0.00000003355, 5.45857968674, 73.0846775379],
    [0.00000002899, 5.12928266291, 448.3170843883],
    [0.00000003706, 2.47342147635, 64.2571631652],
    [0.00000003796, 4.29502458131, 164.5410506616],
    [0.00000003534, 4.42464754991, 46.470422916],
    [0.00000003488, 5.62713714766, 3189.5647568569],
    [0.0000000294, 4.33606107945, 78263.70942472259],
    [0.00000003309, 3.10770680369, 519.6084726772],
    [0.0000000403, 4.41794838679, 772.5887669361],
    [0.00000002867, 5.17129632099, 346.1875180162],
    [0.00000003842, 1.87994191354, 299.7170951002],
    [0.00000003846, 5.38315286213, 980.146913497],
    [0.00000003724, 4.94511644698, 984.4884570373],
    [0.00000002814, 2.17260061398, 191.3195694948],
    [0.00000003392, 3.0855211609, 245.4942402426],
    [0.00000002923, 0.37358823115, 6.4804075544],
    [0.00000003025, 1.19297242418, 104.8378793578],
    [0.0000000347, 1.89084704021, 44.6134431922],
    [0.00000002931, 0.78809830626, 540.0553418023],
    [0.00000003707, 4.14868763219, 6136.4815982734],
    [0.00000003931, 5.52289695589, 6171.6456884946],
    [0.00000003056, 2.97000936733, 250.6020496733],
    [0.00000003117, 0.76332399369, 229.4526051326],
    [0.00000003091, 4.9194127978, 221.1634019642],
    [0.00000003378, 3.82658652472, 25936.85547173129],
    [0.00000003041, 2.14503983522, 6604.958782124],
    [0.00000002865, 0.53734608663, 273.8536000037],
    [0.00000002845, 0.34922064899, 85.9391734158],
    [0.00000003657, 6.02755271763, 340.8827666294],
    [0.00000002818, 4.44508352472, 369.342700127],
    [0.00000002861, 2.19284349075, 295.1942410061],
    [0.00000002865, 3.21935127992, 3.8202786785],
    [0.00000002797, 5.97725967979, 2014.0265547571],
    [0.0000000328, 0.74832416123, 422.7142217227],
    [0.00000003509, 1.92501559437, 343.4792050305],
    [0.00000002962, 2.29867992492, 661.1586054393],
    [0.00000003485, 4.5320530238, 676.2852168126],
    [0.00000002836, 1.2077968366, 1119.1856752295],
    [0.00000003603, 2.72183511139, 508.6264628881],
    [0.0000000362, 5.57691156197, 10066.691294493],
    [0.00000002731, 0.9666341177, 582.3811631341],
    [0.00000003306, 6.20620840278, 11.5669651257],
    [0.00000003279, 6.13563821647, 276.0717858949],
    [0.00000002747, 4.5747626302, 226.6324175623],
    [0.00000002825, 1.24120423378, 989.0537497468],
    [0.00000002707, 0.46257342768, 1458.472094566],
    [0.00000002755, 5.43548338507, 246.9787129509],
    [0.00000003338, 3.98641322371, 488.5889840402],
    [0.0000000296, 5.31788128818, 1467.0701142751],
    [0.00000003062, 1.93542241882, 987.7817253596],
    [0.00000003504, 4.10521239427, 6280.1069045748],
    [0.00000003584, 3.12196206517, 108.7218485111],
    [0.00000002975, 0.13746189123, 9987.4562778008],
    [0.00000002634, 5.61201014857, 412.3710968744],
    [0.00000003702, 0.66231252049, 10101.8553847142],
    [0.00000003261, 4.39228048501, 75.3722993983],
    [0.00000002939, 3.2631997985, 130.552616608],
    [0.00000002742, 6.24317126103, 447.2051186955],
    [0.00000003008, 4.24451493185, 170.1701249541],
    [0.00000003001, 2.45489658954, 230.8252032563],
    [0.00000002722, 4.98348297926, 754.0357607965],
    [0.00000002928, 5.73784691627, 14.6690369863],
    [0.00000002699, 2.98043546816, 27.7204748203],
    [0.00000003678, 3.46436124301, 26468.0309095342],
    [0.000000035, 4.41810854452, 322.6116447801],
    [0.00000002943, 3.58544468129, 12489.8856287072],
    [0.00000002894, 2.2699912084, 1615.8995982268],
    [0.00000002679, 1.32002304425, 236.1936451179],
    [0.00000002711, 1.25250599577, 52250.5878817157],
    [0.00000002573, 4.41371056719, 262.0571402144],
    [0.00000003483, 1.97113718781, 655.938921424],
    [0.000000026, 3.8010722697, 70.6369969831],
    [0.0000000328, 1.75059058234, 683.9894646444],
    [0.0000000326, 3.46047977615, 74.1908977363],
    [0.00000003097, 5.47452034532, 302.3772239761],
    [0.00000002565, 3.47443238116, 2042.4977891028],
    [0.00000003158, 4.58160924364, 12492.8545741238],
    [0.00000003373, 5.52806001629, 10210.3166007944],
    [0.00000002619, 4.43681016753, 949.1756089698],
    [0.0000000329, 1.35055242247, 515.6763194141],
    [0.0000000318, 4.49938964982, 694.8382229522],
    [0.00000002558, 5.07921716363, 197.7999770492],
    [0.00000002902, 2.61388996483, 115.3623147599],
    [0.00000002586, 4.09771865336, 1448.9108670104],
    [0.0000000316, 4.82168102018, 714.6788848813],
    [0.00000003016, 3.16691101108, 385.7568422525],
    [0.00000003001, 3.24181300229, 1618.8685436434],
    [0.00000003319, 5.98200177347, 533.8355666788],
    [0.00000003307, 3.31452419197, 732.97125859],
    [0.0000000253, 0.13809025963, 591.9423906897],
    [0.00000002975, 5.72770980032, 1011.4270345649],
    [0.00000002857, 4.11031053901, 2267.4332856357],
    [0.00000003091, 4.87979664891, 582.641795565],
    [0.00000003422, 6.18592254593, 281.4884118663],
    [0.00000002501, 0.50645055144, 29.226199388],
    [0.00000003502, 0.17203520151, 371.5297482509],
    [0.00000002607, 3.51828908958, 112.3933693433],
    [0.00000002547, 4.45612695304, 901.2207133455],
    [0.00000002778, 4.97805873371, 132.5796060375],
    [0.00000002476, 1.55163657371, 1234.1272988641],
    [0.00000002929, 2.34725672182, 273.1510245881],
    [0.00000002724, 5.73177362443, 688.6553310904],
    [0.00000002667, 6.13733078138, 161.4120465506],
    [0.00000002877, 5.47506403197, 1436.5407527326],
    [0.00000002779, 1.54196175338, 680.0573113813],
    [0.00000002427, 4.6491343131, 392.6579409322],
    [0.00000003223, 2.57976952494, 267.5856407704],
    [0.0000000275, 1.29662662582, 108.982480942],
    [0.0000000322, 1.0629018794, 388.7257876691],
    [0.00000003236, 3.47802643973, 283.6272758804],
    [0.00000003027, 5.38233284458, 44.0921783304],
    [0.0000000283, 5.70274947128, 327.4375699205],
    [0.00000002768, 5.4225616879, 482.2573343321],
    [0.0000000323, 5.65661970187, 134.3728952865],
    [0.00000002685, 5.03687735302, 763.2244813366],
    [0.00000002441, 5.19830386978, 380.2396425446],
    [0.00000002608, 3.11386505876, 578.449009871],
    [0.00000002465, 1.4924267283, 141.6988906084],
    [0.00000002332, 3.19371804203, 683.0262567979],
    [0.00000002307, 4.07685834192, 78.9262001515],
    [0.0000000228, 2.52476606956, 156.6767441354],
    [0.0000000226, 6.23958645351, 400.5746370851],
    [0.00000002301, 2.47762267951, 107.918699359],
    [0.00000003089, 5.69639540598, 537.3952129264],
    [0.00000003074, 1.16740737548, 58.6280888727],
    [0.00000002846, 0.02430566936, 563.3705826075],
    [0.00000002423, 4.24559706691, 27.7417266797],
    [0.0000000267, 3.48404619442, 123.0183784819],
    [0.00000002228, 3.33159258912, 1257.7031721002],
    [0.00000002445, 2.29979337782, 280.2163874791],
    [0.0000000226, 3.85026258012, 753.1419889192],
    [0.00000002195, 4.94038065567, 1222.2784494481],
    [0.00000002579, 1.76841912074, 710.7467316182],
    [0.00000002402, 4.47942458428, 569.0478410098],
    [0.00000002181, 5.39048760967, 318.679491517],
    [0.00000002317, 6.27946729049, 493.0424021651],
    [0.0000000242, 3.66436222896, 3.6233367224],
];

const VSOP87_R1: Vsop87Element = [
    [0.0147989637, 3.67205705317, 74.7815985673],
    [0.00071212085, 6.22601006675, 63.7358983034],
    [0.00068626972, 6.13411265052, 149.5631971346],
    [0.00020857262, 5.24625494219, 11.0457002639],
    [0.00021468152, 2.6017670427, 76.2660712756],
    [0.00024059649, Math.PI],
    [0.00011405346, 0.01848461561, 70.8494453042],
    [0.00007496775, 0.42360033283, 73.297125859],
    [0.000042438, 1.41692350371, 85.8272988312],
    [0.00003505936, 2.58354048851, 138.5174968707],
    [0.00003228835, 5.25499602896, 3.9321532631],
    [0.00003926694, 3.15513991323, 71.8126531507],
    [0.0000306001, 0.15321893225, 1.4844727083],
    [0.00003578446, 2.31160668309, 224.3447957019],
    [0.00002564251, 0.98076846352, 148.0787244263],
    [0.00002429445, 3.99440122468, 52.6901980395],
    [0.00001644719, 2.65349313124, 127.4717966068],
    [0.00001583766, 1.43045619196, 78.7137518304],
    [0.00001413112, 4.57461892062, 202.2533951741],
    [0.00001489525, 2.67559167316, 56.6223513026],
    [0.00001403237, 1.36985349744, 77.7505439839],
    [0.0000122822, 1.04703640149, 62.2514255951],
    [0.00001508028, 5.05996325425, 151.0476698429],
    [0.00000992085, 2.17168865909, 65.2203710117],
    [0.00001032731, 0.26459059027, 131.4039498699],
    [0.00000861867, 5.05530802218, 351.8165923087],
    [0.00000744445, 3.07640148939, 35.1640902212],
    [0.00000604362, 0.90717667985, 984.6003316219],
    [0.00000646851, 4.4729042291, 70.3281804424],
    [0.0000057471, 3.23070708457, 447.7958195265],
    [0.0000068747, 2.49912565674, 77.962992305],
    [0.00000623602, 0.8625307382, 9.5612275556],
    [0.00000527794, 5.15136007084, 2.9689454166],
    [0.00000561839, 2.7177815898, 462.0229135281],
    [0.00000530364, 5.91655309045, 213.299095438],
    [0.0000046008, 4.22302465979, 12.5301729722],
    [0.0000049428, 0.46291078127, 145.6310438715],
    [0.00000487336, 0.70614146398, 380.12776796],
    [0.00000380908, 3.85089591694, 3.1813937377],
    [0.00000444352, 2.15558291251, 67.6680515665],
    [0.000003388, 2.53820897704, 18.1592472647],
    [0.00000372947, 5.05141251694, 529.6909650946],
    [0.00000348345, 1.74874852104, 71.6002048296],
    [0.00000405881, 1.229617276, 22.0914005278],
    [0.00000268913, 6.24069521597, 340.7708920448],
    [0.00000255585, 2.95695013627, 84.3428261229],
    [0.00000259465, 3.92053708924, 59.8037450403],
    [0.00000224731, 3.90961468562, 160.6088973985],
    [0.0000022171, 3.64727173951, 137.0330241624],
    [0.00000254591, 3.50411592815, 38.1330356378],
    [0.0000023829, 2.04879982674, 269.9214467406],
    [0.00000272355, 3.38363105223, 222.8603229936],
    [0.00000200648, 1.24861003313, 69.3649725959],
    [0.00000234153, 0.27825220612, 108.4612160802],
    [0.00000188515, 4.41307507326, 265.9892934775],
    [0.00000211691, 0.68027381802, 111.4301614968],
    [0.00000205946, 1.53379817229, 284.1485407422],
    [0.00000196179, 4.77152996605, 299.1263942692],
    [0.00000153102, 5.21761881347, 209.3669421749],
    [0.00000162563, 4.3405435361, 33.6796175129],
    [0.00000150563, 1.98966326297, 54.1746707478],
    [0.00000137012, 0.40323866041, 195.1398481733],
    [0.00000117171, 0.39649791652, 87.3117715395],
    [0.00000127913, 2.40333045173, 39.6175083461],
    [0.00000104218, 2.92152185788, 134.5853436076],
    [0.00000103862, 1.81622936156, 72.3339180125],
    [0.00000105741, 0.17067407327, 79.2350166922],
    [0.00000106419, 0.69799543514, 2.4476805548],
    [0.00000095326, 4.02880266738, 82.8583534146],
    [0.00000104772, 4.43616414428, 305.3461693927],
    [0.00000093825, 5.01823592717, 51.2057253312],
    [0.00000103739, 2.57553519741, 191.2076949102],
    [0.00000106679, 1.22996874093, 225.8292684102],
    [0.00000093452, 3.09274255916, 77.2292791221],
    [0.00000097398, 3.81380841075, 152.5321425512],
    [0.00000084583, 5.72473747348, 68.8437077341],
    [0.00000077395, 0.08281157747, 45.5766510387],
    [0.00000076207, 4.20384370842, 73.8183907208],
    [0.00000086249, 0.53131085736, 145.1097790097],
    [0.00000075795, 3.78559826812, 75.7448064138],
    [0.00000077592, 1.63628139623, 479.2883889155],
    [0.00000084612, 0.6166245601, 116.4260963429],
    [0.00000100209, 4.94084867643, 120.358249606],
    [0.00000072142, 4.30505812564, 565.1156877467],
    [0.00000070733, 2.38450718488, 60.7669528868],
    [0.00000071585, 3.93906647867, 153.4953503977],
    [0.00000084566, 5.56037336584, 344.7030453079],
    [0.00000063556, 1.93742986679, 41.6444977756],
    [0.00000071619, 3.71213491656, 408.4389436113],
    [0.00000061594, 3.90006698249, 4.4534181249],
    [0.00000064973, 1.55845503407, 106.9767433719],
    [0.00000059913, 0.60110866128, 74.8934731519],
    [0.00000062, 4.39369268007, 453.424893819],
    [0.00000063361, 4.19159979468, 184.7272873558],
    [0.00000062301, 3.23773103318, 422.6660376129],
    [0.00000054427, 3.72545550857, 7.1135470008],
    [0.00000052474, 6.08562717749, 404.5067903482],
    [0.00000059073, 1.55568469603, 456.3938392356],
    [0.00000052597, 3.5049223397, 125.9873238985],
    [0.00000052835, 5.20100035142, 358.9301393095],
    [0.00000058123, 5.33480562448, 220.4126424388],
    [0.00000052909, 4.44819701196, 426.598190876],
    [0.00000050934, 0.526385342, 490.3340891794],
    [0.00000054968, 1.60146090981, 14.977853527],
    [0.00000049491, 4.25534603275, 5.4166259714],
    [0.00000051303, 0.36772379136, 206.1855484372],
    [0.00000051821, 1.75832999538, 8.0767548473],
    [0.00000056964, 0.84114552694, 146.594251718],
    [0.00000049109, 0.94061875871, 99.1606209555],
    [0.00000046361, 5.35115472594, 152.7445908723],
    [0.00000048023, 1.97249712347, 288.0806940053],
    [0.00000043772, 3.03713403879, 20.6069278195],
    [0.00000049493, 5.84619560979, 112.9146342051],
    [0.00000041987, 0.04620500196, 128.9562693151],
    [0.00000048628, 3.62817742782, 81.0013736908],
    [0.00000041472, 2.33730376429, 277.0349937414],
    [0.00000039983, 5.09525356576, 35.4247226521],
    [0.00000041948, 2.51050760642, 24.3790223882],
    [0.00000038325, 3.61946898382, 173.9422195228],
    [0.00000038385, 2.0600322013, 333.657345044],
    [0.00000042597, 1.260887373, 1514.2912967165],
    [0.00000038855, 0.74239364306, 347.8844390456],
    [0.00000038535, 4.95064283065, 92.940845832],
    [0.00000033234, 1.38358507432, 74.6697239827],
    [0.00000033788, 3.68407945156, 66.9172920411],
    [0.00000038953, 5.49236040328, 200.7689224658],
    [0.0000003185, 0.53990592534, 203.7378678824],
    [0.0000003332, 6.26012644668, 1059.3819301892],
    [0.00000030806, 2.53797566903, 977.4867846211],
    [0.00000029198, 5.43116906, 58.1068240109],
    [0.00000030059, 0.19481555617, 387.2413149608],
    [0.00000028997, 3.10546504714, 991.7138786227],
    [0.0000003564, 3.72863820177, 96.8729990951],
    [0.00000027607, 0.37142052647, 80.1982245387],
    [0.00000032492, 4.38403518987, 221.3758502853],
    [0.00000027029, 1.35552416596, 0.9632078465],
    [0.00000031276, 0.79566430555, 373.0142209592],
    [0.00000031122, 2.05381353845, 230.5645708254],
    [0.00000025883, 3.46808071409, 144.1465711632],
    [0.00000030201, 0.71392007232, 109.9456887885],
    [0.00000024688, 3.04162764358, 14.0146456805],
    [0.00000027882, 4.76559523368, 415.5524906121],
    [0.0000002511, 5.12405829717, 81.3738807063],
    [0.00000025582, 2.56904073164, 522.5774180938],
    [0.00000024351, 2.2028905975, 628.8515860501],
    [0.00000025479, 1.795218773, 143.6253063014],
    [0.00000024182, 5.67160913092, 443.8636662634],
    [0.00000025679, 5.43185950751, 546.956440482],
    [0.00000024177, 5.59982039849, 32.1951448046],
    [0.00000024428, 3.30271734903, 617.8058857862],
    [0.00000023535, 0.65842590604, 46.2097904851],
    [0.00000022371, 4.82094751058, 135.5485514541],
    [0.00000027179, 2.02720001624, 536.8045120954],
    [0.00000022213, 4.6166462422, 391.1734682239],
    [0.00000021973, 4.59216260632, 241.6102710893],
    [0.00000020813, 0.24392941148, 465.9550667912],
    [0.00000027264, 2.15210992383, 140.001969579],
    [0.00000021356, 5.27168432406, 159.1244246902],
    [0.00000023632, 4.94972840898, 561.1835344836],
    [0.00000024921, 0.54550733267, 181.7583419392],
    [0.00000023027, 3.80632203913, 55.1378785943],
    [0.00000019799, 1.30259938601, 518.6452648307],
    [0.00000019252, 1.31448491434, 543.0242872189],
    [0.00000019704, 4.90869636976, 909.8187330546],
    [0.00000020801, 0.91178207093, 76.4785195967],
    [0.00000019876, 0.66494008343, 66.70484372],
    [0.00000018957, 4.67998817036, 98.8999885246],
    [0.00000025913, 4.52903186569, 454.9093665273],
    [0.00000021888, 1.2337293174, 41.1019810544],
    [0.00000018703, 6.09640927844, 103.0927742186],
    [0.00000018207, 0.97283864525, 55.6591434561],
    [0.00000021247, 4.19373732137, 329.7251917809],
    [0.00000019408, 4.314682308, 6.2197751235],
    [0.00000018497, 5.78624335074, 142.4496501338],
    [0.00000022588, 5.84591645052, 297.6419215609],
    [0.0000001677, 6.09084656811, 211.8146227297],
    [0.00000016432, 2.5000846902, 61.2882177486],
    [0.00000020361, 3.16137245375, 186.2117600641],
    [0.00000015955, 2.98317221345, 81.8951455681],
    [0.00000018953, 6.01226591746, 155.7829722581],
    [0.00000017686, 4.82613965176, 273.1028404783],
    [0.00000015141, 3.65588411561, 472.1748419147],
    [0.0000001844, 3.47582817224, 36.6485629295],
    [0.00000016303, 0.13086415177, 554.0699874828],
    [0.00000018633, 0.23932740251, 23.5758732361],
    [0.00000014352, 2.69389896537, 70.1157321213],
    [0.0000001519, 2.43789398875, 486.4019359163],
    [0.00000014002, 5.12389205028, 29.2049475286],
    [0.00000015758, 4.24947053051, 146.3818033969],
    [0.00000014125, 1.55719788547, 110.2063212194],
    [0.00000017477, 1.94549668506, 835.0371344873],
    [0.00000013691, 1.63831110442, 92.0470739547],
    [0.00000013801, 0.13721153975, 235.3904959658],
    [0.00000013573, 2.85427895075, 49.5088043018],
    [0.00000012563, 3.20921738646, 100.3844612329],
    [0.0000001239, 2.88595800082, 60.5545045657],
    [0.00000014986, 0.32593957273, 259.5088859231],
    [0.00000012922, 2.77565630582, 105.4922706636],
    [0.00000012323, 3.36427641421, 440.6822725257],
    [0.00000015233, 0.2558984518, 258.8757464767],
    [0.00000012106, 0.10857558014, 157.6399519819],
    [0.00000012883, 0.30655541587, 124.2904028691],
    [0.000000109, 3.42905554547, 33.1371007917],
    [0.00000011206, 4.98840478043, 604.4725636619],
    [0.00000010812, 3.86253020441, 767.3690829208],
    [0.00000011561, 2.60450144944, 166.828672522],
    [0.000000102, 5.27810824796, 264.5048207692],
    [0.00000010926, 0.64149188846, 558.0021407459],
    [0.00000012315, 4.33998516461, 16.6747745564],
    [0.00000009946, 0.67298666287, 31.492569389],
    [0.00000012641, 4.83194943583, 114.3991069134],
    [0.00000010479, 0.20404797652, 275.5505210331],
    [0.00000011291, 0.96120625051, 373.9079928365],
    [0.00000012144, 1.91712815063, 378.6432952517],
    [0.00000012229, 0.7046545467, 218.4069048687],
    [0.00000010753, 5.74480767273, 88.1149206916],
    [0.00000009481, 0.65566927406, 353.301065017],
    [0.00000011006, 2.62953946665, 154.0166152595],
    [0.00000009113, 2.99457723478, 681.5417840896],
    [0.00000010429, 2.33056994007, 132.8884225782],
    [0.00000009169, 4.79284571455, 216.4804891757],
    [0.00000009341, 0.75923548315, 129.9194771616],
    [0.00000008917, 0.78008399009, 67.3592350258],
    [0.00000008757, 6.12717748848, 150.5264049811],
    [0.00000009637, 2.88664912193, 67.8804998876],
    [0.00000010465, 0.36943456465, 699.7010313543],
    [0.00000009301, 1.49620591593, 19.643719973],
    [0.00000009367, 5.26481516822, 80.7194894005],
    [0.00000010076, 3.56540311122, 278.5194664497],
    [0.00000009455, 3.06088968751, 149.6750717192],
    [0.00000009168, 3.02528121597, 162.0933701068],
    [0.00000008395, 2.1845500165, 342.2553647531],
    [0.00000009233, 5.32613442062, 152.0108776894],
    [0.00000009786, 2.43713607191, 75.3028634291],
    [0.00000010029, 0.81917102953, 339.2864193365],
    [0.00000009429, 1.93671715384, 147.1155165798],
    [0.00000007861, 4.71717822837, 106.0135355254],
    [0.00000008813, 0.01616162513, 42.5864537627],
    [0.00000007808, 0.61104170424, 135.336103133],
    [0.00000008193, 2.59644466423, 469.1364605289],
    [0.00000010084, 2.58619215129, 50.4025761791],
    [0.00000008574, 5.69115937472, 760.25553592],
    [0.00000007525, 2.64764195045, 5.9378908332],
    [0.00000008699, 0.54050826161, 66.1835788582],
    [0.00000008027, 1.94079002321, 180.2738692309],
    [0.00000007547, 5.94593031762, 97.4155158163],
    [0.00000007597, 5.80197738402, 450.9772132642],
    [0.00000008666, 3.69933873164, 300.6108669775],
    [0.00000007685, 1.47377256329, 32.2433289144],
    [0.00000008195, 2.30769657654, 254.9435932136],
    [0.00000008473, 1.27680705911, 39.3568759152],
    [0.00000007026, 0.68091865104, 874.3940104025],
    [0.00000008898, 0.16273040357, 43.1289704839],
    [0.00000007205, 4.9817753104, 117.9105690512],
    [0.00000007389, 4.09295183164, 92.3077063856],
    [0.00000007314, 5.04313738379, 756.3233826569],
    [0.00000008454, 1.22026161161, 79.4474650133],
    [0.00000006925, 6.04100189247, 350.3321196004],
    [0.00000008793, 1.33398658801, 48.7580447764],
    [0.0000000727, 3.32609286227, 68.1893164283],
    [0.00000006825, 4.77832275072, 142.6620984549],
    [0.00000006816, 3.90452052962, 480.7728616238],
    [0.00000007062, 1.27536949417, 68.5618234438],
    [0.00000007947, 4.29940380231, 624.919432787],
    [0.00000006741, 5.43264472273, 610.6923387854],
    [0.00000006529, 5.43599941795, 88.7962442478],
    [0.00000007635, 4.81180007736, 312.4597163935],
    [0.00000007235, 3.18370421558, 268.4369740323],
    [0.00000008133, 1.98936178361, 692.5874843535],
    [0.00000006477, 1.05238958778, 685.4739373527],
    [0.0000000663, 1.37656948077, 291.262087743],
    [0.00000006878, 2.59188446778, 282.6640680339],
    [0.00000007123, 5.79744758808, 468.2426886516],
    [0.0000000632, 2.58497126634, 458.090760265],
    [0.00000006222, 5.68982546821, 113.8778420516],
    [0.00000007635, 0.49482302003, 296.1574488526],
    [0.00000008521, 0.00576688485, 227.3137411185],
    [0.0000000652, 3.99093726386, 42.5382696529],
    [0.00000006435, 1.03721543102, 365.9006739584],
    [0.00000006107, 0.35071886662, 148.5999892881],
    [0.00000008199, 1.13448902886, 69.1525242748],
    [0.00000006102, 0.94101111641, 13.3333221243],
    [0.00000005989, 4.98445156102, 184.0941479094],
    [0.00000006355, 0.16346166674, 228.276948965],
    [0.00000007955, 4.03567630186, 183.2428146475],
    [0.00000005884, 4.40842406038, 19.1224551112],
    [0.00000005938, 5.40863870407, 17.5261078183],
    [0.00000005869, 5.39494525133, 95.3885263868],
    [0.00000005775, 2.81250784939, 121.8427223143],
    [0.0000000607, 4.23605170027, 119.5069163441],
    [0.00000006349, 3.52304701692, 285.6330134505],
    [0.0000000578, 0.17831551537, 458.8415197904],
    [0.00000005674, 4.16711163603, 89.7594520943],
    [0.00000005534, 4.24741728108, 75.5323580927],
    [0.00000005648, 2.81224199321, 154.979823106],
    [0.00000006939, 3.31979953743, 306.830642101],
    [0.00000005682, 4.79764449768, 248.7238180901],
    [0.00000006087, 4.04640130992, 271.4059194489],
    [0.00000006869, 1.34392408836, 7.8643065262],
    [0.00000005611, 5.32955957046, 920.8644333185],
    [0.00000006495, 0.45735814276, 106.2741679563],
    [0.00000005353, 2.49825965802, 24.1183899573],
    [0.00000006612, 5.24626646696, 58.319272332],
    [0.00000005552, 0.24515487696, 173.6815870919],
    [0.00000005209, 6.07866998675, 134.0640787458],
    [0.00000005176, 3.69984512887, 778.4147831847],
    [0.00000005949, 3.63204266272, 189.7232222019],
    [0.0000000636, 0.35370738262, 411.620337349],
    [0.00000005147, 1.55440402971, 193.655375465],
    [0.00000006436, 5.18759014405, 120.9913890524],
    [0.00000006994, 4.85978914075, 419.4846438752],
    [0.00000005323, 0.50787742639, 16.4623262353],
    [0.00000005085, 1.28917723765, 267.4737661858],
    [0.00000005993, 4.70505267412, 298.2326223919],
    [0.00000005507, 2.72405080404, 986.0848043302],
    [0.00000006163, 1.87793216012, 397.3932433474],
    [0.00000004846, 5.6671411571, 90.8232336773],
    [0.00000004875, 1.24385851949, 25.6028626656],
    [0.00000005374, 0.31175745933, 192.6921676185],
    [0.00000005262, 1.85699096844, 114.9416236346],
    [0.00000005373, 6.22242588334, 91.4563731237],
    [0.0000000505, 3.39322756907, 831.1049812242],
    [0.00000004637, 0.84958882655, 403.0223176399],
    [0.00000006382, 2.77560901069, 198.321241911],
    [0.00000004685, 4.94029403928, 902.7051860538],
    [0.00000005005, 1.40309022449, 6.1503391543],
    [0.00000005014, 5.57665259095, 451.9404211107],
    [0.0000000458, 2.47734499363, 31.2319369581],
    [0.00000005129, 3.2352870415, 109.3125493421],
    [0.00000004459, 6.22635092697, 207.8824694666],
    [0.00000005734, 0.96616252776, 483.2205421786],
    [0.00000004425, 2.74721673213, 823.9914342234],
    [0.00000004575, 1.87994871749, 44.7253177768],
    [0.00000004748, 0.34902594832, 457.8783119439],
    [0.00000004268, 4.89983575247, 124.5028511902],
    [0.00000004709, 5.28612293112, 449.2802922348],
    [0.00000005761, 2.09247769051, 187.6962327724],
    [0.00000004284, 0.66132439268, 210.3301500214],
    [0.00000004318, 1.68857333749, 309.2783226558],
    [0.00000004332, 1.41872733238, 25.1297819136],
    [0.00000004305, 1.05990546337, 606.7601855223],
    [0.00000004519, 5.84384426255, 905.8865797915],
    [0.00000003934, 0.417688973, 180.1619946463],
    [0.00000003973, 3.22666150606, 639.897286314],
    [0.00000004871, 4.61331971606, 258.0244132148],
    [0.00000004604, 4.77631056831, 463.5073862364],
    [0.00000003943, 3.31312639875, 107.4980082337],
    [0.00000004217, 0.73383451512, 497.4476361802],
    [0.00000004057, 1.67333716577, 7.4223635415],
    [0.00000003854, 6.13547145503, 34.2008823747],
    [0.00000004617, 5.89829880253, 303.8616966844],
    [0.00000005086, 2.8523551874, 28.3111756513],
    [0.00000005337, 2.36556705745, 477.8039162072],
    [0.00000004456, 1.74674336635, 95.9792272178],
    [0.00000004138, 3.80344455465, 460.5384408198],
    [0.00000003812, 2.48508006441, 25.2727942655],
    [0.00000004732, 0.87519409311, 255.0554677982],
    [0.00000003843, 4.02615028031, 104.0077979553],
    [0.00000003776, 2.89171052095, 27.0873353739],
    [0.00000004932, 0.36238909407, 123.5396433437],
    [0.00000004371, 3.74322467592, 376.1956146969],
    [0.00000003747, 3.04126115463, 142.1408335931],
    [0.00000004232, 4.31629167726, 446.3113468182],
    [0.00000003685, 3.26448469664, 170.7608257851],
    [0.00000003575, 4.31199276037, 572.2292347475],
    [0.00000003567, 4.08542270507, 433.7117378768],
    [0.00000004496, 2.10358455875, 838.218528225],
    [0.00000003505, 3.5390238439, 520.129737539],
    [0.00000003524, 3.75716903766, 473.068613792],
    [0.00000003962, 5.33706246667, 43.2890291783],
    [0.00000003597, 3.65066955203, 976.0023119128],
    [0.00000003487, 2.12239114397, 316.3918696566],
    [0.00000003475, 4.44351326599, 384.0599212231],
    [0.00000003628, 2.11511417759, 73.1852512744],
    [0.00000003702, 3.86923731076, 981.6313862053],
    [0.00000003687, 5.18698183343, 993.198351331],
    [0.00000003599, 2.07986409347, 47.6942631934],
    [0.00000003807, 4.21821126511, 196.6243208816],
    [0.00000004707, 4.56309173897, 47.061123747],
    [0.00000004312, 0.38740046308, 988.532484885],
    [0.00000003867, 2.08559458308, 457.3570470821],
    [0.00000004723, 4.16947683948, 219.891377577],
    [0.00000003527, 0.2037157647, 394.3548619616],
    [0.00000003644, 5.82023483708, 586.3133163972],
    [0.00000003328, 2.93840719007, 535.9107402181],
    [0.00000003321, 4.19289134366, 114.1384744825],
    [0.00000004128, 3.06165703109, 377.1588225434],
    [0.00000003545, 4.41886084391, 1293.8786542777],
    [0.00000003295, 2.97049569593, 15.1903018481],
    [0.00000003337, 6.23473900765, 9947.0556815321],
    [0.00000003253, 5.22412177835, 425.1137181677],
    [0.00000003677, 5.31389484415, 141.6988906084],
    [0.00000003242, 4.68868636498, 978.9712573294],
    [0.00000003266, 3.57072306171, 17.2654753874],
    [0.00000003435, 0.52794358986, 141.4864422873],
    [0.00000003242, 2.62760698007, 6.592282139],
    [0.00000003613, 1.94737668557, 661.0949149645],
    [0.00000003182, 0.3660331511, 449.4927405559],
    [0.00000003311, 1.25616383318, 233.9060232575],
    [0.00000003403, 6.0379258317, 199.2844497575],
    [0.00000004196, 4.26442082589, 381.6122406683],
    [0.00000003961, 4.53281422377, 916.9322800554],
    [0.00000003846, 3.76849990033, 8.5980197091],
    [0.0000000335, 5.63661413371, 444.8268741099],
    [0.0000000378, 5.35722293289, 328.2407190726],
    [0.00000003166, 2.16351748263, 983.1158589136],
    [0.00000003538, 1.89746744103, 280.9671470045],
    [0.0000000393, 2.09444900058, 653.9813679637],
    [0.00000003282, 1.91872815218, 2349.3284312038],
    [0.00000003269, 0.52855777633, 450.4559484024],
    [0.00000003582, 1.60170266832, 1587.5884225755],
    [0.00000003522, 2.5178203618, 237.6781178262],
    [0.00000003024, 3.54567524563, 94.4253185403],
    [0.00000003528, 4.79818282081, 406.954470903],
    [0.00000002996, 2.5915529362, 6133.5126528568],
    [0.00000003146, 2.18094827839, 216.9224321604],
    [0.0000000361, 6.15486273902, 171.6545976624],
    [0.00000002977, 0.6947862817, 294.3004691288],
    [0.00000003377, 1.21382647091, 162.8965192589],
    [0.00000003347, 4.14981703949, 214.7835681463],
    [0.00000002953, 2.18721777019, 597.3590166611],
    [0.00000004049, 3.15153850922, 833.552661779],
    [0.00000003725, 5.84743216544, 6058.7310542895],
    [0.0000000339, 1.18412112871, 167.7224443993],
    [0.00000003142, 2.26934209337, 517.1607921224],
    [0.00000004077, 0.07273073033, 1190.0351205337],
    [0.0000000302, 2.64998251178, 20.4468691251],
    [0.00000003926, 1.41612569694, 346.1875180162],
    [0.0000000311, 1.11431255827, 1044.4040766622],
    [0.00000002836, 0.62522723719, 749.2098356561],
    [0.00000002831, 4.78996738581, 820.0592809603],
    [0.00000002824, 0.87232289414, 30.7106720963],
    [0.00000003114, 1.79734939525, 414.0680179038],
    [0.00000002801, 3.99301180541, 10063.7223490764],
    [0.00000003489, 1.86982946081, 371.5297482509],
    [0.00000003725, 1.68366366742, 683.9894646444],
    [0.00000003763, 3.28247771799, 432.8179659995],
    [0.00000003493, 0.98765698465, 9988.9407505091],
    [0.00000003523, 5.12512607932, 105.380396079],
    [0.00000002839, 4.22662576295, 990.2294059144],
    [0.00000003432, 2.8048316223, 764.1876891831],
    [0.00000002733, 0.42373696972, 354.9979860464],
    [0.00000003146, 5.19208910201, 417.0369633204],
    [0.00000003041, 5.75641149588, 409.9234163196],
    [0.00000003379, 5.47448876584, 1396.2206689709],
    [0.00000003102, 0.4168444478, 521.0929453855],
    [0.00000002863, 0.41519700992, 894.8408795276],
    [0.00000002707, 3.60084311477, 621.7380390493],
    [0.00000003128, 5.23384180625, 424.1505103212],
    [0.00000003107, 2.44919355737, 4.665866446],
    [0.00000002683, 3.88682711832, 133.1008708993],
    [0.0000000266, 4.78670985324, 362.8622925726],
    [0.000000032, 1.88004939357, 331.2096644892],
    [0.0000000273, 4.12217979791, 600.5404103988],
    [0.00000003414, 4.93712749827, 1140.38330388],
    [0.00000002653, 5.10283251074, 118.0224436358],
    [0.00000003222, 4.76521772319, 294.6729761443],
    [0.00000003289, 4.26401031509, 544.5087599272],
    [0.000000031, 5.4792852793, 701.1855040626],
    [0.00000002785, 5.19343849039, 144.8973306886],
    [0.00000002607, 4.72531286187, 122.4758617607],
    [0.00000002581, 6.27329466695, 908.3342603463],
    [0.00000003285, 1.9597262267, 372.4235201282],
    [0.00000002897, 0.3737809018, 582.3811631341],
    [0.00000002615, 2.25516923974, 74.9940468884],
    [0.00000003582, 1.27992264402, 987.5692770385],
    [0.00000003115, 5.10929689813, 459.0539681115],
    [0.00000002857, 5.90256930211, 525.2375469697],
    [0.00000002589, 1.83177157032, 657.1627617014],
    [0.00000002539, 4.14968938109, 74.7334144575],
    [0.00000002797, 2.82242772664, 2036.8687148103],
    [0.00000002688, 2.16500211397, 262.8078997398],
    [0.00000002744, 1.54445470732, 28.5718080822],
    [0.00000002539, 0.46036497385, 74.8297826771],
    [0.00000003322, 3.50108539407, 82.6459050935],
    [0.0000000281, 6.06709915335, 374.4986936675],
    [0.00000002504, 3.523948017, 1183.6723330583],
    [0.00000002565, 1.64023845161, 73.4090004436],
    [0.00000002531, 3.50486296784, 293.188503436],
    [0.00000002663, 4.23321349902, 421.1815649046],
    [0.00000002793, 2.00644423849, 75.0422309982],
    [0.0000000243, 1.56119387576, 136.0698163159],
    [0.00000002553, 1.25909246207, 670.4960838257],
    [0.00000002604, 3.87350462519, 74.0308390419],
    [0.0000000251, 3.35948960782, 464.9918589447],
    [0.00000003005, 0.81031349171, 73.88782669],
    [0.0000000311, 6.14956891318, 118.8737768977],
    [0.00000003234, 2.45751141361, 98.3574718034],
    [0.00000002774, 6.26134027482, 1022.3126761344],
    [0.00000002402, 4.38353347008, 1303.2798231389],
    [0.00000003296, 3.84350963765, 511.5317178299],
    [0.000000028, 2.60339313269, 74.5209661364],
    [0.00000003005, 0.76247280223, 75.6753704446],
    [0.00000002434, 4.9478467943, 969.6224780949],
    [0.00000002632, 0.635571102, 227.5261894396],
    [0.00000002669, 0.7334022821, 73.0846775379],
    [0.00000002465, 1.3064877338, 77.0692204277],
    [0.00000003237, 3.19110274211, 1887.3055176757],
    [0.00000002395, 2.76580569447, 768.8535556291],
    [0.0000000323, 0.01981320255, 881.5075574033],
    [0.00000002747, 5.59085990261, 388.7257876691],
    [0.00000003008, 5.6595546366, 1969.2006632438],
    [0.00000003008, 0.91409756228, 2118.7638603784],
    [0.00000002465, 0.26629856014, 72.4939767069],
    [0.00000002629, 4.00618677646, 26.0235537909],
    [0.00000002272, 2.77069357315, 515.463871093],
    [0.0000000236, 4.12736987374, 74.6215398729],
    [0.00000002255, 3.3657444395, 286.596221297],
    [0.00000002211, 5.18239546182, 59.2824801785],
    [0.00000002994, 2.83179016989, 184.9879197867],
    [0.00000002492, 1.19872353228, 383.0967133766],
    [0.00000002355, 0.48259604722, 74.9416572617],
    [0.00000002185, 6.0799711998, 63.6240237188],
    [0.00000002228, 1.4245214891, 6219.339951688],
];

const VSOP87_R2: Vsop87Element = [
    [0.00022439904, 0.6995311876, 74.7815985673],
    [0.00004727037, 1.69901641488, 63.7358983034],
    [0.00001681903, 4.64833551727, 70.8494453042],
    [0.00001433755, 3.52119917947, 149.5631971346],
    [0.00001649559, 3.0966007898, 11.0457002639],
    [0.00000770188],
    [0.00000461009, 0.76676632849, 3.9321532631],
    [0.00000500429, 6.17229032223, 76.2660712756],
    [0.00000390371, 4.49605283502, 56.6223513026],
    [0.00000389945, 5.52673426377, 85.8272988312],
    [0.00000292097, 0.20389012095, 52.6901980395],
    [0.00000272898, 3.84707823651, 138.5174968707],
    [0.00000286579, 3.5335768327, 73.297125859],
    [0.00000205449, 3.24758017121, 78.7137518304],
    [0.00000219674, 1.96418942891, 131.4039498699],
    [0.00000215788, 0.84812474187, 77.962992305],
    [0.00000128834, 2.08146849515, 3.1813937377],
    [0.00000148554, 4.89840863841, 127.4717966068],
    [0.00000117452, 4.93414907433, 447.7958195265],
    [0.0000011269, 1.01361852218, 462.0229135281],
    [0.00000098875, 6.15817742611, 224.3447957019],
    [0.00000091379, 0.67973399531, 18.1592472647],
    [0.00000089217, 0.23425778826, 202.2533951741],
    [0.00000088206, 2.93094837724, 62.2514255951],
    [0.00000114066, 4.7874187396, 145.6310438715],
    [0.00000103858, 3.58561789629, 71.6002048296],
    [0.00000061819, 3.29964272893, 351.8165923087],
    [0.00000057782, 4.90737420887, 22.0914005278],
    [0.00000064369, 3.39006689398, 1.4844727083],
    [0.0000007111, 6.10490061068, 454.9093665273],
    [0.0000005099, 3.86691997779, 65.2203710117],
    [0.00000063537, 3.96202309168, 67.6680515665],
    [0.00000058957, 5.55530463687, 9.5612275556],
    [0.000000487, 3.74709235789, 269.9214467406],
    [0.00000043584, 1.92568752002, 59.8037450403],
    [0.0000004217, 2.61650997054, 151.0476698429],
    [0.0000004242, 6.13634453301, 284.1485407422],
    [0.0000004434, 5.89997845114, 71.8126531507],
    [0.00000037328, 5.91300114911, 984.6003316219],
    [0.00000036201, 5.40315761474, 77.7505439839],
    [0.00000041989, 2.09071623849, 12.5301729722],
    [0.00000031411, 4.59200004835, 148.0787244263],
    [0.00000031289, 2.26696307388, 195.1398481733],
    [0.0000002715, 3.53242984046, 209.3669421749],
    [0.00000028152, 4.57845964163, 77.2292791221],
    [0.00000026097, 0.65978256272, 120.358249606],
    [0.00000024372, 5.86680440531, 69.3649725959],
    [0.00000023037, 1.03776963677, 84.3428261229],
    [0.00000022679, 1.7143424397, 160.6088973985],
    [0.0000002765, 4.91488946525, 277.0349937414],
    [0.00000020816, 2.19643268155, 45.5766510387],
    [0.00000019961, 2.3207735618, 2.4476805548],
    [0.00000016584, 4.77529536873, 213.299095438],
    [0.00000016578, 1.85615182154, 340.7708920448],
    [0.00000017196, 4.36852462522, 54.1746707478],
    [0.00000016053, 3.64619586667, 152.7445908723],
    [0.00000014806, 5.43824503068, 408.4389436113],
    [0.00000013872, 3.38531100784, 358.9301393095],
    [0.00000013328, 5.25179190495, 137.0330241624],
    [0.00000013286, 1.26285812368, 134.5853436076],
    [0.0000001289, 3.03270380745, 92.940845832],
    [0.00000012467, 1.33213558369, 51.2057253312],
    [0.0000001345, 1.53176996919, 422.6660376129],
    [0.00000016442, 0.40190549188, 265.9892934775],
    [0.00000011996, 5.10426418352, 191.2076949102],
    [0.00000012898, 4.43242192513, 87.3117715395],
    [0.00000011449, 2.02645622099, 7.1135470008],
    [0.00000011826, 4.65645290272, 41.6444977756],
    [0.00000012045, 3.23910807852, 116.4260963429],
    [0.0000001168, 3.73278249629, 220.4126424388],
    [0.00000011573, 4.16500659139, 60.5545045657],
    [0.00000010175, 0.32936886913, 70.3281804424],
    [0.00000011332, 1.07613885149, 72.3339180125],
    [0.00000009655, 3.05950236129, 2.9689454166],
    [0.00000009279, 2.43997351068, 565.1156877467],
    [0.00000008986, 5.18839740735, 225.8292684102],
    [0.00000010284, 1.1860258206, 344.7030453079],
    [0.00000008844, 6.00894470528, 5.4166259714],
    [0.00000008508, 5.24741470216, 347.8844390456],
    [0.00000008319, 3.71723808749, 14.977853527],
    [0.00000008276, 2.27408171672, 299.1263942692],
    [0.00000008064, 5.71681525179, 55.1378785943],
    [0.0000000783, 0.90313686798, 222.8603229936],
    [0.00000008335, 4.48600419464, 70.1157321213],
    [0.00000008763, 5.8151944012, 153.4953503977],
    [0.00000008472, 3.91387041805, 333.657345044],
    [0.00000009874, 5.9652614366, 35.1640902212],
    [0.00000009647, 0.38872626737, 415.5524906121],
    [0.00000007106, 1.5059848847, 991.7138786227],
    [0.00000006596, 1.18068235818, 96.8729990951],
    [0.00000008065, 2.25930653257, 206.1855484372],
    [0.00000006479, 2.99461362786, 380.12776796],
    [0.00000009012, 6.0534362253, 146.3818033969],
    [0.00000006131, 0.05596259493, 99.1606209555],
    [0.00000005799, 0.82465326137, 142.4496501338],
    [0.00000005816, 4.63029217647, 49.5088043018],
    [0.00000005608, 0.66268449799, 58.1068240109],
    [0.00000005966, 2.48916255408, 373.0142209592],
    [0.0000000571, 2.23566160404, 80.1982245387],
    [0.00000005272, 5.06746739956, 440.6822725257],
    [0.00000005162, 4.36457872885, 977.4867846211],
    [0.00000005428, 0.85181859845, 546.956440482],
    [0.00000005766, 0.34229025692, 536.8045120954],
    [0.00000005924, 5.48443563529, 76.4785195967],
    [0.0000000534, 3.730731164, 23.5758732361],
    [0.00000005174, 4.13873402677, 132.8884225782],
    [0.0000000531, 6.14059082194, 39.6175083461],
    [0.0000000579, 3.39593613152, 458.090760265],
    [0.00000005007, 4.25821412289, 522.5774180938],
    [0.00000004967, 4.79184817938, 387.2413149608],
    [0.00000005183, 3.25775152471, 561.1835344836],
    [0.00000004602, 1.69262282455, 152.5321425512],
    [0.00000005302, 1.83522660093, 124.2904028691],
    [0.00000005005, 0.3663056595, 60.7669528868],
    [0.00000004454, 2.30288945184, 312.4597163935],
    [0.00000004457, 0.45775730382, 33.1371007917],
    [0.00000005722, 0.89523844278, 81.8951455681],
    [0.00000005842, 0.92039543147, 20.6069278195],
    [0.00000005743, 0.66226484448, 38.1330356378],
    [0.00000004255, 3.55373860346, 479.2883889155],
    [0.0000000419, 4.37674804409, 79.2350166922],
    [0.00000004194, 1.6498626717, 128.9562693151],
    [0.00000005125, 1.40553011416, 144.1465711632],
    [0.00000004045, 6.07362424798, 19.643719973],
    [0.00000003984, 5.7717840641, 288.0806940053],
    [0.00000005017, 2.99521887648, 29.2049475286],
    [0.00000003842, 2.60024827897, 426.598190876],
    [0.00000003861, 3.19886211335, 159.1244246902],
    [0.0000000387, 4.43713601497, 141.6988906084],
    [0.00000005316, 4.07970979457, 111.4301614968],
    [0.00000004553, 0.01384318412, 298.2326223919],
    [0.00000003737, 5.28319518103, 353.301065017],
    [0.00000003939, 5.27301148162, 521.0929453855],
    [0.0000000371, 5.15385470848, 490.3340891794],
    [0.00000004039, 0.60924359087, 152.0108776894],
    [0.00000003861, 1.343943837, 535.3200393871],
    [0.00000004385, 0.620576801, 827.1728279611],
    [0.00000003567, 4.71986443303, 6.9010986797],
    [0.00000003576, 3.24526237368, 230.5645708254],
    [0.00000003469, 0.79054323335, 983.1158589136],
    [0.00000004524, 2.86819565712, 129.9194771616],
    [0.00000003648, 5.59395544992, 774.4826299216],
    [0.00000003513, 4.49630054276, 376.1956146969],
    [0.00000003432, 2.55614913808, 258.8757464767],
    [0.00000004352, 2.09804374929, 404.5067903482],
    [0.00000003336, 0.89628904042, 469.1364605289],
    [0.00000003274, 3.86236880159, 42.5382696529],
    [0.00000003201, 2.76459652868, 248.7238180901],
    [0.00000003184, 0.07709843451, 1514.2912967165],
    [0.00000003783, 5.29835962126, 369.0820676961],
    [0.00000003266, 2.24754480216, 73.8183907208],
    [0.00000003055, 2.60120354415, 433.7117378768],
    [0.00000003051, 4.54953369151, 980.6681783588],
    [0.00000003062, 1.27089879603, 200.7689224658],
    [0.00000003055, 1.70878161343, 639.897286314],
    [0.0000000311, 3.63187411723, 16.6747745564],
    [0.00000003472, 4.93521260607, 411.620337349],
    [0.00000003531, 4.49372794858, 881.5075574033],
    [0.00000003284, 5.59170577331, 472.1748419147],
    [0.00000003015, 6.02967446446, 291.262087743],
    [0.00000003467, 2.17484439267, 554.0699874828],
    [0.00000003138, 0.52367930477, 1094.8066528413],
    [0.00000003257, 2.49339546514, 451.7279727896],
    [0.00000002881, 0.50481204892, 305.3461693927],
    [0.00000003082, 4.20145474081, 146.594251718],
    [0.00000002883, 2.44983947531, 135.336103133],
    [0.00000002965, 0.3929499553, 25.2727942655],
    [0.00000002831, 2.52728803131, 867.2804634017],
    [0.00000002728, 5.29491477549, 125.9873238985],
    [0.00000002857, 4.71106805785, 218.9281697305],
    [0.00000002763, 4.27510031656, 350.3321196004],
    [0.0000000273, 1.98552777251, 82.8583534146],
    [0.00000002857, 3.08706426922, 216.4804891757],
    [0.00000003365, 3.67691210011, 661.0949149645],
    [0.00000002925, 1.43646759644, 381.6122406683],
    [0.00000002753, 0.39468041761, 33.6796175129],
    [0.00000002756, 4.6267249884, 1357.6145525811],
    [0.0000000345, 2.12911756067, 685.4739373527],
    [0.00000002571, 5.92862393284, 89.7594520943],
    [0.00000002677, 0.76342313946, 486.4019359163],
    [0.00000002689, 4.16436463826, 235.3904959658],
    [0.00000002646, 3.81808560938, 550.8885937451],
    [0.00000003369, 3.17071565345, 108.4612160802],
    [0.00000002613, 5.68333838067, 24.3790223882],
    [0.00000002736, 1.87107584495, 529.6909650946],
    [0.00000002606, 4.36605237304, 1080.5795588397],
    [0.00000002407, 3.07343136742, 391.1734682239],
    [0.00000002446, 5.7384638154, 535.9107402181],
    [0.00000002334, 5.18878243102, 1059.3819301892],
    [0.00000002568, 1.09886876369, 913.0001267923],
    [0.00000002236, 6.10115874045, 140.001969579],
    [0.00000003053, 5.35047433775, 681.5417840896],
];

const VSOP87_R3: Vsop87Element = [
    [0.00001164382, 4.73453291602, 74.7815985673],
    [0.00000212367, 3.34255734999, 63.7358983034],
    [0.00000196408, 2.98004616318, 70.8494453042],
    [0.00000104527, 0.95807937648, 11.0457002639],
    [0.00000071681, 0.02528455665, 56.6223513026],
    [0.0000007254, 0.99701907912, 149.5631971346],
    [0.00000054875, 2.59436811267, 3.9321532631],
    [0.00000034029, 3.81553325635, 76.2660712756],
    [0.00000032081, 3.5982517784, 131.4039498699],
    [0.00000029641, 3.44111535957, 85.8272988312],
    [0.00000036377, 5.65035573017, 77.962992305],
    [0.00000027663, 0.4283600147, 3.1813937377],
    [0.00000027464, 2.55126467481, 52.6901980395],
    [0.00000024569, 5.14034173566, 78.7137518304],
    [0.0000001939, 5.13477648625, 18.1592472647],
    [0.00000015767, 0.37116951743, 447.7958195265],
    [0.00000015441, 5.57271837433, 462.0229135281],
    [0.00000015232, 3.85998573509, 73.297125859],
    [0.00000015475, 2.97496547327, 145.6310438715],
    [0.00000017951],
    [0.00000015958, 5.19915553904, 71.6002048296],
    [0.00000011056, 6.03152659562, 138.5174968707],
    [0.00000010529, 3.58261852497, 224.3447957019],
    [0.00000007606, 1.44542030704, 1.4844727083],
    [0.00000008121, 2.61579604319, 22.0914005278],
    [0.00000007107, 5.43946774526, 269.9214467406],
    [0.00000006459, 4.37142319461, 284.1485407422],
    [0.00000006818, 0.01396812984, 151.0476698429],
    [0.00000008101, 0.29563819537, 127.4717966068],
    [0.00000005768, 4.22672716593, 373.0142209592],
    [0.00000005022, 1.84154937974, 202.2533951741],
    [0.00000004692, 2.7840457544, 120.358249606],
    [0.00000005087, 0.77745294804, 62.2514255951],
    [0.0000000416, 1.83820502779, 72.3339180125],
    [0.00000003922, 1.88900691473, 209.3669421749],
    [0.00000005201, 4.15791319343, 195.1398481733],
    [0.00000003636, 1.99709010456, 65.2203710117],
    [0.00000003582, 3.92592140377, 124.2904028691],
    [0.00000003808, 1.04818660873, 92.940845832],
    [0.00000004241, 3.95755998904, 9.5612275556],
    [0.00000003497, 1.54139696251, 148.0787244263],
    [0.00000003195, 2.98608971329, 387.2413149608],
    [0.0000000395, 1.85721204932, 152.7445908723],
    [0.00000003277, 1.40881404192, 351.8165923087],
    [0.00000003605, 1.17366167402, 153.4953503977],
    [0.0000000294, 6.03594958459, 12.5301729722],
    [0.00000002744, 5.64674283515, 134.5853436076],
    [0.000000028, 0.79480255927, 572.2292347475],
    [0.00000003054, 5.84310939105, 160.6088973985],
    [0.00000002662, 1.98593312104, 450.9772132642],
    [0.000000027, 2.77036653988, 213.299095438],
    [0.00000002323, 1.67918985468, 358.9301393095],
    [0.00000002254, 5.77129530133, 84.3428261229],
    [0.00000002291, 4.814246016, 536.8045120954],
    [0.00000002213, 2.20360299816, 465.9550667912],
];

const VSOP87_R4: Vsop87Element = [
    [0.00000052996, 3.00838033088, 74.7815985673],
    [0.00000009887, 1.91399083603, 56.6223513026],
    [0.00000007008, 5.08677527404, 11.0457002639],
    [0.00000006728, 5.42924958121, 149.5631971346],
    [0.00000003703, 5.22728581851, 131.4039498699],
    [0.00000003361, 1.29695290266, 85.8272988312],
    [0.00000002664, 0.44064577837, 63.7358983034],
    [0.00000002309, 0.92380720934, 145.6310438715],
    [0.00000002383, 6.21390585593, 358.9301393095],
    [0.00000002288, 2.23425399117, 440.6822725257],
    [0.00000003093, Math.PI],
];

const VSOP87_R5: Vsop87Element = [[Math.LN2]];

export const VSOP87_X: Vsop87Group = [VSOP87_L0, VSOP87_L1, VSOP87_L2, VSOP87_L3, VSOP87_L4, VSOP87_L5];

export const VSOP87_Y: Vsop87Group = [VSOP87_B0, VSOP87_B1, VSOP87_B2, VSOP87_B3, VSOP87_B4, VSOP87_B5];

export const VSOP87_Z: Vsop87Group = [VSOP87_R0, VSOP87_R1, VSOP87_R2, VSOP87_R3, VSOP87_R4, VSOP87_R5];
